//辅助类，包含了全局方法

var SynUtil = new _SynUtil()

function _SynUtil(){
    this.makeHtml = function(fn, valueList){
        var tpl = fn.toString()
        if(valueList)
            tpl = tpl.replace(/{placeholder_\d}/g, function(holder){
                var value = ""
                var index = parseInt(holder.split("_")[1])
                if(valueList[index]){
                    value = valueList[index]
                }
                return value
            })
        return tpl.split('\n').slice(1, -1).join('\n') + '\n'
    }

    this.showTopMessage = function(msg){
        var msgPanel = $(this.makeHtml(function(){/*
         <div style="position: fixed; z-index: 9999; left: 0; top: 0; width: 100%; text-align: center; padding-top: 10px; display: none; pointer-events:none;">
         <div class="ui message" style="display: inline-block;">
         {placeholder_0}
         </div>
         </div>
         */}, [msg]))

        var msgType = "info"
        var time = 3000
        for (var i in arguments){
            if(i > 0){
                var arg = arguments[i]
                if(typeof arg === "string")
                    msgType = arg
                else if(typeof arg === "number")
                    time = arg * 1000
            }
        }
        msgPanel.find(".ui.message").addClass(msgType)
        msgPanel.appendTo($("body")).transition('fade down')
        setTimeout(function(){
            msgPanel.transition('fade down', function(){
                $(this).remove()
            })
        }, time)
    }

    this.buildUrl = function(url, params){
        if(params){
            for(var key in params){
                if(url.indexOf("?") > 0)
                    url += "&" + key + "=" + params[key]
                else
                    url += "?" + key + "=" + params[key]
            }
        }
        return url
    }
}

//全局事件
$(function(){

    /*显示全局消息 start ----------------------------------------------------------------------------- */
    SynEvent.on("ShowGlobalMessage", function(params){
        if(window.parent != window)
            SynEvent.topTrigger("ShowGlobalMessage", params)
        else
            SynUtil.showTopMessage(params.msg, params.type, params.time)
    })
    /*显示全局消息 end ----------------------------------------------------------------------------- */


    /*显示遮罩 start ----------------------------------------------------------------------------- */
    $(document).on("ShowModalBackground", function(){
        $("<div id='modal-background'></div>").appendTo($("body"))
    })

    $(document).on("HideModalBackground", function(){
        $("#modal-background").remove()
    })
    /*显示遮罩 start ----------------------------------------------------------------------------- */


    /* 弹出窗口相关 start ----------------------------------------------------------------------------- */
    $(document).on("OpenDialogFrame", function(event, param){
        var url = createUrlFromParam(param)
        createDialogFrame("dialog-frame" ,url)
    })

    $(document).on("CloseDialogFrame", function(event, param){
        $("#dialog-frame").remove()
    })

    $(document).on("OpenAlertDialogFrame", function(event, param){
        var url = createUrlFromParam(param)
        createDialogFrame("alert-dialog-frame", url)
    })

    $(document).on("CloseAlertDialogFrame", function(event, param){
        $("#alert-dialog-frame").remove()
    })

    function createUrlFromParam(param){
        var url = param.url
        for(var key in param){
            if(key != "url"){
                if(typeof param[key] != "object")
                    url = makeUrl(url, key, param[key])
                else
                    for(var key2 in param[key]){
                        url = makeUrl(url, key2, param[key][key2])
                    }
            }
        }
        return url
    }

    function makeUrl(url, key, value){
        if(url.indexOf("?") > 0)
            url += "&" + key + "=" + value
        else
            url += "?" + key + "=" + value
        return url
    }

    function createDialogFrame(id ,url){
        //显示加载状态
        var iframe = document.createElement("iframe");
        var frame = $(iframe)
        frame.load(function(){
            //取消加载状态
        })
        frame.attr("id", id)
        frame.attr("allowTransparency","true")
        frame.css("position", "fixed")
        frame.css("width", "100%")
        frame.css("height", "100%")
        frame.css("top", "0")
        frame.css("left", "0")
        frame.css("border", "none")
        frame.appendTo("body")
        frame.attr("src", url)
    }
    /* 弹出窗口相关 end ----------------------------------------------------------------------------- */

})

$(function(){

    //让iframe（包括子iframe)内的click事件透到最外层
    $(document).click(function(){
        if(window.parent != window){
            // top.$(top.document).trigger("CloseMenu")
            // top.$(top.document).trigger("ClosePopMenu")
            parent.$(parent.document).trigger("click")
        }
    })

})


var SynEvent = new _SynEvent()

function _SynEvent(){
    /*
    eventType: 事件类型
    params:
        event: 事件对象
        source: 事件源
        ...: 其他参数
    */
    this.trigger = function(){
        //arguments[0]: eventType
        //arguments[1]: params
        if(arguments.length > 1)
            $(document).trigger(arguments[0], arguments[1])
        else
            $(document).trigger(arguments[0])
    }
    this.on = function(eventType, listener){
        $(document).on(eventType, function(event, params){
            if(params)
                params.event = event
            listener(params)
        })
    }
    this.parentTrigger = function(){
        if(arguments.length > 1)
            parent.$(parent.document).trigger(arguments[0], arguments[1])
        else
            parent.$(parent.document).trigger(arguments[0])
    }
    this.parentOn = function(eventType, listener){
        parent.$(parent.document).on(eventType, function(event, params){
            if(params)
                params.event = event
            listener(params)
        })
    }
    this.topTrigger = function(eventType, param){
        if(arguments.length > 1)
            top.$(top.document).trigger(arguments[0], arguments[1])
        else
            top.$(top.document).trigger(arguments[0])
    }
    this.openerTrigger = function(eventType, param){
        if(arguments.length > 1)
            window.opener.$(window.opener.document).trigger(arguments[0], arguments[1])
        else
            window.opener.$(window.opener.document).trigger(arguments[0])
    }
}
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var SynworkCore = (function () {
            function SynworkCore(syn) {
                this.syn = syn;
                this.modules = {};
                this.configFnList = [];
            }
            SynworkCore.prototype.initModule = function () {
                var _this = this;
                var angularModule = angular.module;
                angular.module = function (name, requires, configFn) {
                    _this.modules[name] = name;
                    return angularModule(name, requires, configFn);
                };
                var modules = ['ng', 'oc.lazyLoad', 'as.sortable', 'angularResizable', 'ngFileUpload', 'infinite-scroll'];
                if (window['ngMaterial']) {
                    modules = modules.concat(['ngMaterial']);
                    $("<link rel=\"stylesheet\" href=\"http://lib.95work.com/version/dev/share/css/material-icons.css\">").appendTo($(document.head));
                }
                this.synModule = angular.module("synwork", modules);
                this.synModule.provider("crossStorage", framework.service.CrossStorageProvider)
                    .service("app", function () { return _this.syn.app; })
                    .service("rpc", function () { return _this.syn.rpc; })
                    .service('syn', function () { return _this.syn; })
                    .service("rest", function () { return _this.syn.rest; })
                    .service("message", function () { return _this.syn.message; })
                    .service("dialog", function () { return _this.syn.dlg; })
                    .service("htmlExporter", function () { return _this.syn.htmlExporter; })
                    .service("dataAggregate", function () { return _this.syn.dataAggregate; })
                    .service("busy", function () { return _this.syn.busy; })
                    .directive("autoGrow", framework.directive.autoGrowFactory)
                    .directive("dateFormatter", framework.directive.dateFormaterFactory)
                    .directive("dateInput", framework.directive.dateInputFactory)
                    .directive("synDatePicker", framework.directive.datePickerFactory)
                    .directive("synTimePicker", framework.directive.timePickerFactory)
                    .directive("checkboxList", framework.directive.checkboxListFactory)
                    .directive("radioList", framework.directive.radioListFactory)
                    .directive("loading", framework.directive.loadingFactory)
                    .directive("inputHint", framework.directive.inputHintFactory)
                    .directive("repeatFinish", framework.directive.repeatFinishFactory)
                    .directive("includePage", framework.directive.synComponentFactoryOld)
                    .directive("synComponent", framework.directive.synComponentFactory)
                    .directive("smDropdown", framework.directive.semantic.smDropdownFactory)
                    .directive("smPopup", framework.directive.semantic.smPopupFactory)
                    .directive("smCheckbox", framework.directive.semantic.smCheckboxFactory)
                    .directive("smIcon", framework.directive.semantic.smIconFactory)
                    .directive("smTab", framework.directive.semantic.smTabFactory)
                    .directive("frameLink", framework.directive.frameLinkFactory)
                    .directive("elementInit", framework.directive.elementInitFactory)
                    .directive("videoUpload", framework.directive.videoUploadFactory)
                    .directive("portlet", framework.directive.portletFactory);
                framework.directive.validator.init(this.synModule);
                framework.directive.scrollFixTable.init(this.synModule);
                framework.directive.nav.init(this.synModule);
                framework.directive.pageview.init(this.synModule);
                framework.directive.override.init(this.synModule);
                framework.directive.page.init(this.synModule);
                framework.component.dataGrid.init(this.synModule);
                framework.component.tree.init(this.synModule);
                framework.component.treeItem.init(this.synModule);
            };
            SynworkCore.prototype.initStyle = function (style) {
                $("<style type=\"text/css\" id=\"synwork.css\"> " + style + " </style>").appendTo("head");
            };
            SynworkCore.prototype.init = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                document.body.setAttribute('ng-jq', '');
                                this.initModule();
                                return [4, this.initAppModule()];
                            case 1:
                                _a.sent();
                                this.bootApp();
                                $(function () {
                                    window['require'].config({
                                        baseUrl: "http://lib.95work.com",
                                        paths: {
                                            syn: "version/" + _this.syn.app.version + "/syn"
                                        },
                                        waitSeconds: 0
                                    });
                                    framework.syn.component.loadPage();
                                });
                                return [2];
                        }
                    });
                });
            };
            SynworkCore.prototype.registerComponent2 = function (cfg) {
                var name = cfg.name;
                if (this.compileProvider) {
                    this.compileProvider.component(name, cfg);
                }
                else {
                    this.module.component(name, cfg);
                }
            };
            SynworkCore.prototype.initAppModule = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var depends, key, cfg;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, this.syn.app.init()];
                            case 1:
                                _a.sent();
                                if (this.syn.app.userExceeded > 0) {
                                    $('body').empty().append(" < div class = \"ui active dimmer\" >  < div class = \"content\" >  < h2 class = \"ui inverted icon header\" >  < i class = \"info circle icon\" ></i > \n                                    \u5F53\u524D\u767B\u5F55\u7528\u6237\u6570\u5DF2\u8D85\u8FC7" + this.syn.app.userExceeded + "\u4E2A, \u8BF7\u7A0D\u540E\u518D\u4F7F\u7528\uFF01 </h2 >  < div >  < button class = \"ui large primary button logout\" > \n                                    \u6CE8\u9500 </button >  </div >  </div >  </div > \n                ");
                                    $('.logout').click(function () {
                                        _this.syn.rpc.promiseService("Login").call('logout').then(function (url) {
                                            window.location.href = url;
                                        });
                                    });
                                }
                                depends = ['ngMessages', 'synwork'];
                                for (key in this.modules) {
                                    if (key.indexOf("ui.grid") == 0) {
                                        depends.push(key);
                                    }
                                }
                                this.module = angular.module('app', depends);
                                this.syn.module = this.module;
                                this.module.filter('escape', function ($sce) {
                                    return function (input) {
                                        if (!input) {
                                            return '';
                                        }
                                        return input.replace(/<\/?[^>]*>/g, '');
                                    };
                                });
                                cfg = [
                                    '$httpProvider', '$controllerProvider',
                                    '$sceProvider', '$compileProvider', '$provide', '$locationProvider'
                                ];
                                if (window['ngMaterial']) {
                                    cfg.push('$mdThemingProvider');
                                    cfg.push('$mdAriaProvider');
                                    cfg.push('$mdInkRippleProvider');
                                    cfg.push('$mdGestureProvider');
                                }
                                cfg.push(function ($httpProvider, $controllerProvider, $sceProvider, $compileProvider, $provide, $locationProvider, $mdThemingProvider, $mdAriaProvider, $mdInkRippleProvider, $mdGestureProvider) {
                                    _this.controllerProvider = $controllerProvider;
                                    _this.compileProvider = $compileProvider;
                                    if (_this.compileProvider.commentDirectivesEnabled) {
                                        _this.compileProvider.commentDirectivesEnabled(false);
                                    }
                                    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
                                    $httpProvider.interceptors.push(framework.service.httpInterceptorFactory(_this.syn));
                                    $sceProvider.enabled(false);
                                    _this.syn.ng.compileProvider = _this.compileProvider;
                                    _this.syn.ng.locationProvider = $locationProvider;
                                    _this.syn.ng.controllerProvider = $controllerProvider;
                                    _this.syn.ng.provide = $provide;
                                    if ($mdAriaProvider) {
                                        $mdAriaProvider.disableWarnings();
                                    }
                                    if ($mdInkRippleProvider) {
                                        $mdInkRippleProvider.disableInkRipple();
                                    }
                                    if ($mdGestureProvider) {
                                        $mdGestureProvider.disableAll();
                                    }
                                });
                                this.module.config(cfg);
                                this.module.run(['$injector', '$q', '$rootScope', function ($injector, $q, $rootScope) {
                                        if (_this.syn.isAngular1_5) {
                                            Rx.config = Rx.config || {};
                                            Rx.config.Promise = $q;
                                        }
                                        _this.syn.ng.init($injector);
                                        $rootScope.syn = _this.syn;
                                        _this.configFnList.forEach(function (fn) {
                                            fn();
                                        });
                                        _this.initTheme();
                                    }]);
                                return [2];
                        }
                    });
                });
            };
            SynworkCore.prototype.initTheme = function () {
                synwork.theme.init();
            };
            SynworkCore.prototype.configModule = function (fn) {
                if (this.controllerProvider) {
                    fn();
                }
                else {
                    this.configFnList.push(fn);
                }
            };
            SynworkCore.prototype.bootApp = function () {
                angular.bootstrap(document, ['app']);
            };
            SynworkCore.prototype.boot = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.initStyle(framework.synworkStyle());
                                return [4, this.init()];
                            case 1:
                                _a.sent();
                                return [2];
                        }
                    });
                });
            };
            return SynworkCore;
        }());
        framework.SynworkCore = SynworkCore;
        var Page = (function () {
            function Page(id, syn) {
                this.id = id;
                this.syn = syn;
            }
            Object.defineProperty(Page.prototype, "promiseRpc", {
                get: function () {
                    if (!this._rpc2) {
                        var refId = this.id.toString();
                        if (isNaN(Number(refId))) {
                            refId = "#" + refId;
                        }
                        this._rpc2 = this.syn.rpc.$(refId, {});
                    }
                    return this._rpc2;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Page.prototype, "rpc", {
                get: function () {
                    if (!this._rpc) {
                        var refId = this.id.toString();
                        if (isNaN(Number(refId))) {
                            refId = "#" + refId;
                        }
                        this._rpc = this.syn.rpc.service(refId);
                    }
                    return this._rpc;
                },
                enumerable: true,
                configurable: true
            });
            Page.prototype.call = function (method) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                return this.promiseRpc.call.apply(this.promiseRpc, [method].concat(args));
            };
            Object.defineProperty(Page.prototype, "batch", {
                get: function () {
                    return this.promiseRpc.batch;
                },
                enumerable: true,
                configurable: true
            });
            Page.prototype.busyCall = function (method) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                return this.promiseRpc.busyCall.apply(this.promiseRpc, [method].concat(args));
            };
            Page.prototype.useMsgPack = function () {
                this.promiseRpc['useMsgPack']();
            };
            Page.prototype.style = function () {
                return $("style#page-" + this.id + "\\.css").text();
            };
            return Page;
        }());
        framework.Page = Page;
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        function synworkStyle() {
            return ".ui2.item{color:#f00;border:1px solid #f00}div[syn-nav-view] > *{position:absolute;width:100%;height:100%}.ui.dimmer.modals.page{z-index:1100}iframe.iframe-full-screen{position:fixed !important;border:none !important;z-index:2000 !important;left:0 !important;top:0 !important;width:100% !important;height:100% !important;margin:0 !important;padding:0 !important}.ui.active.busy.dimmer{pointer-events:none}.ui.dimmer.modal-page.active{user-select:text !important;text-align:inherit !important;z-index:1000;}.ui.dimmer.modal-page.active > .syn-include,.ui.dimmer.modal-page.active > .modal-page{position:absolute;top:0;left:0;width:100%;height:100%;}.ui.dimmer.modal-page.active > .syn-include > div,.ui.dimmer.modal-page.active > .modal-page > div{position:absolute;top:1rem;left:1rem;right:1rem;bottom:1rem;height:auto !important;background:#fff;}.max-size.ui.dimmer.modal-page.active > .syn-include > div,.max-size.ui.dimmer.modal-page.active > .modal-page > div{top:0;left:0;right:0;bottom:0}.modals.dimmer .ui.modal.fullscreen-max.scrolling{margin:0 !important}.dimmable.dimmed.scrolling{height:100% !important}.ui.dimmer.modals.page{height:100% !important}.ui.modal.fullscreen-max{width:100% !important;flex:1 !important;height:100% !important;display:flex !important;flex-direction:column !important;margin:0 !important;overflow:hidden !important;}.ui.modal.fullscreen-max.hidden{display:none !important}.ui.modal.fullscreen-max >.content{flex:1 !important;height:0 !important;max-height:unset !important;min-height:unset !important;}.ui.modal.fullscreen-max >.content >div{width:100%;height:100%}.ui.active.busy.dimmer{z-index:2000}.ui-grid-top-panel{background:#f7f7f7}.ui-grid-row.ui-grid-row-selected > [ui-grid-row] > .ui-grid-cell{background-color:#cce8ff}syn-data-grid{position:relative;display:block;border:1px solid #d3d3d3;}syn-data-grid .sgrid-ct{display:flex;flex-direction:column;position:absolute;left:0;top:0;width:100%;height:100%;overflow:hidden}syn-data-grid .sgrid-head-pad,syn-data-grid .sgrid-row-pad{width:14px}syn-data-grid .sgrid-row-pad >div{border-bottom:1px solid #d3d3d3}syn-data-grid .sgrid-vscroll-bar::-webkit-scrollbar,syn-data-grid .sgrid-hscroll-bar::-webkit-scrollbar{width:14px !important;border-radius:0 !important;height:14px !important}syn-data-grid .sgrid-vscroll-bar::-webkit-scrollbar-thumb,syn-data-grid .sgrid-hscroll-bar::-webkit-scrollbar-thumb{border-radius:0 !important;background:#e1e1e1 !important}syn-data-grid .sgrid-vscroll-bar::-webkit-scrollbar-track,syn-data-grid .sgrid-hscroll-bar::-webkit-scrollbar-track{background:#f1f1f1 !important}syn-data-grid .sgrid-vscroll-bar{width:14px;position:absolute;right:0;top:0;bottom:0;display:none;overflow-y:auto;overflow-x:hidden;}syn-data-grid .sgrid-vscroll-bar >div{width:1px}syn-data-grid .sgrid-hscroll-bar{height:14px;display:none;overflow-x:auto;overflow-y:hidden;margin-right:14px;}syn-data-grid .sgrid-hscroll-bar >div{height:1px}syn-data-grid .sgrid-head-ct{display:flex;flex-direction:row;border-bottom:1px solid #d3d3d3;background:#fbfbfb}syn-data-grid .sgrid-heads{display:flex;flex-direction:row;}syn-data-grid .sgrid-heads.center{flex:1;overflow-x:hidden}syn-data-grid .sgrid-heads.right{border-left:1px solid #d3d3d3}syn-data-grid syn-grid-head{display:flex;flex-direction:column;justify-content:center;}syn-data-grid syn-grid-head.field{flex-direction:row}syn-data-grid syn-grid-head .sgrid-head-cell{flex:1;padding:.3em .5em;text-align:center;border-right:1px solid #d3d3d3;overflow:hidden;display:flex;align-items:center;justify-content:center;}syn-data-grid syn-grid-head .sgrid-head-cell >div.title{flex:1;display:flex;align-items:center;justify-content:center;}syn-data-grid syn-grid-head .sgrid-head-cell >div.title.sortable{cursor:pointer;}syn-data-grid syn-grid-head .sgrid-head-cell >div.title.sortable:hover{color:#008000;text-decoration:underline}syn-data-grid syn-grid-head .sgrid-head-cell >div.title.asc:after{font-family:Icons;content:\"\\f0d8\";margin:0 4px}syn-data-grid syn-grid-head .sgrid-head-cell >div.title.desc:after{font-family:Icons;content:\"\\f0d7\";margin:0 4px}syn-data-grid syn-grid-head .sgrid-head-cell.align-left >div.title{justify-content:flex-start}syn-data-grid syn-grid-head .sgrid-head-cell.align-right >div.title{justify-content:flex-end}syn-data-grid syn-grid-head .sgrid-head-cell.align-center >div.title{justify-content:center}syn-data-grid syn-grid-head .sgrid-head-cell.checkbox >div{display:flex;flex-direction:column;align-items:center;}syn-data-grid syn-grid-head .sgrid-head-cell.checkbox >div .ui.checkbox{width:18px}syn-data-grid syn-grid-head .sgrid-columns{display:flex;flex-direction:row;border-top:1px solid #d3d3d3}syn-data-grid syn-grid-row{display:flex;flex-direction:row;border-bottom:1px solid #d3d3d3;}syn-data-grid syn-grid-row.selected{background:#c1daf0}syn-data-grid .sgrid-row-ct{position:relative;display:flex;flex-direction:row;flex:1;align-items:flex-start;overflow:hidden}syn-data-grid .center.sgrid-rows{overflow:hidden;display:flex;flex:1}syn-data-grid syn-grid-row-cell{display:flex;align-items:center;padding:.3em .5em;border-right:1px solid #d3d3d3;overflow:hidden;white-space:nowrap;flex:none;}syn-data-grid syn-grid-row-cell.edit{padding:0;align-items:stretch}syn-data-grid syn-grid-row-cell >div{overflow:hidden;flex:1;text-overflow:ellipsis}syn-data-grid syn-grid-row-cell.align-left{text-align:left}syn-data-grid syn-grid-row-cell.align-right{text-align:right}syn-data-grid syn-grid-row-cell.align-center{text-align:center}syn-data-grid syn-grid-row-cell.checkbox >div{display:flex;flex-direction:column;align-items:center;}syn-data-grid syn-grid-row-cell.checkbox >div .ui.checkbox{width:18px}syn-data-grid syn-grid-row-cell .sgrid-cell-editor{flex:1;}syn-data-grid syn-grid-row-cell .sgrid-cell-editor input{width:100%;height:100%;padding:.3em .5em;border:1px solid #1979ca;outline:none}syn-data-grid syn-grid-row-cell .sgrid-cell-editor select{width:100%;height:100%;border:1px solid #1979ca;outline:none}syn-data-grid syn-grid-row-cell .sgrid-cell-editor.checkbox{display:flex;align-items:center;justify-content:center}syn-data-grid .right.sgrid-rows{border-left:1px solid #d3d3d3}s-tree{display:flex;padding:0;position:relative;}s-tree div.popup{position:absolute;display:none;left:0;top:0;z-index:100;}s-tree div.popup spopup{display:block}s-tree s-tree-item{display:block;}s-tree s-tree-item .tree.node.level-1{padding-left:0}s-tree s-tree-item .tree.node.level-2{padding-left:.7em}s-tree s-tree-item .tree.node.level-3{padding-left:1.4em}s-tree s-tree-item .tree.node.level-4{padding-left:2.1em}s-tree s-tree-item .tree.node.level-5{padding-left:2.8em}s-tree s-tree-item .tree.node.level-6{padding-left:3.499999999999999em}s-tree s-tree-item .tree.node.level-7{padding-left:4.199999999999999em}s-tree s-tree-item .tree.node.level-8{padding-left:4.899999999999999em}s-tree s-tree-item .tree.node.level-9{padding-left:5.6em}s-tree s-tree-item .tree.node.level-10{padding-left:6.3em}s-tree s-tree-item .tree.node.level-11{padding-left:6.999999999999999em}s-tree s-tree-item .tree.node.level-12{padding-left:7.699999999999998em}s-tree s-tree-item .tree.node.level-13{padding-left:8.4em}s-tree s-tree-item .tree.node.level-14{padding-left:9.1em}s-tree s-tree-item .tree.node.level-15{padding-left:9.8em}s-tree s-tree-item .tree.node.level-16{padding-left:10.5em}s-tree s-tree-item .tree.node.level-17{padding-left:11.2em}s-tree s-tree-item .tree.node.level-18{padding-left:11.9em}s-tree s-tree-item .tree.node.level-19{padding-left:12.6em}s-tree s-tree-item .tree.node.level-20{padding-left:13.3em}s-tree .tree.node{line-height:1em;cursor:pointer;border-bottom:1px solid #e8e8e8;white-space:nowrap;word-break:keep-all;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}s-tree .tree.node .node.content{padding:.8em 2px}s-tree .tree.node:hover{background-color:#f4f4f4}s-tree .tree.node.selected{background-color:#dadada}s-tree .tree.node i.icon{margin:0}s-tree .tree.node i.empty.icon{display:none}s-tree .tree.node i.icon.collapse:hover{color:#008000}s-tree.drag .tree.node{border-bottom-color:transparent;}s-tree.drag .tree.node.selected,s-tree.drag .tree.node:hover{background-color:transparent}s-tree.drag .tree.node .node.content{outline:1px solid #d3d3d3;outline-offset:-2px}s-tree.drag .tree.node.drag-source .node.content{outline:2px dotted #808080;outline-offset:-3px;background:#e5eecc;color:#d3d3d3}s-tree.drag .tree.node.drop-indicate{pointer-events:none;}s-tree.drag .tree.node.drop-indicate .node.content{outline:2px dotted #808080;outline-offset:-3px;background:#eaeaea;}s-tree.drag .tree.node.drop-indicate .node.content >*{visibility:hidden}s-tree .tree.children{overflow:hidden}.ui.toast.dimmer{background:none;pointer-events:none;}.ui.toast.dimmer.mask{background:rgba(0,0,0,0.3);pointer-events:auto;}.ui.toast.dimmer.mask >.content{max-width:100%;justify-content:center;border-radius:0}.ui.toast.dimmer >.content{max-width:85%;background:rgba(0,0,0,0.6);padding:1.2em;border-radius:.5em;display:flex;flex-direction:column;align-items:center;}.ui.toast.dimmer >.content i{font-size:2em}.ui.toast.dimmer >.content >i:first-child{margin-bottom:.5em}.ui.toast.dimmer >.content >i:last-child{margin-bottom:0 !important}.ui.toast.dimmer >.content >.text{line-height:1.5}.ui.toast.dimmer.top{justify-content:flex-start}.ui.toast.dimmer.bottom{justify-content:flex-end}.ui.dimmer.msgbox{background:rgba(0,0,0,0.4);}.ui.dimmer.msgbox >div{width:calc(100% - 10px);}.ui.dimmer.msgbox >div >.ui.segment{margin:0;padding:2em;border:none;border-radius:0;width:auto;border-bottom:1px solid #f1f1f1;border-top-left-radius:.5em;border-top-right-radius:.5em;}.ui.dimmer.msgbox >div >.ui.segment >.body{text-align:left;line-height:1.4;word-break:break-all;overflow:auto;max-height:calc(100vh - 200px);}.ui.dimmer.msgbox >div >.ui.segment >.body.gray{color:#555}.ui.dimmer.msgbox >div >.ui.buttons{margin:0;overflow:hidden;border-bottom-left-radius:.5em;border-bottom-right-radius:.5em;font-size:1rem;background:#fff;}.ui.dimmer.msgbox >div >.ui.buttons >.ui.button{padding:1.4em 0;flex:1;border-radius:0;box-shadow:none !important;margin:0;width:auto;border-right:1px solid #f1f1f1;}.ui.dimmer.msgbox >div >.ui.buttons >.ui.button:last-child{border:none}@media screen and (min-width:768px){.ui.dimmer.msgbox >div{max-width:640px;min-width:360px;width:auto}}.ui.dimmer.actionsheet{background:rgba(0,0,0,0.4);justify-content:flex-end;padding:0;align-items:stretch;}.ui.dimmer.actionsheet >div{background:#eaeaea;}.ui.dimmer.actionsheet >div >.ui.header .sub.header{font-size:.8em;line-height:1.6}.ui.dimmer.actionsheet >div >.ui.menu{border:none;}.ui.dimmer.actionsheet >div >.ui.menu .item{padding:1.2em;color:#000;}.ui.dimmer.actionsheet >div >.ui.menu .item >i.icon{float:none;margin:0 .5em}.ui.dimmer.actionsheet >div >.ui.menu .item.active{background:none}.ui.dimmer.actionsheet >div >.ui.menu.cancel{margin-top:.4em;color:#808080}.ui.toast.dimmer{z-index:9000}.ui.msgbox.dimmer{z-index:8800}.ui.actionsheet.dimmer{z-index:8100}.ui.popup.dimmer{z-index:8200}.ui.component.ui-item.ui-flow{display:block}.md-open-menu-container.md-active{transition:unset !important;transition-duration:unset !important}";
        }
        framework.synworkStyle = synworkStyle;
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var log;
    (function (log) {
        var Level = (function () {
            function Level(value, name) {
                this.value = value;
                this.name = name;
            }
            return Level;
        }());
        log.Level = Level;
        var prepareStackTrace = function (error, stack) {
            return stack;
        };
        var LogFactory = (function () {
            function LogFactory() {
            }
            LogFactory.get = function (name) {
                return this.loggers[name] || (this.loggers[name] = new Logger(name, this.defauleLevel));
            };
            LogFactory.setLevel = function (levelName) {
                this.defauleLevel = LogFactory.Level[levelName.toLocaleLowerCase()] || this.defauleLevel;
                for (var logName in this.loggers) {
                    if (this.loggers.hasOwnProperty(logName)) {
                        this.loggers[logName].setLevel(levelName);
                    }
                }
            };
            LogFactory.getLevel = function () {
                return this.defauleLevel;
            };
            LogFactory.TRACE = new Level(1, "TRACE");
            LogFactory.DEBUG = new Level(2, "DEBUG");
            LogFactory.INFO = new Level(3, "INFO");
            LogFactory.TIME = new Level(4, "TIME");
            LogFactory.WARN = new Level(5, "WARN");
            LogFactory.ERROR = new Level(8, "ERROR");
            LogFactory.OFF = new Level(99, "OFF");
            LogFactory.loggers = {};
            LogFactory.defauleLevel = LogFactory.DEBUG;
            LogFactory.Level = {
                trace: LogFactory.TRACE,
                debug: LogFactory.DEBUG,
                info: LogFactory.INFO,
                time: LogFactory.TIME,
                warn: LogFactory.WARN,
                error: LogFactory.ERROR,
                off: LogFactory.OFF
            };
            return LogFactory;
        }());
        log.LogFactory = LogFactory;
        var Logger = (function () {
            function Logger(_name, level) {
                this._name = _name;
                this._level = level;
            }
            Logger.prototype.getSourceLine = function () {
                var old = Error.prepareStackTrace;
                Error.prepareStackTrace = prepareStackTrace;
                var err = new Error();
                try {
                    var stack = err.stack;
                    if (stack instanceof Array) {
                        var callSite = err.stack[3];
                        return callSite.getFileName() + ":" + callSite.getLineNumber();
                    }
                }
                catch (error) {
                }
                finally {
                    Error.prepareStackTrace = old;
                }
                return '';
            };
            Object.defineProperty(Logger.prototype, "name", {
                get: function () {
                    return this._name;
                },
                enumerable: true,
                configurable: true
            });
            Logger.prototype.enabledFor = function (level) {
                return level.value >= this._level.value;
            };
            Logger.prototype.setLevel = function (levelName) {
                this._level = LogFactory.Level[levelName.toLocaleLowerCase()] || this._level;
                return this;
            };
            Logger.prototype.getLevel = function () {
                return this._level;
            };
            Object.defineProperty(Logger.prototype, "isTraceEnable", {
                get: function () {
                    return this.enabledFor(LogFactory.TRACE);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Logger.prototype, "isDebugEnable", {
                get: function () {
                    return this.enabledFor(LogFactory.DEBUG);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Logger.prototype, "isInfoEnable", {
                get: function () {
                    return this.enabledFor(LogFactory.INFO);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Logger.prototype, "isTimeEnable", {
                get: function () {
                    return this.enabledFor(LogFactory.TIME);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Logger.prototype, "isWarnEnable", {
                get: function () {
                    return this.enabledFor(LogFactory.WARN);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Logger.prototype, "isErrorEnable", {
                get: function () {
                    return this.enabledFor(LogFactory.ERROR);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Logger.prototype, "isOffEnable", {
                get: function () {
                    return this.enabledFor(LogFactory.OFF);
                },
                enumerable: true,
                configurable: true
            });
            Logger.prototype.trace = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return this.invoke('trace', args);
            };
            Logger.prototype.debug = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return this.invoke('debug', args);
            };
            Logger.prototype.info = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return this.invoke('info', args);
            };
            Logger.prototype.warn = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return this.invoke('warn', args);
            };
            Logger.prototype.error = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return this.invoke('error', args);
            };
            Logger.prototype.benchmark = function (name, fn) {
                console.time(name);
                var value = fn();
                console.timeEnd(name);
                return value;
            };
            Logger.prototype.invoke = function (method, args) {
                var level = LogFactory.Level[method];
                if (this.enabledFor(level)) {
                    var sourceLine = this.getSourceLine();
                    var params = this.convertMessage(args, sourceLine);
                    console[method].apply(console, params);
                }
                return this;
            };
            Logger.prototype.groupName = function () {
                var time = moment().format('HH:mm:ss SSS');
                return "[" + time + "] [" + this._name + "]";
            };
            Logger.prototype.convertMessage = function (args, sourceLine) {
                var time = moment().format('HH:mm:ss SSS');
                var name = ("[" + time + "] [" + this._name + "]").toString();
                var rs = [["%c" + name].concat(args.map(function (it) { return '%O'; })).join(' ')]
                    .concat('color:gray').concat(args);
                if (sourceLine) {
                    rs.push('   ' + sourceLine);
                }
                return rs;
            };
            return Logger;
        }());
        log.Logger = Logger;
    })(log = synwork.log || (synwork.log = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var ScopeBroker = (function () {
                function ScopeBroker(scope, rootScope) {
                    var _this = this;
                    this.scope = scope;
                    this.rootScope = rootScope;
                    this.variables = {};
                    this.watchers = [];
                    scope.$on("$destroy", function () {
                        _this.clean();
                    });
                }
                ScopeBroker.prototype.clean = function () {
                    var scope = this.rootScope;
                    angular.forEach(this.variables, function (value, key) {
                        scope[key] = null;
                        delete scope[key];
                    });
                    this.variables = null;
                    this.watchers.forEach(function (fn) {
                        fn();
                    });
                };
                ScopeBroker.prototype.set = function (name, value) {
                    this.rootScope[name] = value;
                    this.variables[name] = value;
                    return this;
                };
                ScopeBroker.prototype.unSet = function (name) {
                    this.rootScope[name] = null;
                    this.variables[name] = null;
                    delete this.rootScope[name];
                    delete this.variables[name];
                    return this;
                };
                ScopeBroker.prototype.watch = function (watchExpression, listener, objectEquality) {
                    var watcher = this.rootScope.$watch(watchExpression, listener, objectEquality);
                    this.watchers.push(watcher);
                    return watcher;
                };
                ScopeBroker.prototype.watchCollection = function (watchExpression, listener) {
                    var watcher = this.rootScope.$watchCollection(watchExpression, listener);
                    this.watchers.push(watcher);
                    return watcher;
                };
                ScopeBroker.prototype.watchGroup = function (watchExpressions, listener) {
                    var watcher = this.rootScope.$watchGroup(watchExpressions, listener);
                    this.watchers.push(watcher);
                    return watcher;
                };
                ScopeBroker.prototype.on = function (name, listener) {
                    var watcher = this.rootScope.$on(name, listener);
                    this.watchers.push(watcher);
                    return watcher;
                };
                ScopeBroker.prototype.emit = function (name) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    return this.rootScope.$emit.apply(this.rootScope, [name].concat(args));
                };
                return ScopeBroker;
            }());
            service.ScopeBroker = ScopeBroker;
            var App = (function () {
                function App(syn) {
                    this.syn = syn;
                    this._isClientExpire = false;
                    this._isLoginContext = false;
                    this.isLogin = false;
                    this.isES6 = false;
                    this.userExceeded = 0;
                }
                Object.defineProperty(App.prototype, "fp", {
                    get: function () {
                        return this._fp;
                    },
                    enumerable: true,
                    configurable: true
                });
                App.prototype.init = function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var appInfo, LogFactory, meta, fn, loginModule, error_1;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    appInfo = {
                                        contextPath: "/@site/1000000",
                                        rpcUrl: "/web/rpc2"
                                    };
                                    if (window['appInfo']) {
                                        appInfo = window['appInfo']();
                                    }
                                    Object.assign(this, appInfo);
                                    if (this.contextPath == "/") {
                                        this.contextPath = "";
                                    }
                                    this.jsVer = this.jsVer || '1001';
                                    LogFactory = synwork.log.LogFactory;
                                    if (!this.userRefId) {
                                        meta = $("meta[name=uref]")[0];
                                        this.userRefId = meta && meta.content;
                                    }
                                    if (this.isDev) {
                                        LogFactory.setLevel('debug');
                                    }
                                    if (location.pathname.startsWith("/@dev/")) {
                                        LogFactory.setLevel('debug');
                                        LogFactory.get('rpc').setLevel('warn');
                                        this.contextPath = "/@dev" + this.contextPath;
                                    }
                                    if (this.isStandaloneCookie) {
                                        this.rpcUrl = this.contextPath + "/@rpc";
                                    }
                                    this.isMac = /macintosh|mac os x/i.test(window.navigator.userAgent.toLocaleLowerCase());
                                    this.isIPadClient = this.isMac && ("ontouchstart" in window) ? true : false;
                                    framework.syn.log.debug("init app");
                                    fn = (function () {
                                        var toKeys = function () { return (_this.userRefId || '#guest#').split(''); };
                                        function encode(text) {
                                            var keys = toKeys();
                                            text = encodeURIComponent(text);
                                            var out = '';
                                            for (var i = 0; i < text.length; i++) {
                                                var key = keys[i % keys.length];
                                                var code = text.charCodeAt(i) + key.charCodeAt(0);
                                                out += String.fromCharCode(code);
                                            }
                                            return encodeURIComponent(btoa(out));
                                        }
                                        function decode(input) {
                                            var keys = toKeys();
                                            var text = atob(decodeURIComponent(input));
                                            var out = '';
                                            for (var i = 0; i < text.length; i++) {
                                                var key = keys[i % keys.length];
                                                var code = text.charCodeAt(i) - key.charCodeAt(0);
                                                out += String.fromCharCode(code);
                                            }
                                            return decodeURIComponent(out);
                                        }
                                        return { encode: function (text) { return encode(text); }, decode: function (text) { return decode(text); } };
                                    })();
                                    this.encode = fn.encode;
                                    this.decode = fn.decode;
                                    this.checkCurrentContext();
                                    framework.syn.component.hookSystemJs();
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4, System.import('service/login')];
                                case 2:
                                    loginModule = _a.sent();
                                    loginModule.accountManger.checkAccess();
                                    return [3, 4];
                                case 3:
                                    error_1 = _a.sent();
                                    console.error(error_1);
                                    return [3, 4];
                                case 4: return [2];
                            }
                        });
                    });
                };
                App.prototype.pageUrl = function (idOrName, params, isEncode) {
                    if (isEncode === void 0) { isEncode = false; }
                    var url = this.contextPath + "/" + idOrName;
                    if (_.endsWith(this.contextPath, "/")) {
                        url = this.contextPath + idOrName;
                    }
                    if (!idOrName) {
                        url = this.contextPath;
                    }
                    if (params) {
                        if (isEncode) {
                            var json = JSON.stringify(params);
                            url = url + "?" + this.encode(json);
                        }
                        else {
                            url = url + "?" + $.param(params);
                        }
                    }
                    return url;
                };
                App.prototype.pageParams = function () {
                    try {
                        var search = window.location.search;
                        if (!search) {
                            return {};
                        }
                        search = search.substr(1, search.length - 1);
                        search = search.split('&')[0];
                        return JSON.parse(this.decode(search));
                    }
                    catch (error) {
                        return {};
                    }
                };
                App.prototype.currentUrl = function () {
                    return;
                };
                App.prototype.libPath = function (name) {
                    return "http://lib.95work.com/version/" + this.version + "/" + name + "?ver=" + this.jsVer;
                };
                App.prototype.thirdLibPath = function (name) {
                    return "http://lib.95work.com/lib/" + name;
                };
                App.prototype.uploadUrl = function () {
                    if (this.isStandaloneCookie) {
                        return this.contextPath + "/@file/upload" + window.location.search;
                    }
                    return '/web/_file/upload';
                };
                App.prototype.imageUploadUrl = function () {
                    if (this.isStandaloneCookie) {
                        return this.contextPath + "/@file/imageUpload" + window.location.search;
                    }
                    return '/web/_file/imageUpload';
                };
                App.prototype.rootScopeBroker = function (scope) {
                    return new ScopeBroker(scope, this.syn.ng.rootScope);
                };
                App.prototype.clientExpire = function (msg) {
                    if (msg === void 0) { msg = ''; }
                    if (window.top && window.top != window && window.top['syn']) {
                        window.top['syn'].app.clientExpire(msg);
                        return;
                    }
                    msg = msg || "会话已失效!";
                    framework.syn.toast.hide();
                    if (this._isClientExpire) {
                        return;
                    }
                    this._isClientExpire = true;
                    document.body.childNodes.forEach(function (node) {
                        if (node instanceof HTMLElement) {
                            node.style.display = 'none';
                        }
                    });
                    framework.syn.msgbox.alert("", msg).then(function (rs) {
                        (window.top || window).location.reload();
                    });
                };
                Object.defineProperty(App.prototype, "isClientExpire", {
                    get: function () {
                        return this._isClientExpire;
                    },
                    enumerable: true,
                    configurable: true
                });
                App.prototype.checkUserContext = function (subUserRef, win) {
                    if (this.userRefId !== subUserRef) {
                        this.clientExpire();
                        if (win) {
                            $(win.document.body).hide();
                        }
                    }
                };
                App.prototype.checkCurrentContext = function () {
                    try {
                        if (window.top && window.top != window) {
                            var topSyn = window.top['syn'];
                            if (window.top.location.host != location.host) {
                                return;
                            }
                            if (window.top.location.pathname != location.pathname) {
                                return;
                            }
                            if (topSyn && topSyn.app) {
                                topSyn.app.checkUserContext(this.userRefId, window);
                            }
                        }
                    }
                    catch (error) {
                        console.warn(error);
                    }
                };
                App.prototype.enableLoginContext = function () {
                    this._isLoginContext = true;
                    this.userRefId = "#guest#";
                };
                Object.defineProperty(App.prototype, "isLoginContext", {
                    get: function () {
                        return this._isLoginContext;
                    },
                    enumerable: true,
                    configurable: true
                });
                return App;
            }());
            service.App = App;
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service_1) {
            function toJson(obj) {
                if (angular.isUndefined(obj))
                    return undefined;
                return JSON.stringify(obj, function (key, value) {
                    var val = value;
                    if (value && value.$$empty) {
                        val = null;
                    }
                    else if (typeof key === 'string' &&
                        ((key.charAt(0) === '$' && key.charAt(1) === '$') ||
                            (key.charAt(0) === '_' && key.charAt(1) === '_'))) {
                        if (key !== '__') {
                            val = undefined;
                        }
                    }
                    else if (value && window.document === value) {
                        val = '$DOCUMENT';
                    }
                    else if (value && value.$evalAsync && value.$watch) {
                        val = '$SCOPE';
                    }
                    return val;
                });
            }
            var RpcBatch = (function () {
                function RpcBatch() {
                    var _this = this;
                    this._idCount = 0;
                    this._requestList = [];
                    this.log = synwork.log.LogFactory.get("batch rpc");
                    this._process = _.debounce(function () {
                        _this.process();
                    }, 10);
                }
                RpcBatch.prototype.addRequest = function (request) {
                    request.id = this._idCount++;
                    this._requestList.push(request);
                    this._process();
                };
                RpcBatch.prototype.toRequest = function (request) {
                    var params = {
                        id: request.id,
                        service: request.service,
                        method: request.method,
                        paramsCount: request.params.length,
                        params: toJson(request.params),
                        sign: ""
                    };
                    var content = params.service + "&" + params.method + "&" + params.paramsCount + "&" + params.params;
                    params.sign = md5(content);
                    return params;
                };
                RpcBatch.prototype.handleResult = function (request, result) {
                    try {
                        request.defer.resolve(result);
                    }
                    catch (e) {
                        this.log.error("call resolve error", e);
                    }
                };
                RpcBatch.prototype.process = function () {
                    var _this = this;
                    var requestList = this._requestList.concat([]);
                    this._requestList = [];
                    var params = requestList.map(function (it) { return _this.toRequest(it); });
                    var showLoading = requestList.some(function (it) { return it.busy; });
                    if (this.log.isDebugEnable) {
                        var servcieList = requestList.map(function (it) { return it.service + "." + it.method; }).join(',');
                        this.log.debug('start call', servcieList);
                    }
                    if (showLoading) {
                        framework.syn.toast.showLoading();
                    }
                    var url = framework.syn.app.isStandaloneCookie ? rpcUrl() : framework.syn.app.rpcUrl + "/batch";
                    framework.syn.ng.http.post(url, { items: params }, { headers: { type: 'batch' } }).then(function (resp) {
                        var resultList = resp.data;
                        _this.log.debug('call result', resultList);
                        for (var _i = 0, resultList_1 = resultList; _i < resultList_1.length; _i++) {
                            var callResult = resultList_1[_i];
                            var result = new RpcResult();
                            result.success = true;
                            var id = callResult.id;
                            var request = _.find(requestList, { id: id });
                            if (!request) {
                                _this.log.warn('无法发现请求对象', id);
                                continue;
                            }
                            var actionName = request.service + "." + request.method;
                            result.actionName = actionName;
                            if (callResult.error) {
                                result.errorMsg = callResult.error.message;
                                result.success = false;
                                result.errorCode = callResult.error.code;
                                _this.log.warn(actionName + ":" + result.errorMsg);
                            }
                            else {
                                result.data = callResult.result;
                            }
                            _this.handleResult(request, result);
                        }
                    }, function (error) {
                        _this.log.error('call error', JSON.stringify(error));
                    }).finally(function () {
                        if (showLoading) {
                            framework.syn.toast.hide();
                        }
                    });
                };
                return RpcBatch;
            }());
            var batch = new RpcBatch();
            var Rpc = (function () {
                function Rpc() {
                }
                Rpc.prototype.service = function (serviceName, showNetError) {
                    if (showNetError === void 0) { showNetError = false; }
                    return new RpcService(framework.syn.app.rpcUrl, serviceName, false);
                };
                Rpc.prototype.promiseService = function (serviceName, showNetError) {
                    if (showNetError === void 0) { showNetError = false; }
                    return new RpcService(framework.syn.app.rpcUrl, serviceName, true);
                };
                Rpc.prototype.$ = function (serviceName, options) {
                    return new RpcService2(framework.syn.app.rpcUrl, serviceName, true, options);
                };
                return Rpc;
            }());
            service_1.Rpc = Rpc;
            function rpcUrl() {
                if (framework.syn.app.isStandaloneCookie) {
                    var url = framework.syn.app.contextPath + "/" + framework.syn.app.pageId + "/@rpc" + window.location.search;
                    return url;
                }
                return framework.syn.app.rpcUrl;
            }
            var RpcResult = (function () {
                function RpcResult() {
                    this._isResolveError = false;
                }
                RpcResult.prototype.resolveError = function () {
                    this._isResolveError = true;
                };
                Object.defineProperty(RpcResult.prototype, "errorResolved", {
                    get: function () {
                        return this._isResolveError;
                    },
                    enumerable: true,
                    configurable: true
                });
                RpcResult.prototype.convertErrorMsg = function () {
                    if (this.exception == "javax.persistence.OptimisticLockException") {
                        return "数据版本过低，无法保存";
                    }
                    return this.errorMsg;
                };
                RpcResult.prototype.checkError = function (msg) {
                    if (msg === void 0) { msg = ''; }
                    msg = msg || this.actionName + "\u51FA\u9519";
                    if (this.success) {
                        return framework.syn.ng.q.resolve();
                    }
                    this._isResolveError = true;
                    framework.syn.message.error(msg + ":" + this.convertErrorMsg()).longTime();
                    return framework.syn.ng.q.reject();
                };
                RpcResult.prototype.checkOptimisticLock = function () {
                    var defer = framework.syn.ng.q.defer();
                    if (this.exception == 'javax.persistence.OptimisticLockException') {
                        framework.syn.dlg.openConfirm("数据版本过低，无法保存，是否读取最新数据?").onOk(function () {
                            defer.resolve(true);
                        }).onCancel(function () {
                            defer.resolve(false);
                        });
                    }
                    else {
                        return framework.syn.ng.q.resolve(false);
                    }
                    return defer.promise;
                };
                RpcResult.prototype.showSuccess = function (msg) {
                    if (msg === void 0) { msg = ''; }
                    msg = msg || this.actionName + "\u6210\u529F";
                    framework.syn.message.success(msg);
                };
                return RpcResult;
            }());
            service_1.RpcResult = RpcResult;
            var RemoteMethod = (function () {
                function RemoteMethod(rpc, method, defaultArgs) {
                    this.rpc = rpc;
                    this.method = method;
                    this.defaultArgs = defaultArgs;
                    this.isInit = false;
                    this.cache = {};
                    this.subject = new Rx.Subject();
                }
                Object.defineProperty(RemoteMethod.prototype, "result", {
                    get: function () {
                        return this._result;
                    },
                    enumerable: true,
                    configurable: true
                });
                RemoteMethod.prototype.init = function () {
                    var _this = this;
                    this.isInit = true;
                    var obs = this.subject;
                    if (this.debounceTime) {
                        obs = obs.debounceTime(this.debounceTime);
                    }
                    obs.switchMap(function (args) {
                        return _this.rpc.callWithArgs(_this.method, args);
                    }, function (outerValue, innerValue) { return [outerValue, innerValue]; })
                        .subscribe(function (rs) {
                        var args = rs[0];
                        var result = rs[1];
                        if (_this.isCacheable) {
                            _this.cache[JSON.stringify(args)] = result;
                        }
                        if (_this.eachFn) {
                            result.forEach(function (element) {
                                _this.eachFn(element);
                            });
                        }
                        _this._result = result;
                    });
                };
                RemoteMethod.prototype.each = function (fn) {
                    this.eachFn = fn;
                    return this;
                };
                RemoteMethod.prototype.debounce = function (time) {
                    this.debounceTime = time;
                    return this;
                };
                RemoteMethod.prototype.useCache = function () {
                    this.isCacheable = true;
                    return this;
                };
                RemoteMethod.prototype.clearCache = function () {
                    return this;
                };
                RemoteMethod.prototype.call = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    if (!this.isInit) {
                        this.init();
                    }
                    this._result = null;
                    if (this.isCacheable) {
                        var key = JSON.stringify(args);
                        var value = this.cache[key];
                        if (value) {
                            this._result = value;
                            return value;
                        }
                    }
                    this.subject.next(args);
                };
                return RemoteMethod;
            }());
            service_1.RemoteMethod = RemoteMethod;
            var RpcService = (function () {
                function RpcService(_baseUrl, _service, promise, options) {
                    if (promise === void 0) { promise = false; }
                    if (options === void 0) { options = { encode: true }; }
                    this._baseUrl = _baseUrl;
                    this._service = _service;
                    this.promise = promise;
                    this.options = options;
                    this.busyConfig = { modal: true };
                    this.log = framework.syn.getLog('rpc');
                    this._useSmile = false;
                    this._useGbk = false;
                    this.msgPackTransform = function (data) {
                        console.log('data', data);
                        return Smile.Parser.parse(data);
                    };
                    if (!framework.syn.app.userRefId) {
                        this.options.encode = false;
                    }
                    else {
                        this.options.encode = true;
                    }
                }
                RpcService.prototype.useSmile = function () {
                    this._useSmile = true;
                    return this;
                };
                RpcService.prototype.useGbk = function () {
                    this._useGbk = true;
                    return this;
                };
                RpcService.prototype.owner = function (owner) {
                    this._owner = owner;
                    return this;
                };
                RpcService.prototype.setBusyConfig = function (cfg) {
                    this.busyConfig = cfg;
                };
                RpcService.prototype.bind = function (mapping) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    return this.doBind(mapping, args, false);
                };
                RpcService.prototype.doBind = function (mapping, args, isBusy) {
                    var _this = this;
                    var _a = mapping.split(":"), prop = _a[0], method = _a[1];
                    method = method || prop;
                    var obs = this.callWithArgs(method, args);
                    if (isBusy) {
                        obs.busy(this.busyConfig);
                    }
                    var promise = obs.toPromise();
                    setTimeout(function () {
                        promise.then(function (rs) {
                            _this._owner[prop] = rs;
                        });
                    }, 0);
                    return promise;
                };
                RpcService.prototype.busyBind = function (mapping) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    return this.doBind(mapping, args, true);
                };
                RpcService.prototype.method = function (name, args) {
                    if (args === void 0) { args = null; }
                    return new RemoteMethod(this, name, args);
                };
                RpcService.prototype.call = function (method) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    var rs = this.callWithArgs(method, args);
                    if (this.promise) {
                        if (rs['then']) {
                            return rs;
                        }
                        return rs.toPromise();
                    }
                    return rs;
                };
                RpcService.prototype.busyCall = function (method) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    var rs = this.callWithArgs(method, args).busy(this.busyConfig);
                    if (this.promise) {
                        if (rs['then']) {
                            return rs;
                        }
                        return rs.toPromise();
                    }
                    return rs;
                };
                RpcService.prototype.toParams = function (method, args) {
                    var params = {
                        service: this._service,
                        method: method,
                        paramsCount: args.length,
                        params: toJson(args),
                        time: new Date().getTime()
                    };
                    this.log.debug(this.rpcCallName(method), this._service + "." + method, args);
                    var content = params.service + "&" + params.method + "&" + params.paramsCount + "&" + params.params + "&" + params.time;
                    params.sign = md5(content);
                    return this.options.encode ? framework.syn.app.encode(JSON.stringify(params)) : params;
                };
                RpcService.prototype.appCase = function (appCase) {
                    this._appCase = appCase;
                };
                RpcService.prototype.rpcCallName = function (method) {
                    var appCase = this._appCase ? "[app:" + this._appCase + "] " : '';
                    return appCase + "rpc call " + this._service + "." + method;
                };
                RpcService.prototype.buildParams = function (method, args) {
                    var params = this.toParams(method, args);
                    var config = {};
                    config.headers = {
                        servie: this._service,
                        method: method
                    };
                    if (framework.syn.app.isLoginContext) {
                        config.headers.login = "true";
                    }
                    if (framework.syn.app.userRefId) {
                        config.headers.uref = framework.syn.app.userRefId;
                    }
                    if (this._useGbk) {
                        config.headers['Content-Type'] = 'application/json;charset=GBK';
                    }
                    if (this._useSmile) {
                        config.headers.msg = 'pack';
                        config.responseType = 'arraybuffer';
                        config.transformResponse = this.msgPackTransform;
                    }
                    if (this.options.encode) {
                        config.headers['encode'] = '1';
                    }
                    if (this._appCase > 0)
                        [
                            config.headers['app'] = this._appCase
                        ];
                    if (this.options.msgPack) {
                        config.headers['msg'] = 'pack';
                        config.responseType = 'arraybuffer';
                        config.transformResponse = this.msgPackTransform;
                    }
                    return [config, params];
                };
                RpcService.prototype.callWithArgs = function (method, args) {
                    var _this = this;
                    if (framework.syn.app.isClientExpire)
                        return framework.syn.ng.q.defer().promise;
                    var _a = this.buildParams(method, args), config = _a[0], params = _a[1];
                    var defer = framework.syn.ng.q.defer();
                    var time = new Date().getTime();
                    framework.syn.ng.http.post(rpcUrl(), params, config).then(function (resp) {
                        if (_this.checkClientExpire(resp)) {
                            return;
                        }
                        var data = resp.data;
                        if (data.error) {
                            var error = new service_1.Error(data.error.code, data.error.message, data.error.data, false);
                            error.status = resp.status;
                            error.statusText = resp.statusText;
                            defer.reject(error);
                        }
                        else {
                            try {
                                _this.log.debug(_this.rpcCallName(method), ' success', "time:" + (new Date().getTime() - time) / 1000);
                                defer.resolve(data.result);
                            }
                            catch (e) {
                                console.log("resolve error:" + e);
                            }
                        }
                    }, function (rs) {
                        defer.reject(rs);
                    });
                    return Rx.Observable.fromPromise(defer.promise);
                };
                RpcService.prototype.checkClientExpire = function (resp) {
                    if (resp.status == 401) {
                        return true;
                    }
                    return false;
                };
                return RpcService;
            }());
            service_1.RpcService = RpcService;
            var BatchCall = (function () {
                function BatchCall(service, scope) {
                    this.service = service;
                    this.scope = scope;
                }
                BatchCall.prototype.call = function (method) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    return this.doCall(method, args, false);
                };
                BatchCall.prototype.busyCall = function (method) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    return this.doCall(method, args, true);
                };
                BatchCall.prototype.doCall = function (method, params, busy) {
                    var defer = framework.syn.ng.q.defer();
                    batch.addRequest({
                        service: this.service,
                        method: method,
                        params: params,
                        defer: defer,
                        busy: busy
                    });
                    return defer.promise;
                };
                return BatchCall;
            }());
            service_1.BatchCall = BatchCall;
            var RpcService2 = (function (_super) {
                __extends(RpcService2, _super);
                function RpcService2() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                RpcService2.prototype.handleResult = function (defer, rs) {
                    try {
                        if (!rs.success && this._errorHandler) {
                            this._errorHandler(rs);
                            defer.reject(rs.errorMsg);
                            return;
                        }
                        defer.resolve(rs);
                    }
                    catch (e) {
                        console.error("rpc call resolve error", e);
                    }
                };
                Object.defineProperty(RpcService2.prototype, "batch", {
                    get: function () {
                        return new BatchCall(this._service, this._scope);
                    },
                    enumerable: true,
                    configurable: true
                });
                RpcService2.prototype.setErrorHandler = function (handler) {
                    this._errorHandler = handler;
                };
                RpcService2.prototype.useMsgPack = function () {
                };
                RpcService2.prototype.busyCall = function (method) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    framework.syn.toast.showLoading();
                    var promise = this.callWithArgs(method, args);
                    promise.finally(function () {
                        framework.syn.toast.hide();
                    });
                    return promise;
                };
                RpcService2.prototype.callWithArgs = function (method, args) {
                    var _this = this;
                    if (framework.syn.app.isClientExpire)
                        return framework.syn.ng.q.defer().promise;
                    var _a = this.buildParams(method, args), config = _a[0], params = _a[1];
                    var defer = framework.syn.ng.q.defer();
                    var result = new RpcResult();
                    result.success = true;
                    var actionName = this._service + "." + method;
                    var time = new Date().getTime();
                    framework.syn.ng.http.post(rpcUrl(), params, config).then(function (resp) {
                        if (_this.checkClientExpire(resp)) {
                            return;
                        }
                        var data = resp.data;
                        result.actionName = data.name || actionName;
                        _this.log.debug(_this.rpcCallName(method), " success", "time:" + (new Date().getTime() - time) / 1000);
                        if (data.error) {
                            result.errorMsg = data.error.message;
                            result.success = false;
                            result.errorCode = data.error.code;
                            _this.log.warn("[rpc app error] " + actionName + ":" + result.errorMsg);
                            _this.handleResult(defer, result);
                        }
                        else {
                            result.data = data.result;
                            _this.handleResult(defer, result);
                        }
                    }, function (error) {
                        console.error('rpc error', error);
                        if (error.status < 0) {
                            return;
                        }
                        result.success = false;
                        result.errorCode = error.code;
                        result.status = error.status;
                        result.statusText = error.statusText;
                        if (error.data && error.data.data) {
                            result.actionName = error.data.data.actionName || actionName;
                            result.errorMsg = error.data.error.message;
                            result.errorData = error.data;
                            result.stacktrace = error.data.data.stacktrace;
                            result.exception = error.data.data.exception;
                        }
                        if (error.resolve)
                            error.resolve();
                        console.error("[rpc error] " + actionName + ":" + result.errorMsg + "\r\n" + result.stacktrace);
                        _this.handleResult(defer, result);
                    });
                    return defer.promise;
                };
                return RpcService2;
            }(RpcService));
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var ng;
            var Rest = (function () {
                function Rest(syn) {
                    this.syn = syn;
                    ng = syn.ng;
                }
                Rest.prototype.service = function (serviceName, showNetError) {
                    if (showNetError === void 0) { showNetError = false; }
                    return new RestService(this.syn.app.restBaseUrl + "/" + serviceName, showNetError);
                };
                Rest.prototype.url = function (apiUrl) {
                    if (apiUrl.startsWith('imageFolder')) {
                        return framework.syn.app.contextPath + "/@file/" + apiUrl;
                    }
                    return this.syn.app.restBaseUrl + "/" + apiUrl;
                };
                return Rest;
            }());
            service.Rest = Rest;
            var RestService = (function () {
                function RestService(baseUrl, showNetError) {
                    this.baseUrl = baseUrl;
                    this.showNetError = showNetError;
                }
                RestService.prototype.config = function (cfg) {
                    if (cfg.params && cfg.params.ignoreError) {
                        cfg.ignoreError = true;
                        delete cfg.params.ignoreError;
                    }
                    cfg.showNetError = this.showNetError;
                    return cfg;
                };
                RestService.prototype.get = function (url, params) {
                    return this.hookError(ng.http.get(this.baseUrl + "/" + url, this.config({ params: params })));
                };
                RestService.prototype.delete = function (url, params) {
                    return this.hookError(ng.http.delete(this.baseUrl + "/" + url, this.config({ params: params })));
                };
                RestService.prototype.patch = function (url, data, params) {
                    return this.hookError(ng.http.patch(this.baseUrl + "/" + url, data, this.config({ params: params })));
                };
                RestService.prototype.post = function (url, data, params) {
                    var cfg = { params: params };
                    if (data instanceof Blob) {
                        cfg.headers = {
                            'Content-Type': 'application/octet-stream'
                        };
                    }
                    return this.hookError(ng.http.post(this.baseUrl + "/" + url, data, this.config(cfg)));
                };
                RestService.prototype.hookError = function (promise) {
                    return promise;
                };
                RestService.prototype.transformResp = function (data, headersGetter, status) {
                    return data;
                };
                return RestService;
            }());
            service.RestService = RestService;
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var HtmlExporter = (function () {
                function HtmlExporter() {
                }
                HtmlExporter.prototype.saveAsExcel = function (fileName, sheetName, table, style) {
                    if (sheetName === void 0) { sheetName = 'sheet1'; }
                    if (style === void 0) { style = ''; }
                    var excelTpl = "\n<html xmlns:o='urn:schemas-microsoft-com:office:office'\n    xmlns:x='urn:schemas-microsoft-com:office:excel'\n    xmlns='http://www.w3.org/TR/REC-html40'>\n<head>\n    <!--[if gte mso 9]>\n        <xml>\n            <x:ExcelWorkbook>\n                <x:ExcelWorksheets>\n                    <x:ExcelWorksheet>\n                        <x:Name>" + sheetName + "</x:Name>\n                        <x:WorksheetOptions>\n                            <x:DisplayGridlines/>\n                        </x:WorksheetOptions>\n                    </x:ExcelWorksheet>\n                </x:ExcelWorksheets>\n            </x:ExcelWorkbook>\n        </xml>\n     <![endif]-->\n     <style type=\"text/css\">\n        " + style + "\n    </style>    \n</head>\n<body>\n" + table + "\n</body>\n</html>";
                    var blob = new Blob([excelTpl], { type: "text/plain;charset=utf-8" });
                    saveAs(blob, fileName + ".xls");
                };
                HtmlExporter.prototype.saveAsWord = function (fileName, content, style) {
                    if (style === void 0) { style = ''; }
                    var tpl = "<html>\n<head>\n<style>\n" + style + "\n</style>\n</head>\n<body>\n" + content + "\n</body>\n</html>";
                    var blob = new Blob([tpl], { type: "text/plain;charset=utf-8" });
                    saveAs(blob, fileName + ".doc");
                };
                return HtmlExporter;
            }());
            service.HtmlExporter = HtmlExporter;
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var Column = (function () {
                function Column(expr, alias, index) {
                    this.expr = expr;
                    this.alias = alias;
                    this.index = index;
                    if (!alias) {
                        if (_.isString(expr)) {
                            this.alias = expr.toString();
                        }
                        else {
                            this.alias = "c" + index;
                        }
                    }
                }
                return Column;
            }());
            var GroupColumn = (function (_super) {
                __extends(GroupColumn, _super);
                function GroupColumn(expr, alias, index) {
                    return _super.call(this, expr, alias, index) || this;
                }
                return GroupColumn;
            }(Column));
            var SummaryColumn = (function (_super) {
                __extends(SummaryColumn, _super);
                function SummaryColumn(expr, alias, index, type) {
                    var _this = _super.call(this, expr, alias, index) || this;
                    _this.type = type;
                    return _this;
                }
                return SummaryColumn;
            }(Column));
            var GroupCollection = (function () {
                function GroupCollection() {
                    this.groups = [];
                    this.items = [];
                }
                return GroupCollection;
            }());
            var DataAggregate = (function () {
                function DataAggregate(data) {
                    this.groups = [];
                    this.columns = [];
                    this.sorts = [];
                    this.orders = [];
                    this.exec = function (expr) {
                        return eval(expr);
                    };
                    this.data = data;
                }
                DataAggregate.prototype.addColumn = function (expr, alias, type) {
                    this.columns.push(new SummaryColumn(expr, alias, this.groups.length + this.columns.length + 1, type));
                };
                DataAggregate.prototype.group = function (expr, alias) {
                    this.groups.push(new GroupColumn(expr, alias, this.groups.length + 1));
                    return this;
                };
                DataAggregate.prototype.sum = function (expr, alias) {
                    this.addColumn(expr, alias, "sum");
                    return this;
                };
                DataAggregate.prototype.avg = function (expr, alias) {
                    this.addColumn(expr, alias, "avg");
                    return this;
                };
                DataAggregate.prototype.count = function (expr, alias) {
                    this.addColumn(expr, alias, "count");
                    return this;
                };
                DataAggregate.prototype.min = function (expr, alias) {
                    this.addColumn(expr, alias, "min");
                    return this;
                };
                DataAggregate.prototype.max = function (expr, alias) {
                    this.addColumn(expr, alias, "max");
                    return this;
                };
                DataAggregate.prototype.summary = function () {
                    var _this = this;
                    var groupMap = {};
                    this.data.forEach(function (it) {
                        var groupValues = _this.groups.map(function (g) {
                            return _.map([it], g.expr)[0];
                        });
                        var groupKey = groupValues.join("|");
                        var groupCollection = groupMap[groupKey];
                        if (!groupCollection) {
                            groupCollection = new GroupCollection();
                            groupCollection.groups = groupValues;
                            groupMap[groupKey] = groupCollection;
                        }
                        groupCollection.items.push(it);
                    });
                    var rs = [];
                    for (var key in groupMap) {
                        var collection = groupMap[key];
                        var row = {};
                        rs.push(row);
                        collection.groups.forEach(function (g, index) {
                            var group = _this.groups[index];
                            row[group.alias] = g;
                        });
                        this.columns.forEach(function (c) {
                            if (c.type == "sum") {
                                row[c.alias] = _.sumBy(collection.items, c.expr);
                            }
                            else if (c.type == "avg") {
                                row[c.alias] = _.sumBy(collection.items, c.expr) / collection.items.length;
                            }
                            else if (c.type == "max") {
                                row[c.alias] = _.max(_.map(collection.items, c.expr));
                            }
                            else if (c.type == "min") {
                                row[c.alias] = _.min(_.map(collection.items, c.expr));
                            }
                            else if (c.type == "count") {
                                var values = _.map(collection.items, c.expr);
                                row[c.alias] = _.filter(values, function (it) {
                                    return it;
                                }).length;
                            }
                        });
                    }
                    if (!_.isEmpty(this.sorts)) {
                        rs = _.orderBy(rs, this.sorts, this.orders);
                    }
                    return rs;
                };
                DataAggregate.prototype.sortBy = function (sorts, orders) {
                    this.sorts = sorts;
                    this.orders = orders || [];
                    return this;
                };
                return DataAggregate;
            }());
            service.DataAggregate = DataAggregate;
            var DataAggregateService = (function () {
                function DataAggregateService() {
                }
                DataAggregateService.prototype.source = function (data) {
                    return new DataAggregate(data);
                };
                return DataAggregateService;
            }());
            service.DataAggregateService = DataAggregateService;
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var ng;
            var Message = (function () {
                function Message(serviceCfg) {
                    this.serviceCfg = serviceCfg;
                    this.cfg = {
                        title: "",
                        delay: -1
                    };
                    this.normalDelay = 3000;
                    this.shortDelay = 2000;
                    this.longDelay = 10000;
                    this.interval = -1;
                }
                Message.prototype.isLoaded = function () {
                    return this.messageEl != null;
                };
                Message.prototype.show = function (message, title, cls) {
                    var _this = this;
                    if (this.isTopWindow() || !(window.parent["syn"])) {
                        this.cfg.title = title;
                        if (angular.isArray(message)) {
                            this.cfg.message = null;
                            this.cfg.messages = message;
                        }
                        else {
                            this.cfg.message = message;
                            this.cfg.messages = null;
                        }
                        this.cfg.cls = cls;
                        this.cfg.delay = this.normalDelay;
                        this.cfg.icon = null;
                        setTimeout(function () {
                            _this.showMessage();
                        }, 0);
                        return this;
                    }
                    else {
                        return (window.parent).syn.message.current.show(message, title, cls);
                    }
                };
                Message.prototype.isTopWindow = function () {
                    return window.parent === window;
                };
                Message.prototype.showMessage = function () {
                    var _this = this;
                    if (this.messageEl) {
                        this.doShowMessage();
                    }
                    else {
                        this.loadMessagePage().then(function () { return _this.doShowMessage(); });
                    }
                };
                Message.prototype.close = function () {
                    if (this.messageEl.transition("is visible")) {
                        this.messageEl.transition("fade down");
                    }
                    else {
                        this.messageEl.transition("hide");
                    }
                };
                Message.prototype.doShowMessage = function () {
                    var _this = this;
                    angular.merge(this.messageScope, this.cfg);
                    clearTimeout(this.interval);
                    ng.timeout(function () {
                        _this.messageEl.transition("hide").transition("fade down");
                        if (_this.cfg.delay > 0) {
                            _this.interval = setTimeout(function () {
                                _this.close();
                            }, _this.cfg.delay);
                        }
                    });
                };
                Message.prototype.manualClose = function () {
                    this.cfg.delay = -1;
                };
                Message.prototype.shortTime = function () {
                    this.cfg.delay = this.shortDelay;
                };
                Message.prototype.longTime = function (time) {
                    if (time === void 0) { time = undefined; }
                    this.cfg.delay = time || this.longDelay;
                };
                Message.prototype.loadMessagePage = function () {
                    var _this = this;
                    return ng.templateRequest(framework.syn.app.pageUrl(this.serviceCfg.messagePage)).then(function (tpl) {
                        _this.messageEl = angular.element(tpl).appendTo('body');
                        _this.messageScope = ng.rootScope.$new(true);
                        _this.messageScope.close = function () { return _this.close(); };
                        _this.messageEl['transition']("hide");
                        ng.compile(_this.messageEl)(_this.messageScope);
                    }).catch(function (status) {
                    });
                };
                return Message;
            }());
            service.Message = Message;
            var MessageService = (function () {
                function MessageService(syn) {
                    this.cfg = {};
                    ng = syn.ng;
                    if (!this.cfg.messagePage) {
                        this.cfg.messagePage = 1028907;
                    }
                    this.current = new Message(this.cfg);
                }
                MessageService.prototype.setPageId = function (paeId) {
                    this.cfg.messagePage = paeId;
                };
                MessageService.prototype.info = function (message, title) {
                    this.current.show(message, title || "提示", "info");
                    return this.current;
                };
                MessageService.prototype.success = function (message, title) {
                    this.current.show(message, title || "提示", "success");
                    return this.current;
                };
                MessageService.prototype.error = function (message, title) {
                    this.current.show(message, title || "错误", "error");
                    return this.current;
                };
                MessageService.prototype.warn = function (message, title) {
                    this.current.show(message, title || "警告", "warning");
                    return this.current;
                };
                MessageService.prototype.isLoaded = function () {
                    return this.current.isLoaded();
                };
                return MessageService;
            }());
            service.MessageService = MessageService;
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork_1) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var count = 0;
            var iframe;
            var serviceConfig = {};
            var loadingTpl = "<div class='ui active inverted dimmer'><div class='ui text loader'></div></div>";
            var pageCache = {};
            var current = null;
            var ng;
            var syn;
            var ModalPage = (function () {
                function ModalPage(pageId, params) {
                    this.pageId = pageId;
                    this.params = params;
                    this._zIndex = -1;
                    this._isShow = false;
                    this._navId = -1;
                }
                ModalPage.prototype.onClose = function (callback) {
                    this._closeFn = callback;
                    return this;
                };
                ModalPage.prototype.zIndex = function (value) {
                    this._zIndex = value;
                    return this;
                };
                ModalPage.prototype.doClose = function (result) {
                    var _this = this;
                    if (this._navId > 0) {
                        service.naviagtion.remove(this._navId);
                    }
                    this.el.remove();
                    this.modalScope.$destroy();
                    this.el.remove();
                    this.modalScope = null;
                    this.el = null;
                    if (iframe && this._fullScreen) {
                        iframe.removeClass("iframe-full-screen");
                    }
                    if (this._closeFn) {
                        ng.timeout(function () {
                            _this._closeFn(result);
                        }, 100);
                    }
                };
                ModalPage.prototype.close = function (result) {
                    var _this = this;
                    if (result === void 0) { result = null; }
                    if (result && angular.isFunction(result.then)) {
                        result.then(function (rs) {
                            _this.doClose(rs);
                        }, function (error) {
                        });
                    }
                    else {
                        this.doClose(result);
                    }
                };
                ModalPage.prototype.fullScreen = function () {
                    return this;
                };
                ModalPage.prototype.tpl = function () {
                    var maxSizeCls = this._maxSize ? "max-size" : "";
                    if (typeof this.pageId == "string" && this.pageId.toString().indexOf("<") == 0) {
                        return "<div class=\"ui modal-page dimmer transition " + maxSizeCls + " visible active\" instance=\"" + ModalPage.count + "\">\n               " + this.pageId + "</div>";
                    }
                    else {
                        return "<div class=\"ui modal-page dimmer transition " + maxSizeCls + " visible active\" instance=\"" + ModalPage.count + "\">\n                <include-page page-id=\"'" + this.pageId + "'\" params=\"params\"></include-page></div>";
                    }
                };
                ModalPage.prototype.maxSize = function () {
                    this._maxSize = true;
                    return this;
                };
                ModalPage.prototype.show = function (fullScreen) {
                    var _this = this;
                    if (fullScreen === void 0) { fullScreen = false; }
                    if (this._isShow) {
                        return;
                    }
                    this._isShow = true;
                    this._navId = service.naviagtion.push(function () {
                        _this.close();
                    });
                    ModalPage.count++;
                    this._fullScreen = fullScreen;
                    this.el = $(this.tpl()).appendTo("body");
                    this.el.data("modalPage.instance", this);
                    this.el.data("modalPage.params", this.params);
                    if (this._zIndex > 0) {
                        this.el.css("z-index", this._zIndex);
                    }
                    this.modalScope = ng.rootScope.$new(true);
                    this.modalScope.params = this.params;
                    this.modalScope.modalPage = this;
                    ng.compile(this.el)(this.modalScope);
                    if (iframe && this._fullScreen) {
                        iframe.addClass("iframe-full-screen");
                    }
                    return this;
                };
                ModalPage.count = 0;
                return ModalPage;
            }());
            service.ModalPage = ModalPage;
            var Dialog = (function () {
                function Dialog(pageId, params, cache, preDialog) {
                    var _this = this;
                    this.pageId = pageId;
                    this.params = params;
                    this.cache = cache;
                    this.preDialog = preDialog;
                    this.cfg = {
                        title: "",
                        okLabel: "确定",
                        cancelLabel: "取消"
                    };
                    this.isLoaded = false;
                    this.navId = -1;
                    this.isOkButtonEnable = function () {
                        return !_this._isBusy;
                    };
                    this.onOkCallback = angular.noop;
                    this.onCancelCallback = angular.noop;
                    this.onHiddenCallback = angular.noop;
                    this.onOkAction = angular.noop;
                    this.onCancelAction = angular.noop;
                    this.lastActionTime = 0;
                    this._isBusy = false;
                    this.isFullScreenMax = false;
                    this.isClose = false;
                    this.isOpen = false;
                    this.dialogCache = syn.cache.getCache("$dialog$");
                }
                Dialog.prototype.open = function () {
                    var _this = this;
                    if (this.isOpen) {
                        return;
                    }
                    this.isOpen = true;
                    this.navId = service.naviagtion.push(function () {
                        _this.close(null);
                    });
                    setTimeout(function () { _this.load(); }, 0);
                };
                Dialog.prototype.title = function (value) {
                    this.cfg.title = value;
                    if (this.dialogScope) {
                        this.dialogScope.title = value;
                    }
                    return this;
                };
                Dialog.prototype.simple = function () {
                    this.cfg.simple = true;
                    if (this.dialogScope) {
                        this.dialogScope.simple = true;
                    }
                    return this;
                };
                Dialog.prototype.icon = function (value) {
                    this.cfg.icon = value;
                    return this;
                };
                Dialog.prototype.message = function (value) {
                    this.cfg.message = value;
                    return this;
                };
                Dialog.prototype.okLabel = function (value) {
                    this.cfg.okLabel = value;
                    return this;
                };
                Dialog.prototype.cancelLabel = function (value) {
                    this.cfg.cancelLabel = value;
                    return this;
                };
                Dialog.prototype.onOk = function (callback) {
                    this.onOkCallback = callback || angular.noop;
                    return this;
                };
                Dialog.prototype.onCancel = function (callback) {
                    this.onCancelCallback = callback || angular.noop;
                    return this;
                };
                Dialog.prototype.onHidden = function (callback) {
                    this.onHiddenCallback = callback || angular.noop;
                    return this;
                };
                Dialog.prototype.okAction = function (action) {
                    this.onOkAction = action || angular.noop;
                    return this;
                };
                Dialog.prototype.closeAction = function (action) {
                    this.onCloseAction = action;
                    return this;
                };
                Dialog.prototype.close = function (params, cb) {
                    var _this = this;
                    if (params === void 0) { params = null; }
                    if (cb === void 0) { cb = null; }
                    if (this.isClose) {
                        return;
                    }
                    if (this.navId > 0) {
                        service.naviagtion.remove(this.navId);
                    }
                    this.isClose = true;
                    if (params) {
                        this.result = params;
                    }
                    if (this.preDialog) {
                        syn.ng.timeout(function () {
                            _this.preDialog.show();
                        });
                        current = this.preDialog;
                    }
                    else {
                        current = null;
                    }
                    var rs = this.result;
                    this.destory();
                    syn.ng.timeout(function () {
                        try {
                            if (cb) {
                                cb();
                            }
                            if (_this.defer) {
                                _this.defer.resolve(rs);
                            }
                            _this.onHiddenCallback(rs || {});
                        }
                        finally {
                            _this.clean();
                        }
                        _this.clean();
                    });
                };
                Dialog.prototype.refresh = function () {
                    if (this.dialogEl) {
                        this.dialogEl.modal("refresh");
                    }
                };
                Dialog.prototype.cancelAction = function (action) {
                    this.onCancelAction = action || angular.noop;
                    return this;
                };
                Dialog.prototype.fullScreen = function (max) {
                    this.cfg.cls = max ? "fullscreen-max" : "fullscreen";
                    this.isFullScreenMax = max;
                    return this;
                };
                Dialog.prototype.resizeToFullScreenMax = function () {
                    this.isFullScreenMax = true;
                    this.dialogEl.removeClass(this.cfg.cls);
                    this.cfg.cls = "fullscreen-max";
                    this.dialogEl.addClass(this.cfg.cls);
                    this.onDialogVisible();
                };
                Dialog.prototype.smallSize = function () {
                    this.cfg.cls = "small";
                    return this;
                };
                Dialog.prototype.largeSize = function () {
                    this.cfg.cls = "large";
                    return this;
                };
                Dialog.prototype.setLoadingStatus = function (status) {
                    this.dialogScope.loading = status;
                    return this;
                };
                Dialog.prototype.max = function () {
                    this.cfg.max = true;
                    return this;
                };
                Dialog.prototype.showError = function (msg, title) {
                    if (title === void 0) { title = ""; }
                    this.dialogScope.error = msg;
                    this.dialogScope.errorTitle = title;
                    this.dialogScope.showError = false;
                };
                Dialog.prototype.hideError = function () {
                    this.dialogScope.showError = false;
                    this.dialogScope.error = "";
                    this.dialogScope.errorTitle = "";
                };
                Object.defineProperty(Dialog.prototype, "isBusy", {
                    get: function () {
                        return this._isBusy;
                    },
                    enumerable: true,
                    configurable: true
                });
                Dialog.prototype.onDialogClose = function (event) {
                    var _this = this;
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    if (this.onCloseAction && !this.onCloseAction()) {
                        return false;
                    }
                    else {
                        syn.ng.timeout(function () {
                            _this.close(null);
                        });
                        return false;
                    }
                };
                Dialog.prototype.clean = function () {
                    this.dialogEl = null;
                    this.dialogScope = null;
                    this.cfg = null;
                    this.params = null;
                    this.onOkCallback = null;
                    this.onCancelCallback = null;
                    this.onHiddenCallback = null;
                    this.onOkAction = null;
                    this.onCancelAction = null;
                    this.defer = null;
                };
                Dialog.prototype.destory = function () {
                    if (this.cfg.max && iframe) {
                        iframe.removeClass("iframe-full-screen");
                    }
                    this.dialogScope.$destroy();
                    this.dialogEl.modal("hide");
                    this.dialogEl.remove();
                };
                Dialog.prototype.onDialogApprove = function (element) {
                    var _this = this;
                    var time = new Date().getTime();
                    var defer = time - this.lastActionTime;
                    this.lastActionTime = time;
                    if (defer < 2000) {
                        return false;
                    }
                    syn.ng.timeout(function () {
                        _this.onAction(_this.onOkAction(), function (rs) {
                            _this.onOkCallback(rs);
                        });
                    });
                    return false;
                };
                Dialog.prototype.onDialogDeny = function (element) {
                    var _this = this;
                    syn.ng.timeout(function () {
                        _this.onAction(_this.onCancelAction(), function (rs) {
                            _this.onCancelCallback(rs);
                        });
                    });
                    return false;
                };
                Dialog.prototype.onDialogVisible = function () {
                    if (this.isFullScreenMax) {
                        this.dialogEl.css("display", "flex");
                    }
                };
                Dialog.prototype.onAction = function (rs, fn) {
                    var _this = this;
                    this._isBusy = true;
                    this.dialogScope.error = null;
                    this.dialogScope.errorTitle = null;
                    if (typeof rs === "boolean") {
                        this._isBusy = false;
                        if (rs) {
                            this.executeAction(fn, rs);
                        }
                        return;
                    }
                    if (rs && angular.isFunction(rs.then)) {
                        this.dialogScope.loading = rs;
                        this.dialogScope.$apply();
                        rs.then(function (value) {
                            _this._isBusy = false;
                            _this.executeAction(fn, value);
                        }, function (error) {
                            _this._isBusy = false;
                            _this.dialogScope.errorTitle = "调用服务出错";
                            error.resolve();
                            if (error.data && error.data.data) {
                                var message = error.data.data.error;
                                message += "," + error.data.data.exception;
                                _this.dialogScope.error = message;
                            }
                            else if (error.code) {
                                var message = error.message || "";
                                if (message.length > 50) {
                                    message = message.substring(0, 48) + "...";
                                }
                                _this.dialogScope.error = "\u9519\u8BEF\u4EE3\u7801:" + error.code + "," + message;
                            }
                        });
                    }
                    else {
                        this._isBusy = false;
                        this.executeAction(fn, rs);
                    }
                };
                Dialog.prototype.executeAction = function (fn, rs) {
                    this.close(null, function () {
                        fn(rs);
                    });
                };
                Dialog.prototype.onPageLoaded = function () {
                };
                Dialog.prototype.loadPage = function () {
                    this.isLoaded = true;
                    var pageId = this.pageId.toString();
                    if (pageId.indexOf("@") == 0) {
                        var tplUrl = syn.app.pageUrl(this.pageId) + ".tpl";
                        var compoentName = pageId.replace("@", "");
                        var tpl = "<" + compoentName + "><" + compoentName + "/>";
                        if (!ng.templateCache.get(tplUrl)) {
                            ng.templateCache.put(tplUrl, tpl);
                        }
                        this.dialogScope.tplUrl = tplUrl;
                        return;
                    }
                    this.dialogScope.pageId = this.pageId;
                };
                Dialog.prototype.getDialogUrl = function () {
                    return syn.app.pageUrl(serviceConfig.dialogPage);
                };
                Dialog.prototype.loadDialog = function () {
                    var _this = this;
                    var dialogUrl = this.getDialogUrl();
                    var isLoaded = this.dialogCache.has(dialogUrl);
                    var dimmer;
                    if (!isLoaded) {
                        dimmer = $(loadingTpl).appendTo(document.body);
                    }
                    return this.dialogCache.getOrElse(dialogUrl, function () {
                        return syn.ng.http.post(dialogUrl, {}).then(function (rs) {
                            return rs.data;
                        });
                    }).then(function (tpl) {
                        count++;
                        _this.dialogEl = angular.element(tpl).appendTo('body');
                        _this.dialogEl.removeClass("active");
                        _this.dialogScope = ng.rootScope.$new(true);
                        _this.dialogEl.data("dlg.instance", _this);
                        _this.dialogEl.data("dlg.params", _this.params);
                        _this.dialogScope.onPageLoaded = function () {
                            _this.onPageLoaded();
                        };
                        _this.dialogScope.isOkButtonEnable = function () {
                            return _this.isOkButtonEnable();
                        };
                        _this.dialogEl.addClass(_this.cfg.cls);
                        ng.compile(_this.dialogEl)(_this.dialogScope);
                        _this.dialogScope.onClose = function (event) { return _this.onDialogClose(event); };
                        _this.dialogScope.params = _this.params;
                        _this.dialogScope.dialog = _this;
                        _this.dialogEl.modal({
                            allowMultiple: true,
                            observeChanges: true,
                            closable: false,
                            duration: 0,
                            onApprove: function (el) { return _this.onDialogApprove(el); },
                            onDeny: function (el) { return _this.onDialogDeny(el); },
                            onVisible: function () { return _this.onDialogVisible(); }
                        });
                    }).finally(function () {
                        if (!isLoaded) {
                            dimmer.remove();
                        }
                    });
                };
                Dialog.prototype.load = function () {
                    var _this = this;
                    if (this.preDialog) {
                        this.preDialog.hide();
                    }
                    var url = location.origin + location.pathname;
                    this.loadDialog().then(function () {
                        angular.merge(_this.dialogScope, _this.cfg);
                        _this.dialogScope.okLabel = function () {
                            return _this.cfg.okLabel;
                        };
                        _this.dialogScope.cancelLabel = function () {
                            return _this.cfg.cancelLabel;
                        };
                        _this.loadContent();
                    });
                };
                Dialog.prototype.loadContent = function () {
                    if (this.cfg.max && iframe) {
                        iframe.addClass("iframe-full-screen");
                    }
                    this.dialogEl.modal("show");
                    this.loadPage();
                };
                Dialog.prototype.show = function () {
                    if (this.isClose)
                        return;
                    this.dialogEl.addClass("visible active").removeClass("hidden");
                    this.dialogEl.css("display", "block");
                    this.dialogEl.modal("show").modal("show dimmer");
                };
                Dialog.prototype.hide = function () {
                    this.dialogEl.removeClass("visible active").addClass("hidden");
                    this.dialogEl.css("display", "none");
                };
                Dialog.prototype.promise = function () {
                    if (!this.defer) {
                        this.defer = syn.ng.q.defer();
                    }
                    return this.defer.promise;
                };
                return Dialog;
            }());
            service.Dialog = Dialog;
            var AlertDialog = (function (_super) {
                __extends(AlertDialog, _super);
                function AlertDialog(preDialog) {
                    return _super.call(this, '', {}, false, preDialog) || this;
                }
                AlertDialog.prototype.getDialogUrl = function () {
                    return syn.app.pageUrl(serviceConfig.alertPage);
                };
                AlertDialog.prototype.loadContent = function () {
                    this.dialogScope.title = this.cfg.title || '提示';
                    this.dialogEl.modal("show");
                };
                return AlertDialog;
            }(Dialog));
            var ConfirmDialog = (function (_super) {
                __extends(ConfirmDialog, _super);
                function ConfirmDialog(preDialog) {
                    return _super.call(this, preDialog) || this;
                }
                ConfirmDialog.prototype.getDialogUrl = function () {
                    return syn.app.pageUrl(serviceConfig.confirmPage);
                };
                return ConfirmDialog;
            }(AlertDialog));
            var DialogService = (function () {
                function DialogService(synwork) {
                    this.cfg = serviceConfig;
                    ng = synwork.ng;
                    syn = synwork;
                    this.cfg.dialogPage = 1060416;
                    this.cfg.alertPage = 1027252;
                    this.cfg.confirmPage = 1060417;
                    if (window.parent && window.parent !== window) {
                        try {
                            window.parent['$']("iframe").each(function (i, el) {
                                if (el.contentWindow === window) {
                                    iframe = window.parent['$'](el);
                                }
                            });
                        }
                        catch (e) { }
                    }
                }
                DialogService.prototype.init = function () {
                };
                Object.defineProperty(DialogService.prototype, "current", {
                    get: function () {
                        return current;
                    },
                    enumerable: true,
                    configurable: true
                });
                DialogService.prototype.newDialog = function (pageIdOrName, params, cache) {
                    if (cache === void 0) { cache = true; }
                    var dlg = new Dialog(pageIdOrName, params, cache, current);
                    return this.openDialog(dlg);
                };
                DialogService.prototype.openDialog = function (dlg) {
                    if (current) {
                        if (current.isLoaded) {
                            current = dlg;
                            current.open();
                        }
                    }
                    else {
                        current = dlg;
                        current.open();
                    }
                    return dlg;
                };
                DialogService.prototype.newAlertDialog = function () {
                    var dlg = new AlertDialog(current);
                    return this.openDialog(dlg);
                };
                DialogService.prototype.newConfirmDialog = function () {
                    var dlg = new ConfirmDialog(current);
                    return this.openDialog(dlg);
                };
                DialogService.prototype.openPage = function (pageIdOrName, params, cache) {
                    if (cache === void 0) { cache = true; }
                    return this.newDialog(pageIdOrName, params, cache);
                };
                DialogService.prototype.openSimplePage = function (pageIdOrName, params, cache) {
                    if (cache === void 0) { cache = true; }
                    return this.newDialog(pageIdOrName, params, cache).simple();
                };
                DialogService.prototype.openSavePage = function (pageIdOrName, params, cache) {
                    if (cache === void 0) { cache = true; }
                    return this.openPage(pageIdOrName, params, cache).okLabel("保存");
                };
                DialogService.prototype.openInfo = function (msg, title) {
                    return this.newAlertDialog().message(msg).title(title).icon("info circle");
                };
                DialogService.prototype.openError = function (msg, title) {
                    return this.newAlertDialog().message(msg).title(title || '错误').icon('red remove circle');
                };
                DialogService.prototype.openSuccess = function (msg, title) {
                    return this.newAlertDialog().message(msg).title(title || '成功').icon('green check circle');
                };
                DialogService.prototype.openWarn = function (msg, title) {
                    return this.newAlertDialog().message(msg).title(title || '警告').icon('yellow warning sign');
                };
                DialogService.prototype.openConfirm = function (msg, title) {
                    return this.newConfirmDialog().message(msg).title(title).icon('help circle');
                };
                DialogService.prototype.modalPage = function (pageIdOrName, params) {
                    var modal = new ModalPage(pageIdOrName, params);
                    return modal;
                };
                return DialogService;
            }());
            service.DialogService = DialogService;
            var DialogController = (function () {
                function DialogController($scope, $element) {
                    var _this = this;
                    if ($element === void 0) { $element = null; }
                    this.scope = $scope;
                    this.el = $element;
                    this.dlg = $scope['dialog'];
                    this.params = this.dlg.params;
                    this.dlg.okAction(function () {
                        return _this.onOk();
                    });
                    this.dlg.cancelAction(function () {
                        return _this.onCancel();
                    });
                    this.dlg.closeAction(function () {
                        return _this.onClose();
                    });
                }
                DialogController.prototype.close = function (params) {
                    if (params === void 0) { params = null; }
                    this.dlg.close(params);
                };
                DialogController.prototype.onOk = function () {
                };
                DialogController.prototype.onCancel = function () {
                };
                DialogController.prototype.onClose = function () {
                    return true;
                };
                return DialogController;
            }());
            service.DialogController = DialogController;
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork_1.framework || (synwork_1.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var Error = (function () {
                function Error(code, message, data, isHttpError) {
                    this.code = code;
                    this.message = message;
                    this.data = data;
                    this.isHttpError = isHttpError;
                    this._isResolved = false;
                }
                Error.prototype.resolve = function () {
                    this._isResolved = true;
                };
                Error.prototype.isResolved = function () {
                    return this._isResolved;
                };
                return Error;
            }());
            service.Error = Error;
            function httpInterceptorFactory(syn) {
                var ng = syn.ng;
                return function ($q) {
                    function showCommonMessage(msg) {
                        console.warn(msg);
                    }
                    return {
                        'request': function (config) {
                            config['sendTime'] = new Date().getTime();
                            return config;
                        },
                        'requestError': function (rejection) {
                            console.log("http request error:" + rejection);
                            return rejection;
                        },
                        'response': function (response) {
                            return response;
                        },
                        'responseError': function (rejection) {
                            if (rejection.config && rejection.config['ignoreError']) {
                                return ng.q.reject(rejection);
                            }
                            var message = "";
                            if (rejection.status == -1) {
                                syn.toast.show('网络连接失败！');
                                message = "\u7F51\u7EDC\u65E0\u6CD5\u8FDE\u63A5:" + rejection.config.url;
                                console.warn(message);
                            }
                            else if (rejection.status == 0) {
                                message = "\u7F51\u7EDC\u65E0\u6CD5\u8FDE\u63A5\u6216\u88AB\u6D4F\u89C8\u5668\u53D6\u6D88:" + rejection.config.url;
                                console.warn(message);
                            }
                            else if (rejection.status == 400) {
                                message = "400错误，HTTP请求格式错误！";
                            }
                            else if (rejection.status == 401) {
                                if (syn.app.isStandaloneCookie) {
                                    syn.app.clientExpire();
                                }
                                return ng.q.reject(rejection);
                            }
                            else if (rejection.status == 403) {
                                message = "403错误,禁止访问 ！";
                            }
                            else if (rejection.status == 404) {
                                message = "404\u9519\u8BEF\uFF0C\u8BBF\u95EE\u7684url\uFF1A\u2018" + rejection.config.url + "\u2019\u4E0D\u5B58\u5728";
                            }
                            else if (rejection.status == 405) {
                                message = "405错误：用来访问本页面的 HTTP 谓词不被允许（方法不被允许）！";
                            }
                            else if (rejection.status == 406) {
                                message = "406错误：客户端浏览器不接受所请求页面的 MIME 类型！";
                            }
                            else if (rejection.status == 415) {
                                message = "415错误，不支持的媒体类型！";
                            }
                            else if (rejection.status == 503) {
                                message = "503错误：服务不可用！";
                            }
                            else if (rejection.status == 502) {
                                syn.toast.show('服务不可用');
                                var time = (new Date().getTime() - rejection.config['sendTime']) / 1000;
                                message = "\u8C03\u7528\u670D\u52A1'" + rejection.config.url + "'\u8D85\u65F6\uFF0C\u5DF2\u8D85\u8FC7" + time + "\u79D2\u6CA1\u6709\u54CD\u5E94\uFF01";
                                console.error(message);
                            }
                            else if (rejection.status == 500) {
                                message = "\u8C03\u7528\u670D\u52A1'" + rejection.config.url + "'\u51FA\u9519:" + rejection.data.stacktrace;
                            }
                            else {
                                message = rejection.status + "\u9519\u8BEF\uFF1A" + rejection.data;
                            }
                            var error = new Error("responseError", message, rejection, true);
                            rejection['error'] = error;
                            error.status = rejection.status;
                            error.statusText = rejection.statusText;
                            var rs = $q.reject(error);
                            setTimeout(function () {
                                if (!error.isResolved()) {
                                    if (rejection.status == 500) {
                                        rejection.data.status = rejection.status;
                                        rejection.data.url = rejection.config.url;
                                        console.error(message);
                                        syn.dlg.openSimplePage(1055048, rejection.data);
                                    }
                                    else if (rejection.status == 0) {
                                        if (rejection.config['showNetError']) {
                                            showCommonMessage(message);
                                        }
                                    }
                                    else {
                                        showCommonMessage(message);
                                    }
                                }
                            }, 500);
                            return rs;
                        }
                    };
                };
            }
            service.httpInterceptorFactory = httpInterceptorFactory;
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var elIdCount = 0;
            var busyCache = {};
            var BusyConfig = (function () {
                function BusyConfig(target, text, delay, modal, dimmer) {
                    if (text === void 0) { text = ''; }
                    if (delay === void 0) { delay = 0; }
                    this.target = target;
                    this.text = text;
                    this.delay = delay;
                    this.modal = modal;
                    this.dimmer = dimmer;
                }
                return BusyConfig;
            }());
            service.BusyConfig = BusyConfig;
            function nextId() {
                elIdCount++;
                return elIdCount.toString();
            }
            var BusyInstance = (function () {
                function BusyInstance(target) {
                    var _this = this;
                    this.target = target;
                    this.isBusy = false;
                    this.busyItems = [];
                    this.dimmerItems = [];
                    this.isButton = target.hasClass("ui button");
                    this.subject = new Rx.Subject();
                    this.subject
                        .switchMap(function () { return Rx.Observable.forkJoin(_this.busyItems); })
                        .subscribe(function () { return _this.disposeLoading(); });
                }
                BusyInstance.prototype.loadingTpl = function (text) {
                    return "<div class='ui active busy'>\n                        <div class='ui active text loader'>" + text + "</div>\n                    </div>";
                };
                BusyInstance.prototype.disposeLoading = function () {
                    this.isBusy = false;
                    this.busyItems = [];
                    this.dimmerItems.forEach(function (it) {
                        it.remove();
                    });
                    this.dimmerItems = [];
                    if (this.isButton) {
                        this.target.removeClass("loading busy");
                    }
                    else {
                        this.loadingEl.remove();
                    }
                };
                BusyInstance.prototype.createLoading = function () {
                    if (this.isButton) {
                        this.target.addClass("loading busy");
                    }
                    else {
                        this.loadingEl = $(this.loadingTpl("")).appendTo(this.target);
                    }
                };
                BusyInstance.prototype.next = function (cfg, obs) {
                    var _this = this;
                    if (!this.isBusy) {
                        this.isBusy = true;
                        this.createLoading();
                    }
                    if (this.loadingEl) {
                        $("div.ui.active.text.loader", this.loadingEl).text(cfg.text || '');
                        if (cfg.modal) {
                            this.loadingEl.addClass("inverted dimmer");
                        }
                    }
                    if (cfg.dimmer) {
                        $(cfg.dimmer).each(function (index, el) {
                            _this.dimmerItems.push($('<div class="ui active busy inverted dimmer"></div>').appendTo(el));
                        });
                    }
                    this.busyItems.push(obs.catch(function () { return Rx.Observable.of('catch error!'); }));
                    this.subject.next();
                };
                return BusyInstance;
            }());
            function busy(obs, cfg) {
                var target = $("body");
                if (cfg.target) {
                    if (typeof cfg.target == 'string') {
                        target = $(cfg.target);
                    }
                    else if (cfg.target instanceof jQuery) {
                        target = $(cfg.target);
                    }
                    else if (cfg.target.currentTarget) {
                        target = $(cfg.target.currentTarget);
                    }
                }
                if (target.length == 0) {
                    console.warn("not found element " + cfg.target);
                    return;
                }
                if (target[0].tagName == "BODY") {
                    if (cfg.modal == undefined) {
                        cfg.modal = false;
                    }
                }
                else {
                    if (cfg.modal == undefined) {
                        cfg.modal = true;
                    }
                }
                if (typeof obs.then == 'function') {
                    obs = Rx.Observable.fromPromise(obs);
                }
                target.each(function (index, el) {
                    var jqEl = $(el);
                    var busyId = jqEl.attr("busy");
                    if (!busyId) {
                        busyId = nextId();
                        jqEl.attr("busy", busyId);
                    }
                    var instance = busyCache[busyId];
                    if (!instance) {
                        instance = new BusyInstance(jqEl);
                        busyCache[busyId] = instance;
                    }
                    instance.next(cfg, obs);
                });
            }
            service.busy = busy;
            function initBusy() {
                if (window['Rx']) {
                    Rx.Observable.prototype['busy'] = function (cfg) {
                        var input = this;
                        busy(input, cfg || new BusyConfig(null, null, 0, undefined, null));
                        return input;
                    };
                }
            }
            initBusy();
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var CrossStorageProvider = (function () {
                function CrossStorageProvider() {
                }
                CrossStorageProvider.prototype.$get = function () {
                    return new CrossStorageClient('http://www.95work.com/1097314');
                };
                return CrossStorageProvider;
            }());
            service.CrossStorageProvider = CrossStorageProvider;
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var Binding = (function () {
                function Binding(sourceExpr, targetExpr, context) {
                    var _this = this;
                    this.sourceExpr = sourceExpr;
                    this.targetExpr = targetExpr;
                    this.isCondition = false;
                    this.compiledTarget = framework.syn.ng.parse(targetExpr);
                    this.scope = context.scope.$new();
                    context.scope.$on("$destroy", function () {
                        _this.scope.$destroy();
                    });
                    context.scope.$watch(sourceExpr, function (newValue, oldValue) {
                        if (_this.isCondition) {
                            if (newValue) {
                                _this.scope['$value'] = newValue;
                                _this.compiledTarget(_this.scope, { '$value': newValue });
                            }
                            return;
                        }
                        if (newValue !== undefined) {
                            _this.scope["$value"] = newValue;
                            _this.compiledTarget.assign(_this.scope, newValue);
                        }
                    });
                }
                return Binding;
            }());
            service.Binding = Binding;
            var BindingContext = (function () {
                function BindingContext(scope) {
                    this.scope = scope;
                }
                BindingContext.prototype.bind = function (sourceExpr, targetExpr) {
                    return new Binding(sourceExpr, targetExpr, this);
                };
                BindingContext.prototype.on = function (sourceExpr, targetExpr) {
                    var binding = new Binding(sourceExpr, targetExpr, this);
                    binding.isCondition = true;
                    return binding;
                };
                BindingContext.prototype.bindOnce = function (sourceExpr, targetExpr) {
                };
                return BindingContext;
            }());
            service.BindingContext = BindingContext;
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var im2;
            (function (im2) {
                var log = synwork.log.LogFactory.get("im");
                var EventListener = (function () {
                    function EventListener(emitter, event, listener, once) {
                        this.emitter = emitter;
                        this.event = event;
                        this.listener = listener;
                        this.once = once;
                    }
                    EventListener.prototype.off = function () {
                        this.emitter.removeListener(this.event, this.listener);
                    };
                    return EventListener;
                }());
                var EventEmitter = (function () {
                    function EventEmitter() {
                        this.events = {};
                    }
                    EventEmitter.prototype.on = function (event, listener) {
                        return this.addListener(event, listener, false);
                    };
                    EventEmitter.prototype.once = function (event, listener) {
                        return this.addListener(event, listener, true);
                    };
                    EventEmitter.prototype.addListener = function (event, listener, once) {
                        if (once === void 0) { once = false; }
                        var list = this.events[event];
                        if (!list) {
                            this.events[event] = list = [];
                        }
                        var eventListener = new EventListener(this, event, listener, once);
                        list.push(eventListener);
                        return eventListener;
                    };
                    EventEmitter.prototype.off = function (event, listener) {
                        return this.removeListener(event, listener);
                    };
                    EventEmitter.prototype.listenerCount = function (type) {
                        var list = this.events[type];
                        return list ? list.length : 0;
                    };
                    EventEmitter.prototype.removeListener = function (event, listener) {
                        var list = this.events[event];
                        var ls = _.find(list, { listener: listener });
                        _.remove(list, ls);
                        return this;
                    };
                    EventEmitter.prototype.removeAllListeners = function (event) {
                        if (event) {
                            delete this.events[event];
                        }
                        else {
                            this.events = {};
                        }
                        return this;
                    };
                    EventEmitter.prototype.eventNames = function () {
                        var names = [];
                        for (var key in this.events) {
                            names.push(key);
                        }
                        return names;
                    };
                    EventEmitter.prototype.listeners = function (event) {
                        return this.events[event] || [];
                    };
                    EventEmitter.prototype.emit = function (event) {
                        var args = [];
                        for (var _i = 1; _i < arguments.length; _i++) {
                            args[_i - 1] = arguments[_i];
                        }
                        var list = this.events[event];
                        if (!list)
                            return false;
                        var onceList = [];
                        list.forEach(function (it) {
                            var listener = it.listener;
                            try {
                                listener.apply(null, args);
                            }
                            catch (error) {
                                console.error(error);
                            }
                            if (it.once) {
                                onceList.push(it);
                            }
                        });
                        onceList.forEach(function (it) {
                            it.off();
                        });
                        return true;
                    };
                    return EventEmitter;
                }());
                im2.EventEmitter = EventEmitter;
                var MessageRequest = (function () {
                    function MessageRequest(params) {
                        this.params = params;
                    }
                    MessageRequest.prototype.execute = function (socket) {
                        socket.emit.apply(socket, this.params);
                    };
                    return MessageRequest;
                }());
                var MessgeSocketClient = (function () {
                    function MessgeSocketClient(connect) {
                        var _this = this;
                        if (connect === void 0) { connect = false; }
                        this.pageList = [];
                        this.requestList = [];
                        this.server = "wss://w.95work.com:4888";
                        this.notifyChannelChangeFn = _.debounce(function () {
                            _this.doNotifyChannelChange();
                        }, 200);
                        var nsp = framework.syn.app.isLogin ? 'org-' + framework.syn.app.orgRefId : 'guest';
                        require(["http://lib.95work.com/lib/sockt.io-2.2.0/socket.io.js"], function (io) {
                            var url = _this.server + "/" + nsp + "?uid=" + framework.syn.app.userRefId + "&dept=" + framework.syn.app.deptRefId;
                            log.debug("connect to message server:" + url);
                            _this.socket = io(url, { transports: ['websocket'], autoConnect: connect });
                            _this.init();
                        });
                    }
                    MessgeSocketClient.prototype.connect = function () {
                        this.socket.connect();
                    };
                    MessgeSocketClient.prototype.close = function () {
                        this.socket.close();
                    };
                    MessgeSocketClient.prototype.init = function () {
                        var _this = this;
                        this.socket.on("message", this.onMessage.bind(this));
                        this.socket.on("connect", function () {
                            log.debug('connect success!');
                            _this.doNotifyChannelChange();
                            _this.execute();
                        });
                        this.socket.on("disconnect", function () {
                            log.debug("message server disconnect!");
                        });
                        this.socket.on("connect_error", function (error) {
                            log.error("connect_error:" + error);
                        });
                        this.socket.on("connect_timeout", function (error) {
                            log.error("connect_timeout:" + error);
                        });
                        this.socket.on("reconnect", function () {
                            log.warn("reconnect message server!");
                            var msg = { channel: '$reconnect' };
                            _this.onMessage(msg);
                        });
                        this.socket.on("reconnect_attempt", function () {
                            log.warn("reconnect_attempt");
                        });
                        this.socket.on("reconnect_error", function (error) {
                            log.error("reconnect_error:" + error);
                        });
                        this.socket.on("msg", function (msg) {
                            _this.onMessage(msg);
                        });
                    };
                    MessgeSocketClient.prototype.onMessage = function (msg) {
                        log.debug("on message:" + JSON.stringify(msg));
                        msg.receiveTime = new Date();
                        this.dispatch(msg);
                    };
                    MessgeSocketClient.prototype.dispatch = function (msg) {
                        this.pageList.forEach(function (page) {
                            page.dispatch(msg);
                        });
                    };
                    MessgeSocketClient.prototype.addPage = function (client) {
                        this.pageList.push(client);
                    };
                    MessgeSocketClient.prototype.removePage = function (client) {
                        _.remove(this.pageList, client);
                    };
                    MessgeSocketClient.prototype.doNotifyChannelChange = function () {
                        var channelMap = {};
                        this.pageList.forEach(function (page) {
                            page.listchannel().forEach(function (channel) {
                                channelMap[channel] = channel;
                            });
                        });
                        this.channelList = Object.keys(channelMap);
                        log.debug("on channel change:" + this.channelList);
                        if (this.socket && this.socket.connected) {
                            this.pushRequest(['updateChannel', this.channelList]);
                        }
                    };
                    MessgeSocketClient.prototype.notifyChannelChange = function () {
                        this.notifyChannelChangeFn();
                    };
                    MessgeSocketClient.prototype.pushRequest = function (params) {
                        var request = new MessageRequest(params);
                        this.requestList.push(request);
                        this.execute();
                    };
                    MessgeSocketClient.prototype.send = function (channel, content) {
                        this.sendMessage(channel, content, false, null, null);
                    };
                    MessgeSocketClient.prototype.broadcast = function (channel, content) {
                        this.sendMessage(channel, content, true, null, null);
                    };
                    MessgeSocketClient.prototype.sendToUser = function (channel, content, toUser) {
                        this.sendMessage(channel, content, false, toUser, null);
                    };
                    MessgeSocketClient.prototype.sendToDept = function (channel, content, toDept) {
                        this.sendMessage(channel, content, false, null, toDept);
                    };
                    MessgeSocketClient.prototype.broadcastToDept = function (channel, content, toDept) {
                        this.sendMessage(channel, content, true, null, toDept);
                    };
                    MessgeSocketClient.prototype.sendMessage = function (channel, content, broadcast, toUser, toDept) {
                        var msg = {
                            content: content,
                            channel: channel
                        };
                        this.pushRequest(['send', {
                                msg: msg,
                                toUser: toUser,
                                toDept: toDept,
                                broadcast: broadcast
                            }]);
                    };
                    MessgeSocketClient.prototype.execute = function () {
                        if (this.socket) {
                            while (this.requestList.length > 0) {
                                var request = this.requestList.pop();
                                request.execute(this.socket);
                            }
                        }
                    };
                    return MessgeSocketClient;
                }());
                var MessageClientPage = (function () {
                    function MessageClientPage(window, socketClient) {
                        var _this = this;
                        this.window = window;
                        this.socketClient = socketClient;
                        this.clientList = [];
                        window.addEventListener("unload", function () {
                            _this.destory();
                        });
                        this.socketClient.addPage(this);
                    }
                    MessageClientPage.prototype.dispatch = function (msg) {
                        var _this = this;
                        framework.syn.ng.timeout(function () {
                            _this.clientList.forEach(function (client) {
                                client.dispatch(msg);
                            });
                        });
                    };
                    MessageClientPage.prototype.destory = function () {
                        this.clientList.concat([]).forEach(function (it) {
                            it.destory();
                        });
                    };
                    MessageClientPage.prototype.addClient = function (client) {
                        this.clientList.push(client);
                    };
                    MessageClientPage.prototype.removeClient = function (scope) {
                        _.remove(this.clientList, scope);
                    };
                    MessageClientPage.prototype.listchannel = function () {
                        var list = [];
                        this.clientList.forEach(function (client) {
                            list = list.concat(client.em.eventNames());
                        });
                        return list;
                    };
                    return MessageClientPage;
                }());
                var MessageClient = (function () {
                    function MessageClient(scope, page) {
                        var _this = this;
                        this.scope = scope;
                        this.page = page;
                        this.em = new EventEmitter();
                        if (scope) {
                            this.scope.$on('destory', function () {
                                _this.destory();
                            });
                        }
                        this.page.addClient(this);
                    }
                    Object.defineProperty(MessageClient.prototype, "socketClient", {
                        get: function () {
                            return this.page.socketClient;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    MessageClient.prototype.send = function (channel, content) {
                        this.socketClient.send(channel, content);
                    };
                    MessageClient.prototype.broadcast = function (channel, content) {
                        this.socketClient.broadcast(channel, content);
                    };
                    MessageClient.prototype.sendToUser = function (channel, content, toUser) {
                        this.socketClient.sendToUser(channel, content, toUser || [framework.syn.app.userRefId]);
                    };
                    MessageClient.prototype.sendToDept = function (channel, content, toDept) {
                        this.socketClient.sendToDept(channel, content, toDept || [framework.syn.app.deptRefId]);
                    };
                    MessageClient.prototype.broadcastToDept = function (channel, content, toDept) {
                        this.socketClient.broadcastToDept(channel, content, toDept || [framework.syn.app.deptRefId]);
                    };
                    MessageClient.prototype.on = function (event, listener) {
                        var socketClient = this.socketClient;
                        var eventLisener = this.em.on(event, listener);
                        socketClient.notifyChannelChange();
                        return function () {
                            eventLisener.off();
                            socketClient.notifyChannelChange();
                        };
                    };
                    MessageClient.prototype.once = function (channel, listener) {
                        var fn = this.on(channel, function (msg) {
                            try {
                                listener(msg);
                            }
                            catch (error) {
                                console.error(error);
                            }
                            fn();
                        });
                        return fn;
                    };
                    MessageClient.prototype.destory = function () {
                        this.page.removeClient(this);
                        this.em.removeAllListeners();
                        this.socketClient.notifyChannelChange();
                    };
                    MessageClient.prototype.dispatch = function (msg) {
                        this.em.emit(msg.channel, msg);
                    };
                    MessageClient.prototype.connect = function () {
                        this.page.socketClient.connect();
                    };
                    return MessageClient;
                }());
                var client;
                var page;
                function factory(scope, connect) {
                    if (scope === void 0) { scope = null; }
                    if (connect === void 0) { connect = false; }
                    if (!client) {
                        if (window.top === window) {
                            client = new MessgeSocketClient(connect);
                            window['socketClient'] = client;
                        }
                        else {
                            client = window.top['socketClient'];
                        }
                    }
                    if (!page) {
                        page = new MessageClientPage(window, client);
                    }
                    var messageClient = new MessageClient(scope, page);
                    return messageClient;
                }
                im2.factory = factory;
            })(im2 = service.im2 || (service.im2 = {}));
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var converter;
            (function (converter) {
                var ImageSetting = (function () {
                    function ImageSetting() {
                    }
                    return ImageSetting;
                }());
                converter.ImageSetting = ImageSetting;
                var ViewPort = (function () {
                    function ViewPort() {
                    }
                    return ViewPort;
                }());
                converter.ViewPort = ViewPort;
                var HtmlConveter = (function () {
                    function HtmlConveter() {
                        this.host = 'w.95work.com:4998';
                    }
                    HtmlConveter.prototype.urlToImage = function (url, setting) {
                        return this.callAction(function (socket) {
                            socket.emit('urlToImage', url, setting || {});
                        });
                    };
                    HtmlConveter.prototype.htmlToImage = function (html, setting) {
                        return this.callAction(function (socket) {
                            socket.emit('htmlToImage', html, setting || {});
                        });
                    };
                    HtmlConveter.prototype.urlToPdf = function (url, setting) {
                        return this.callAction(function (socket) {
                            socket.emit('urlToPdf', url, setting || {});
                        });
                    };
                    HtmlConveter.prototype.htmlToPdf = function (html, setting) {
                        return this.callAction(function (socket) {
                            socket.emit('htmlToPdf', html, setting || {});
                        });
                    };
                    HtmlConveter.prototype.callAction = function (fn) {
                        var _this = this;
                        return framework.syn.ng.q(function (resolve, reject) {
                            require(["http://lib.95work.com/lib/sockt.io-2.2.0/socket.io.js"], function (io) {
                                var socket = io("wss://" + _this.host, { reconnection: false, transports: ['websocket'] });
                                socket.on("connect", function () {
                                    fn(socket);
                                });
                                socket.on("result", function (success, id, error) {
                                    socket.disconnect();
                                    var url = id ? "https://" + _this.host + "/file/" + id : null;
                                    resolve({ success: success, url: url, error: error });
                                });
                                socket.on('connect_error', function (msg) {
                                    resolve({ success: false, error: msg });
                                });
                                socket.on('connect_timeout', function (msg) {
                                    resolve({ success: false, error: msg });
                                });
                                socket.on('error', function (msg) {
                                    resolve({ success: false, error: msg });
                                });
                            });
                        });
                    };
                    return HtmlConveter;
                }());
                converter.HtmlConveter = HtmlConveter;
            })(converter = service.converter || (service.converter = {}));
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var cache;
            (function (cache_1) {
                var CacheItem = (function () {
                    function CacheItem(time, value) {
                        this.time = time;
                        this.value = value;
                    }
                    return CacheItem;
                }());
                var Cache = (function () {
                    function Cache(name, global) {
                        this.name = name;
                        this.wait = {};
                        this.cfg = {
                            liveTime: 0
                        };
                        var key = "$cache$." + name;
                        if (global) {
                            this.cache = framework.syn.global.get(key);
                            if (!this.cache) {
                                this.cache = framework.syn.global.newObject();
                                framework.syn.global.set(key, this.cache);
                            }
                        }
                        else {
                            this.cache = {};
                        }
                    }
                    Cache.prototype.config = function (cfg) {
                        this.cfg = cfg;
                    };
                    Cache.prototype.get = function (key) {
                        var item = this.cache[key];
                        if (item) {
                            if (this.cfg.liveTime > 0) {
                                var time = new Date();
                                var diff = time.getTime() - item.time.getTime();
                                if (diff / 1000 > this.cfg.liveTime) {
                                    delete this.cache[key];
                                    item = null;
                                }
                            }
                        }
                        return item ? item.value : null;
                    };
                    Cache.prototype.has = function (key) {
                        return this.cache[key] !== undefined;
                    };
                    Cache.prototype.getOrElse = function (key, fn) {
                        var _this = this;
                        var defer = framework.syn.ng.q.defer();
                        var value = this.get(key);
                        if (!value) {
                            if (!this.wait[key]) {
                                this.wait[key] = defer.promise;
                                fn().then(function (rs) {
                                    _this.put(key, rs);
                                    defer.resolve(rs);
                                }).catch(function () {
                                    defer.reject();
                                }).finally(function () {
                                    delete _this.wait[key];
                                });
                            }
                            else {
                                this.wait[key].then(function (rs) {
                                    defer.resolve(rs);
                                }).catch(function () {
                                    defer.reject();
                                });
                            }
                        }
                        else {
                            defer.resolve(value);
                        }
                        return defer.promise;
                    };
                    Cache.prototype.put = function (key, value) {
                        var item = this.cache[key];
                        if (item) {
                            item.time = new Date();
                            item.value = value;
                        }
                        else {
                            item = new CacheItem(new Date(), value);
                            this.cache[key] = item;
                        }
                    };
                    return Cache;
                }());
                cache_1.Cache = Cache;
                var CacheManager = (function () {
                    function CacheManager() {
                        this.cacheMap = new Map();
                    }
                    CacheManager.prototype.getCache = function (name, global) {
                        if (global === void 0) { global = true; }
                        var cache = this.cacheMap[name];
                        if (!cache) {
                            cache = new Cache(name, global);
                            this.cacheMap[name] = cache;
                        }
                        return cache;
                    };
                    return CacheManager;
                }());
                cache_1.CacheManager = CacheManager;
            })(cache = service.cache || (service.cache = {}));
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var component2;
            (function (component2) {
                var LogFactory = synwork.log.LogFactory;
                var log = LogFactory.get('comp');
                var ComponentInstance = (function () {
                    function ComponentInstance(component, scope, element, linkFn) {
                        this.component = component;
                        this.scope = scope;
                        this.element = element;
                        this.linkFn = linkFn;
                    }
                    ComponentInstance.prototype.dispose = function () {
                        this.scope.$destroy();
                        this.element.remove();
                        this.scope = this.element = this.link = null;
                    };
                    ComponentInstance.prototype.link = function (fn) {
                        if (fn) {
                            fn(this.element);
                        }
                        this.linkFn(this.scope);
                        return this;
                    };
                    return ComponentInstance;
                }());
                component2.ComponentInstance = ComponentInstance;
                var Component = (function () {
                    function Component(id, alias, type, pageInfo, factory) {
                        this.id = id;
                        this.alias = alias;
                        this.type = type;
                        this.pageInfo = pageInfo;
                        this.factory = factory;
                        this.tplInfo = {};
                        this.isInit = false;
                    }
                    Object.defineProperty(Component.prototype, "name", {
                        get: function () {
                            return this.alias || this.id;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Component.prototype.init = function () {
                        this.styleId = "component_" + this.id + ".css";
                        this.componentName = "component_" + this.toLowerLine(this.id.toString()).replace(/\./g, "");
                        this.componentHumpName = this.toHump(this.componentName);
                        this.controllerName = "component_" + this.id + "_controller";
                        this.style = this.pageInfo.style[this.id];
                        this.updateComponentType();
                    };
                    Component.prototype.updateComponentType = function () {
                        this.isComponent = this.type == "component" || this.type == "directive";
                    };
                    Component.prototype.register = function () {
                        log.debug("component " + this.toString() + " registed");
                        this.updateComponentType();
                        if (this.type == "component") {
                            this.registerComponent();
                            return;
                        }
                        if (this.type == "controller") {
                            this.registerController();
                            return;
                        }
                        if (this.type == 'directive') {
                            this.registerDirective();
                            return;
                        }
                    };
                    Component.prototype.toString = function () {
                        return '[' + ["type:" + this.type,
                            "id:" + this.id,
                            this.alias ? "alias:" + this.alias : ''].filter(function (it) { return it != ''; })
                            .join(',') + ']';
                    };
                    Component.prototype.registerComponent = function () {
                        var _this = this;
                        var opt = this.componentOptions;
                        if (!opt.name) {
                            !opt.controller && (opt.controller = this.factory);
                            opt.name = this.componentHumpName;
                            opt.template = this.pageInfo.tpl;
                            var tplEl = $(this.pageInfo.tpl);
                            if (opt.inlineTpl) {
                                var tempalte = $('template', tplEl);
                                if (tempalte.length > 0) {
                                    tempalte.each(function (index, element) {
                                        var name = element.getAttribute('name');
                                        _this.tplInfo[name] = element.innerHTML;
                                    });
                                    tempalte.remove();
                                    opt.template = tplEl[0].outerHTML;
                                }
                            }
                            if (opt.nowrap) {
                                var style = tplEl.attr("style");
                                this.cls = tplEl.attr('class');
                                opt.template = tplEl.html();
                                if (style) {
                                    style = "component_" + this.id + "{" + style + "}";
                                    $("<style type=\"text/css\" id=\"" + this.styleId + "\">" + style + "</style>").appendTo($('head'));
                                }
                                tplEl.remove();
                            }
                            this.tplInfo['_main_'] = opt.template;
                            this.factory.prototype['$component$'] = this;
                        }
                        framework.syn.core.registerComponent2(opt);
                    };
                    Component.prototype.registerDirective = function () {
                        var _this = this;
                        var directiveName = this.componentHumpName;
                        if (!this.factory) {
                            this.directiveOptions.template = this.pageInfo.tpl;
                            this.directiveOptions.replace = true;
                            this.directiveOptions.restrict = 'E';
                        }
                        else {
                            directiveName = this.directiveOptions.name || directiveName;
                            this.directiveOptions.controller = this.factory;
                        }
                        if (this.factory) {
                            this.factory.prototype['$component$'] = this;
                        }
                        framework.syn.ng.compileProvider.directive(directiveName, function () { return _this.directiveOptions; });
                    };
                    Component.prototype.registerController = function () {
                        var tpl = $("<div>" + this.pageInfo.tpl + "</div>");
                        var controllerName = this.controllerName;
                        if (this.controllerAs) {
                            controllerName += ' as ' + this.controllerAs;
                        }
                        $("div[page-id = \"" + this.id + "\"]", tpl).attr("ng-controller", controllerName);
                        this.pageInfo.tpl = tpl[0].innerHTML;
                        tpl.remove();
                        framework.syn.ng.controllerProvider.register(this.controllerName, this.factory);
                    };
                    Component.prototype.newInstance = function (scope, options) {
                        if (options === void 0) { options = {}; }
                        if (this.type == "component" || this.type == "directive") {
                            return this.newComponent(scope, options);
                        }
                        if (this.type == "controller" || this.type == 'html') {
                            return this.newController(scope, options);
                        }
                    };
                    Component.prototype.newController = function (scope, options) {
                        return this.instance(this.pageInfo.tpl, scope, options);
                    };
                    Component.prototype.newComponent = function (scope, options) {
                        var tpl = "<" + this.componentName + " page-id=\"" + this.id + "\" class=\"ui-component\">" + (options.children || '') + "</" + this.componentName + ">";
                        return this.instance(tpl, scope, options);
                    };
                    Component.prototype.instance = function (tpl, scope, options) {
                        var attrs = options.attrs;
                        var params = options.params;
                        var currentScope = scope.$new();
                        var el;
                        try {
                            el = $(tpl);
                        }
                        catch (error) {
                            el = $("<div>" + tpl + "</div>");
                        }
                        if (params && angular.isObject(params) && !angular.isArray(params)) {
                            currentScope['params'] = params;
                            var keys = Object.keys(params);
                            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                                var key = keys_1[_i];
                                if (key.indexOf('$') == 0) {
                                    continue;
                                }
                                try {
                                    el.attr(this.toLowerLine(key), "params." + key);
                                }
                                catch (error) {
                                }
                            }
                        }
                        if (attrs) {
                            var keys = Object.keys(attrs);
                            for (var _a = 0, keys_2 = keys; _a < keys_2.length; _a++) {
                                var key = keys_2[_a];
                                if (key == 'ng-repeat' || key == 'page-id') {
                                    continue;
                                }
                                if (key.indexOf('$') == 0) {
                                    continue;
                                }
                                var value = attrs[key];
                                if (value)
                                    el.attr(key, value);
                            }
                        }
                        var linkFn = framework.syn.ng.compile(el);
                        return new ComponentInstance(this, currentScope, el, linkFn);
                    };
                    Component.prototype.toLowerLine = function (str) {
                        var temp = str.replace(/[A-Z]/g, function (match) {
                            return "_" + match.toLowerCase();
                        });
                        if (temp.slice(0, 1) === '_') {
                            temp = temp.slice(1);
                        }
                        return temp;
                    };
                    Component.prototype.toHump = function (name) {
                        return name.replace(/\_(\w)/g, function (all, letter) {
                            return letter.toUpperCase();
                        });
                    };
                    return Component;
                }());
                component2.Component = Component;
                var ComponentManager = (function () {
                    function ComponentManager() {
                        this._isInit = false;
                        this._styleCache = {};
                    }
                    Object.defineProperty(ComponentManager.prototype, "cache", {
                        get: function () {
                            if (!this._cache) {
                                this._cache = framework.syn.cache.getCache("$component_2.0$", false);
                            }
                            return this._cache;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(ComponentManager.prototype, "moduleCache", {
                        get: function () {
                            if (!this._moduleCache) {
                                this._moduleCache = framework.syn.cache.getCache("$module_2.0$", false);
                            }
                            return this._moduleCache;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    ComponentManager.prototype.cacheComponent = function (component) {
                        log.debug('cache component', component.toString());
                        this.cache.put(component.id, component);
                        component.alias && this.cache.put(component.alias, component);
                    };
                    ComponentManager.prototype.cacheModule = function (module) {
                        log.debug('cache module', module.id);
                        this.moduleCache.put(module.id, module);
                        module.alias && this.moduleCache.put(module.alias, module);
                    };
                    ComponentManager.prototype.has = function (name) {
                        return this.cache.has(name);
                    };
                    ComponentManager.prototype.find = function (name) {
                        return this.cache.get(name);
                    };
                    ComponentManager.prototype.findModule = function (name) {
                        return this.moduleCache.get(name);
                    };
                    ComponentManager.prototype.registerComponent = function (id, alias, pageInfo, fn) {
                        var page = new framework.Page(id, framework.syn);
                        var initer = new AngularIniter(id, pageInfo);
                        var component = new Component(id, alias, 'html', pageInfo, null);
                        component.init();
                        this.cacheComponent(component);
                        fn(page, this.controllerFn(id, pageInfo, false), this.controllerFn(id, pageInfo, true), this.directiveFn(id, pageInfo), initer);
                    };
                    ComponentManager.prototype.registerModule = function (id, alias, fn) {
                        fn();
                        this.cacheModule({ id: id, alias: alias });
                        log.debug("module [id:" + id + ",alise:" + (alias || '') + "] registed");
                    };
                    ComponentManager.prototype.registerStyle = function (pageInfo) {
                        if (pageInfo.style) {
                            var keys = Object.keys(pageInfo.style);
                            for (var _i = 0, keys_3 = keys; _i < keys_3.length; _i++) {
                                var key = keys_3[_i];
                                if (this._styleCache[key]) {
                                    continue;
                                }
                                var style = pageInfo.style[key];
                                var styleId = "page-" + key + ".css";
                                if (style) {
                                    this._styleCache[key] = true;
                                    $("<style type=\"text/css\" id=\"" + styleId + "\">" + style + "</style>").appendTo($('head'));
                                }
                            }
                        }
                    };
                    ComponentManager.prototype.registerPage = function (pageInfo, fn) {
                        var pageTpl = $('#root-page');
                        pageInfo.tpl = pageTpl.html();
                        pageTpl.remove();
                        this.pageFn = function () {
                            fn(pageInfo);
                        };
                    };
                    ComponentManager.prototype.hookSystemJs = function () {
                        var _this = this;
                        var baseUrl = location.protocol + "//" + location.host + framework.syn.app.contextPath + "/";
                        var rootPageUrl = baseUrl + framework.syn.app.pageId;
                        var instantiate = System.constructor.prototype.instantiate;
                        System.constructor.prototype.instantiate = function (url, parent) {
                            if (url == rootPageUrl) {
                                _this.pageFn();
                                return Promise.resolve(System.getRegister());
                            }
                            else {
                                if (url.indexOf(baseUrl) >= 0) {
                                    var pageId = url.replace(baseUrl, '');
                                    var app = framework.syn.app;
                                    var ver = app.version + "_" + (app.codeVersion || '');
                                    url = baseUrl + pageId.replace(/\//g, '~') + (".js?v=" + ver);
                                }
                                return Promise.resolve(instantiate.call(System, url, parent));
                            }
                        };
                        var resolve = System.constructor.prototype.resolve;
                        System.constructor.prototype.resolve = function (id, parent) {
                            log.info('resollve', id, parent);
                            if (id.indexOf('http') == 0
                                || id.indexOf('https') == 0) {
                                return resolve.call(System, id, parent);
                            }
                            var libSite = 'https://lib.95work.com';
                            if (id.startsWith('lib/')) {
                                var _a = id.split('/'), _1 = _a[0], module_1 = _a[1];
                                return resolve.call(System, libSite + "/lib/module/" + module_1 + ".js", parent);
                            }
                            else if (id.startsWith('@tpl/')) {
                                var _b = id.split('/'), _2 = _b[0], module_2 = _b[1];
                                return resolve.call(System, libSite + "/syn/tpl/" + module_2 + ".js", parent);
                            }
                            if (parent) {
                                try {
                                    var test = resolve.call(System, id, parent);
                                    return test;
                                }
                                catch (error) {
                                }
                            }
                            var parentId = parent;
                            var isAbsolute = id.indexOf('.') != 0;
                            isAbsolute && (id = './' + id);
                            if (!parent) {
                                parent = baseUrl;
                            }
                            else {
                                parentId = parent.replace(baseUrl, '');
                                if (!isNaN(Number(parentId))) {
                                    var component_1 = manager.find(parentId);
                                    var module_3 = manager.findModule(parentId);
                                    if (!component_1 && !module_3) {
                                    }
                                    parentId = (component_1 && component_1.alias) || (module_3 && module_3.alias) || parentId;
                                    parent = baseUrl + parentId;
                                }
                                if (isAbsolute) {
                                    parent = baseUrl;
                                }
                            }
                            return resolve.call(System, id, parent);
                        };
                    };
                    ComponentManager.prototype.loadPage = function () {
                        var _this = this;
                        log.setLevel('warn');
                        if (!framework.syn.app.pageId) {
                            return;
                        }
                        log.debug("load root page:" + framework.syn.app.pageId);
                        System.import("" + framework.syn.app.pageId).then(function () {
                            var component = _this.find(framework.syn.app.pageId);
                            component.newInstance(framework.syn.ng.rootScope).link(function (el) {
                                el.appendTo(document.body);
                            });
                            framework.syn.ng.rootScope.$applyAsync();
                        });
                    };
                    ComponentManager.prototype.load = function (name) {
                        var _this = this;
                        var component = this.find(name);
                        if (component) {
                            return framework.syn.ng.q.resolve(component);
                        }
                        var defer = framework.syn.ng.q.defer();
                        System.import("" + name).then(function () {
                            var component = _this.find(name);
                            if (!component) {
                                log.error("can't find compoent:" + name);
                            }
                            defer.resolve(component);
                        });
                        return defer.promise;
                    };
                    ComponentManager.prototype.controllerFn = function (id, pageInfo, vm) {
                        if (vm === void 0) { vm = false; }
                        return function () {
                            var args = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args[_i] = arguments[_i];
                            }
                            var controller;
                            if (args.length == 1) {
                                controller = args[0];
                            }
                            else if (args.length == 2) {
                                controller = args[1];
                            }
                            var component = manager.find(id);
                            component.type = 'controller';
                            component.factory = controller;
                            if (vm) {
                                component.controllerAs = "vm";
                            }
                            component.register();
                        };
                    };
                    ComponentManager.prototype.directiveFn = function (id, pageInfo) {
                        return function (cfg) {
                            if (typeof cfg == "function") {
                                cfg = cfg();
                            }
                            var component = manager.find(id);
                            component.type = 'directive';
                            component.directiveOptions = cfg;
                            component.register();
                        };
                    };
                    return ComponentManager;
                }());
                component2.ComponentManager = ComponentManager;
                var AngularIniter = (function () {
                    function AngularIniter(id, pageInfo) {
                        this.id = id;
                        this.pageInfo = pageInfo;
                    }
                    AngularIniter.prototype.Component = function (cfg) {
                        var _this = this;
                        if (cfg === void 0) { cfg = {}; }
                        if (cfg.controller) {
                            var component_2 = manager.find(this.id);
                            component_2.type = 'component';
                            component_2.factory = cfg.controller;
                            component_2.componentOptions = cfg;
                            component_2.register();
                            return undefined;
                        }
                        return function (_target, propertyKey, descriptor) {
                            if (_target.prototype['_bindings']) {
                                cfg['bindings'] = _target.prototype['_bindings'];
                            }
                            var target = cfg.name ? null : _target;
                            var component = manager.find(_this.id);
                            component.type = 'component';
                            component.factory = target;
                            component.componentOptions = cfg;
                            component.register();
                        };
                    };
                    AngularIniter.prototype.Controller = function (controller) {
                        var _this = this;
                        var fn = function (target, propertyKey, descriptor) {
                            var component = manager.find(_this.id);
                            component.type = 'controller';
                            component.factory = target;
                            controller && (component.factory = controller);
                            component.register();
                        };
                        if (controller) {
                            fn();
                            return undefined;
                        }
                        return fn;
                    };
                    AngularIniter.prototype.Input = function (cfg) {
                        return function (target, propertyKey, desc) {
                            var bindings = target['_bindings'] = target['_bindings'] || {};
                            if (propertyKey) {
                                bindings[propertyKey] = "<";
                            }
                            else {
                                if (typeof cfg !== 'string') {
                                    bindings[cfg.name] = "<";
                                }
                            }
                        };
                    };
                    AngularIniter.prototype.InOut = function (cfg) {
                        return function (target, propertyKey, desc) {
                            var bindings = target['_bindings'] = target['_bindings'] || {};
                            if (propertyKey) {
                                bindings[propertyKey] = '=';
                            }
                            else {
                                if (typeof cfg !== 'string') {
                                    bindings[cfg.name] = '=';
                                }
                            }
                        };
                    };
                    AngularIniter.prototype.Output = function (cfg) {
                        return function (target, propertyKey, desc) {
                            var bindings = target['_bindings'] = target['_bindings'] || {};
                            if (propertyKey) {
                                bindings[propertyKey] = '&';
                            }
                            else {
                                if (typeof cfg !== 'string') {
                                    bindings[cfg.name] = '&';
                                }
                            }
                        };
                    };
                    AngularIniter.prototype.Service = function (name) {
                        if (name === void 0) { name = ""; }
                        return function (target, propertyKey, descriptor) {
                            framework.syn.ng.provide.service(name || target.name, function () { return new target(); });
                        };
                    };
                    AngularIniter.prototype.Directive = function (cfg) {
                        var _this = this;
                        if (cfg === void 0) { cfg = {}; }
                        return function (_target, propertyKey, descriptor) {
                            if (_target.prototype['_bindings']) {
                                cfg.scope = _target.prototype['_bindings'];
                            }
                            if (_target['_bindings']) {
                                cfg.scope = _target['_bindings'];
                            }
                            var component = manager.find(_this.id);
                            component.type = 'directive';
                            component.factory = _target;
                            component.directiveOptions = cfg;
                            component.register();
                        };
                    };
                    return AngularIniter;
                }());
                component2.AngularIniter = AngularIniter;
                var manager = new ComponentManager();
                function getManager() {
                    return manager;
                }
                component2.getManager = getManager;
            })(component2 = service.component2 || (service.component2 = {}));
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var nav;
            (function (nav_1) {
                nav_1.BACK_EVENT = "$window_history_back";
                nav_1.PAGE_EVENT_SHOW = "$page_event_show";
                nav_1.PAGE_EVENT_HIDE = "$page_event_hide";
                var Navigator = (function () {
                    function Navigator() {
                        this.isInit = false;
                        this.backState = "syn-back";
                        this.count = 0;
                    }
                    Navigator.prototype.init = function () {
                        if (!this.isInit) {
                            this.isInit = true;
                        }
                    };
                    Navigator.prototype.pushBack = function () {
                        if (this.isInit) {
                            this.count++;
                            history.pushState(this.backState, "", "#" + this.count);
                        }
                    };
                    Navigator.prototype.setParams = function (params) {
                        if (this.isInit) {
                            history.replaceState(this.backState, "", "#__p__=" + encodeURIComponent(JSON.stringify(params)));
                        }
                    };
                    return Navigator;
                }());
                nav_1.nav = new Navigator();
                var Page = (function () {
                    function Page(name, pageId, params, fromPage) {
                        this.name = name;
                        this.pageId = pageId;
                        this.params = params;
                        this.fromPage = fromPage;
                        this.duration = 200;
                        Page.idCount++;
                        this.id = Page.idCount;
                    }
                    Page.prototype.toLowerLine = function (str) {
                        var temp = str.replace(/[A-Z]/g, function (match) {
                            return "_" + match.toLowerCase();
                        });
                        if (temp.slice(0, 1) === '_') {
                            temp = temp.slice(1);
                        }
                        return temp;
                    };
                    Page.prototype.onResult = function (result) {
                    };
                    Page.prototype.load = function (nav) {
                        var _this = this;
                        this.defer = framework.syn.ng.q.defer();
                        var firstLoad = false;
                        if (this.scope) {
                            this.show();
                            return this.defer.promise;
                        }
                        if (!framework.syn.component.has(this.pageId)) {
                            firstLoad = true;
                            framework.syn.toast.showLoading();
                        }
                        framework.syn.component.load(this.pageId).then(function (component) {
                            try {
                                var parentScope = nav.scope;
                                var parentEl_1 = nav.element;
                                var isComponent_1 = component.type == "directive" || component.type == "component";
                                var instance = component.newInstance(parentScope, { params: _this.params }).link(function (el) {
                                    _this.el = el;
                                    _this.el.appendTo(parentEl_1);
                                });
                                framework.syn.ng.timeout(function () {
                                    _this.scope = _this.el.scope();
                                    _this.scope['page'] = _this;
                                    if (firstLoad) {
                                        framework.syn.toast.hide();
                                    }
                                    if (isComponent_1) {
                                        _this.controller = _this.el.data("$" + component.componentHumpName + "Controller");
                                    }
                                    else {
                                        _this.controller = $(">div", _this.el).data("ngControllerController");
                                    }
                                    _this.notifyPageShow();
                                    if (_this.fromPage) {
                                        _this.el.insertAfter(_this.fromPage.el);
                                        _this.fromPage.hide();
                                    }
                                    _this.slideInRight();
                                });
                            }
                            catch (e) {
                                console.error(e);
                                framework.syn.toast.showWarn("加载页面失败！");
                                _this.destory();
                            }
                        });
                        return this.defer.promise;
                    };
                    Page.prototype.notifyPageShow = function () {
                        this.dispatchEvent(nav_1.PAGE_EVENT_SHOW, this.pageId);
                    };
                    Page.prototype.notifyPageHide = function () {
                        this.dispatchEvent(nav_1.PAGE_EVENT_SHOW, this.pageId);
                    };
                    Page.prototype.show = function () {
                        this.notifyPageShow();
                        if (this.el) {
                            this.el.show();
                            this.resume();
                        }
                    };
                    Page.prototype.slideOutRight = function (fn) {
                        this.transition('slideOutRight', fn);
                    };
                    Page.prototype.slideOutLeft = function (fn) {
                        this.transition('slideOutLeft', fn);
                    };
                    Page.prototype.slideInLeft = function (fn) {
                        this.transition('slideInLeft', fn);
                    };
                    Page.prototype.slideInRight = function (fn) {
                        this.transition('slideInRight', fn);
                    };
                    Page.prototype.transition = function (name, fn) {
                        this.el.transition({
                            displayType: false,
                            animation: name,
                            duration: this.duration,
                            onComplete: function () {
                                if (fn) {
                                    fn();
                                }
                            }
                        });
                    };
                    Page.prototype.hide = function () {
                        this.notifyPageHide();
                        this.suspend();
                        this.el.hide();
                    };
                    Page.prototype.suspend = function () {
                        if (framework.syn.isAngular1_7 && this.scope) {
                        }
                    };
                    Page.prototype.resume = function () {
                        if (framework.syn.isAngular1_7 && this.scope) {
                            this.scope.$resume();
                        }
                    };
                    Page.prototype.dispatchEvent = function (event, params) {
                        this.scope.$broadcast(event, params);
                    };
                    Page.prototype.destory = function () {
                        if (this.scope)
                            this.scope.$destroy();
                        if (this.el)
                            this.el.remove();
                        this.el = null;
                        this.scope = null;
                    };
                    Page.prototype.close = function (result) {
                        var _this = this;
                        this.suspend();
                        this.slideOutRight(function () {
                            _this.el.hide();
                            _this.destory();
                            if (_this.defer) {
                                _this.defer.resolve(result);
                            }
                        });
                    };
                    Page.idCount = 0;
                    return Page;
                }());
                nav_1.Page = Page;
                var PageNavigator = (function () {
                    function PageNavigator(scope, element) {
                        var _this = this;
                        this.scope = scope;
                        this.element = element;
                        this.pageStack = [];
                        element.data(PageNavigator.key, this);
                        nav_1.nav.init();
                        scope.$on(nav_1.BACK_EVENT, function (event) {
                            if (event.defaultPrevented) {
                                return;
                            }
                            if (_this.back()) {
                                event.preventDefault();
                            }
                        });
                    }
                    PageNavigator.prototype.findPage = function (id) {
                        return _.find(this.pageStack, { id: id });
                    };
                    PageNavigator.prototype.openPage = function (pageIdOrName, params) {
                        var pageId = pageIdOrName.toString();
                        var page = new Page(pageId, pageId, params, this._currentPage);
                        if (this._currentPage) {
                            this._currentPage.suspend();
                        }
                        this.pageStack.push(page);
                        this._currentPage = page;
                        nav_1.nav.pushBack();
                        return this._currentPage.load(this);
                    };
                    PageNavigator.prototype.setPageParams = function (params) {
                        nav_1.nav.setParams(params);
                    };
                    PageNavigator.prototype.setShare = function (shareInfo) {
                        nav_1.nav.setParams(angular.merge({ type: 'share' }, shareInfo));
                    };
                    PageNavigator.prototype.goHome = function () {
                        if (this.pageStack.length === 0) {
                            return;
                        }
                        for (var i = this.pageStack.length - 1; i > 0; i--) {
                            var page_1 = this.pageStack[i];
                            page_1.close();
                        }
                        this._currentPage = this.pageStack[0];
                        this.pageStack = [this._currentPage];
                        this._currentPage.show();
                    };
                    PageNavigator.prototype.back = function (result) {
                        return this.doBack(result);
                    };
                    PageNavigator.prototype.doBack = function (result) {
                        if (this.pageStack.length <= 1) {
                            return false;
                        }
                        if (this._currentPage) {
                            this.pageStack.pop();
                            this._currentPage.close(result);
                            this._currentPage = this.pageStack[this.pageStack.length - 1];
                            this._currentPage.show();
                            return true;
                        }
                    };
                    PageNavigator.key = "$syn_page_navigator";
                    return PageNavigator;
                }());
                nav_1.PageNavigator = PageNavigator;
            })(nav = service.nav || (service.nav = {}));
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var naviagtion;
            (function (naviagtion) {
                var idCount = 0;
                var stack = [];
                function push(callback) {
                    idCount++;
                    stack.push({
                        id: idCount,
                        callback: callback
                    });
                    return this.idCount;
                }
                naviagtion.push = push;
                function pop() {
                    var item = stack.pop();
                    item && item.callback();
                    return item ? item.id : -1;
                }
                naviagtion.pop = pop;
                function remove(id) {
                    var index = stack.findIndex(function (it) { return it.id == id; });
                    if (index > 0) {
                        stack.splice(index, 1);
                    }
                }
                naviagtion.remove = remove;
                function length() {
                    return stack.length;
                }
                naviagtion.length = length;
            })(naviagtion = service.naviagtion || (service.naviagtion = {}));
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var animation;
            (function (animation) {
                var Transition = (function () {
                    function Transition(el, options) {
                        this.el = el;
                        this.options = options;
                        this.isVisbile = false;
                    }
                    Transition.prototype.show = function () {
                        var _this = this;
                        if (this.isVisbile) {
                            return;
                        }
                        this.el.transition({
                            displayType: false,
                            animation: this.options.transitionIn,
                            queue: false,
                            useFailSafe: true,
                            onStart: function () {
                                _this.isVisbile = true;
                                _this.el.parent().addClass('active');
                            },
                            onComplete: function () {
                                _this.el.addClass('active');
                            }
                        });
                    };
                    Transition.prototype.hide = function () {
                        var _this = this;
                        var defer = framework.syn.ng.q.defer();
                        if (!this.isVisbile) {
                            return framework.syn.ng.q.resolve();
                        }
                        this.el.transition({
                            displayType: false,
                            animation: this.options.transitionOut,
                            queue: false,
                            useFailSafe: true,
                            onStart: function () {
                                _this.isVisbile = false;
                            },
                            onComplete: function () {
                                _this.el.parent().removeClass('active');
                                defer.resolve();
                            }
                        });
                        return defer.promise;
                    };
                    return Transition;
                }());
                animation.Transition = Transition;
            })(animation = service.animation || (service.animation = {}));
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var actions;
            (function (actions) {
                actions.ACTION_CANCEL = 'cancel';
                actions.ACTION_BACK = 'back';
                actions.ACTION_CONFIRM = 'confirm';
                var Action = (function () {
                    function Action(name, index) {
                        this.name = name;
                        this.index = index;
                    }
                    Object.defineProperty(Action.prototype, "isCancel", {
                        get: function () {
                            return this.name == actions.ACTION_CANCEL;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(Action.prototype, "isConfirm", {
                        get: function () {
                            return this.name == actions.ACTION_CONFIRM;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(Action.prototype, "isBack", {
                        get: function () {
                            return this.name == actions.ACTION_BACK;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Action.prototype.eq = function (action) {
                        return this.name == action;
                    };
                    Action.prototype.toString = function () {
                        return this.name;
                    };
                    return Action;
                }());
                actions.Action = Action;
            })(actions = service.actions || (service.actions = {}));
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var toast;
            (function (toast) {
                var ToastService = (function () {
                    function ToastService() {
                        this.isShow = false;
                        this.isEnable = true;
                        this.longTime = 3000;
                        this.shortTime = 1500;
                        this.iconInfo = "info";
                        this.iconSucess = "check circle outline";
                        this.iconWarn = "exclamation triangle";
                        this.iconError = "times circle outline";
                    }
                    ToastService.prototype.disable = function () {
                        this.isEnable = false;
                    };
                    ToastService.prototype.enable = function () {
                        this.isEnable = true;
                    };
                    ToastService.prototype.show = function () {
                        if (!this.isEnable)
                            return framework.syn.ng.q.resolve();
                        if (arguments.length === 0) {
                            return framework.syn.ng.q.resolve();
                        }
                        if (arguments.length == 1) {
                            if (typeof arguments[0] == "string") {
                                return this.show(arguments[0], this.shortTime);
                            }
                            return this.showToast(arguments[0]);
                        }
                        if (arguments.length == 2) {
                            var cfg = {
                                text: arguments[0],
                                duration: arguments[1],
                                mask: false
                            };
                            return this.showToast(cfg);
                        }
                        return framework.syn.ng.q.resolve();
                    };
                    ToastService.prototype.showInfo = function (text, cfg) {
                        if (cfg === void 0) { cfg = {}; }
                        return this.show(angular.merge(cfg, { text: text, icon: this.iconInfo }));
                    };
                    ToastService.prototype.showSuccess = function (text, cfg) {
                        if (cfg === void 0) { cfg = {}; }
                        return this.show(angular.merge(cfg, { text: text, icon: this.iconSucess }));
                    };
                    ToastService.prototype.showWarn = function (text, cfg) {
                        if (cfg === void 0) { cfg = {}; }
                        return this.show(angular.merge(cfg, { text: text, icon: this.iconWarn }));
                    };
                    ToastService.prototype.showError = function (text, cfg) {
                        if (cfg === void 0) { cfg = {}; }
                        return this.show(angular.merge(cfg, { text: text, icon: this.iconError }));
                    };
                    ToastService.prototype.showLoading = function (text, mask) {
                        if (mask === void 0) { mask = true; }
                        return this.show({
                            text: text,
                            duration: -1,
                            mask: mask,
                            icon: 'spinner loading'
                        });
                    };
                    ToastService.prototype.hide = function () {
                        var _this = this;
                        if (this.el) {
                            this.el.removeClass('mask');
                            this.transtion.hide().then(function () {
                                _this.scope['cfg'] = {};
                            });
                        }
                    };
                    ToastService.prototype.showToast = function (cfg) {
                        var _this = this;
                        if (this.lastCfg) {
                            this.lastCfg.duration = -1;
                        }
                        cfg.duration = cfg.duration | this.shortTime;
                        var defer = framework.syn.ng.q.defer();
                        this.lastCfg = cfg;
                        if (!this.el) {
                            this.createEl();
                        }
                        this.transtion.show();
                        if (cfg.mask) {
                            this.el.addClass('mask');
                        }
                        cfg.duration = Math.min(10000, cfg.duration);
                        framework.syn.ng.timeout(function () {
                            _this.scope['cfg'] = cfg;
                        });
                        if (cfg.duration > 0) {
                            framework.syn.ng.timeout(function () {
                                if (cfg.duration >= 0) {
                                    _this.hide();
                                }
                                defer.resolve();
                            }, cfg.duration);
                        }
                        else {
                            defer.resolve();
                        }
                        return defer.promise;
                    };
                    ToastService.prototype.createEl = function () {
                        this.el = $("<div class=\"ui toast dimmer\" ng-class=\"cfg.position\">\n                <div class=\"content\">\n                    <div ng-if=\"cfg.icon\"> <i class=\"{{cfg.icon}} icon\"></i></div>\n                    <div class=\"text\" ng-if=\"cfg.text\">{{cfg.text}}</div>\n                </div>\n            </div>").appendTo($('body'));
                        this.toastEl = $($(">div.content", this.el)[0]);
                        this.transtion = new service.animation.Transition(this.toastEl, {
                            transitionIn: 'fadeIn',
                            transitionOut: 'fadeOut'
                        });
                        this.scope = framework.syn.ng.rootScope.$new(true);
                        framework.syn.ng.compile(this.el)(this.scope);
                    };
                    return ToastService;
                }());
                toast.ToastService = ToastService;
            })(toast = service.toast || (service.toast = {}));
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var commonpopup;
            (function (commonpopup) {
                var Action = service.actions.Action;
                var PoupController = (function () {
                    function PoupController(scope, element) {
                        this.scope = scope;
                        this.element = element;
                        this.isPromiseClosing = false;
                        this.navId = -1;
                        this.transitionOptions = {
                            transitionIn: 'fadeIn',
                            transitionOut: 'fadeOut'
                        };
                        scope['vm'] = this;
                        this.contentEl = $($(">div", element)[0]);
                        this.init();
                        this.transition = new service.animation.Transition(this.contentEl, this.transitionOptions);
                    }
                    PoupController.prototype.init = function () {
                    };
                    PoupController.prototype.show = function (cfg) {
                        var _this = this;
                        this.navId = service.naviagtion.push(function () {
                            _this.close();
                        });
                        this.cfg = cfg;
                        this.defer = framework.syn.ng.q.defer();
                        this.scope['cfg'] = cfg;
                        if (framework.syn.isAngular1_7) {
                            this.scope.$resume();
                        }
                        this.transition.show();
                        framework.syn.ng.timeout();
                        return this.defer.promise;
                    };
                    PoupController.prototype.onActionClick = function (action) {
                        var index = this.cfg.actions.indexOf(action) + 1;
                        this.close(action.name || "action" + index, index);
                    };
                    PoupController.prototype.close = function (actionName, index) {
                        var _this = this;
                        if (this.isPromiseClosing)
                            return;
                        if (this.navId) {
                            service.naviagtion.remove(this.navId);
                        }
                        var action = new Action(actionName || 'close', index || 0);
                        if (this.defer) {
                            this.defer.promise.then(function () {
                                if (action.result && action.result['then']) {
                                    _this.promiseClose(action.result, _this.cfg.actions[index - 1]);
                                }
                                else {
                                    _this.hide();
                                }
                            });
                            this.defer.resolve(action);
                        }
                    };
                    PoupController.prototype.promiseClose = function (promise, action) {
                        var _this = this;
                        this.isPromiseClosing = true;
                        var preIcon = action.icon;
                        action.icon = 'spinner loading';
                        promise.then(function () {
                            _this.hide();
                        }).catch(function () {
                            action.icon = preIcon;
                        }).finally(function () {
                            _this.isPromiseClosing = false;
                        });
                        framework.syn.ng.q.reject;
                    };
                    PoupController.prototype.hide = function () {
                        return this.transition.hide();
                    };
                    return PoupController;
                }());
                commonpopup.PoupController = PoupController;
                PoupController.$inject = ["$scope", "$element"];
                var CommonPopupService = (function () {
                    function CommonPopupService(tpl, controller) {
                        this.tpl = tpl;
                        this.controller = controller;
                    }
                    CommonPopupService.prototype.init = function () {
                        framework.syn.ng.controllerProvider.register(this.controller['name'], this.controller);
                    };
                    CommonPopupService.prototype.show = function (cfg) {
                        if (!this.el) {
                            this.el = $(this.tpl).appendTo($('body'));
                            this.el = framework.syn.ng.compile(this.el)(framework.syn.ng.rootScope.$new(true));
                            this.ctrl = this.el.data("$ngControllerController");
                        }
                        return this.ctrl.show(cfg);
                    };
                    return CommonPopupService;
                }());
                commonpopup.CommonPopupService = CommonPopupService;
            })(commonpopup = service.commonpopup || (service.commonpopup = {}));
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var actionsheet;
            (function (actionsheet) {
                var Action = service.actions.Action;
                var tpl = "\n    <div class=\"ui page dimmer actionsheet\" ng-controller=\"ActionSheetController\">\n        <div>\n            <h4 class=\"ui header attached\" ng-show=\"cfg.title\">\n                <div class=\"content\">\n                    {{cfg.title}}\n                    <div class=\"sub header\">{{cfg.desc}}</div>\n                </div>\n            </h4>\n            <div class=\"ui fluid vertical attached menu\">\n                <a class=\"active  item\" ng-class=\"action.color\" ng-repeat=\"action in cfg.actions\" ng-click=\"vm.onActionClick(action)\">\n                    <i ng-show=\"action.icon\" class=\"{{action.icon}} icon\"></i>{{action.label}}\n                </a>\n            </div>\n            <div class=\"ui fluid vertical cancel attached menu\">\n                <a class=\"active gray  item\" ng-click=\"vm.onCancel()\">\u53D6\u6D88</a>\n            </div>\n        </div>\n    </div>";
                var ActionSheetController = (function (_super) {
                    __extends(ActionSheetController, _super);
                    function ActionSheetController() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ActionSheetController.prototype.onCancel = function () {
                        this.close(service.actions.ACTION_CANCEL, 0);
                    };
                    ActionSheetController.prototype.init = function () {
                        this.transitionOptions.transitionIn = 'slideInUp';
                        this.transitionOptions.transitionOut = 'slideOutDown';
                    };
                    return ActionSheetController;
                }(service.commonpopup.PoupController));
                var ActionSheetService = (function (_super) {
                    __extends(ActionSheetService, _super);
                    function ActionSheetService() {
                        return _super.call(this, tpl, ActionSheetController) || this;
                    }
                    return ActionSheetService;
                }(service.commonpopup.CommonPopupService));
                actionsheet.ActionSheetService = ActionSheetService;
            })(actionsheet = service.actionsheet || (service.actionsheet = {}));
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var service;
        (function (service) {
            var msgbox;
            (function (msgbox) {
                var Action = service.actions.Action;
                var actions = service.actions;
                var tpl = "\n    <div class=\"ui dimmer page msgbox\" ng-controller=\"MsgBoxController\">\n        <div>\n            <div class=\"ui attached segment\">\n                <h4 class=\"title\" ng-show=\"cfg.title\">{{cfg.title}}</h4>\n                <div class=\"body\" ng-show=\"cfg.content\" ng-class=\"vm.contentCls\" ng-bind-html=\"cfg.content\"></div>\n            </div>\n            <div class=\"ui attached buttons\">\n                 <div class=\"ui basic button\" ng-class=\"action.color\" ng-repeat=\"action in cfg.actions\" ng-click=\"vm.onActionClick(action)\">\n                   <i ng-show=\"action.icon\" class=\"{{action.icon}} icon\"></i>{{action.label}}\n                 </div>\n            </div>\n        </div>\n    </div>";
                var MsgBoxController = (function (_super) {
                    __extends(MsgBoxController, _super);
                    function MsgBoxController() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    Object.defineProperty(MsgBoxController.prototype, "transitionName", {
                        get: function () {
                            return 'scale';
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(MsgBoxController.prototype, "contentCls", {
                        get: function () {
                            return this.cfg && this.cfg.title ? "gray" : "";
                        },
                        enumerable: true,
                        configurable: true
                    });
                    return MsgBoxController;
                }(service.commonpopup.PoupController));
                var MsgBoxService = (function (_super) {
                    __extends(MsgBoxService, _super);
                    function MsgBoxService() {
                        return _super.call(this, tpl, MsgBoxController) || this;
                    }
                    MsgBoxService.prototype.confirmAction = function (options) {
                        return {
                            label: options.confirmLabel || '确定',
                            name: actions.ACTION_CONFIRM,
                            icon: options.confirmIcon || '',
                            color: options.confirmColor || 'primary'
                        };
                    };
                    MsgBoxService.prototype.cancelAction = function (options) {
                        return {
                            label: options.cancelLabel || '取消',
                            name: actions.ACTION_CANCEL,
                            icon: options.cancelIcon || '',
                            color: options.cancelColor || ''
                        };
                    };
                    MsgBoxService.prototype.alert = function (title, content, options) {
                        if (options === void 0) { options = {}; }
                        return this.show({
                            title: title,
                            content: content,
                            actions: [this.confirmAction(options)]
                        });
                    };
                    MsgBoxService.prototype.confirm = function (title, content, options) {
                        if (options === void 0) { options = {}; }
                        return this.show({
                            title: title,
                            content: content,
                            actions: [this.cancelAction(options), this.confirmAction(options)]
                        });
                    };
                    return MsgBoxService;
                }(service.commonpopup.CommonPopupService));
                msgbox.MsgBoxService = MsgBoxService;
            })(msgbox = service.msgbox || (service.msgbox = {}));
        })(service = framework.service || (framework.service = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var theme;
    (function (theme_1) {
        var themeSrv;
        var theme;
        var defaultHue;
        function init() {
            if (!window['ngMaterial']) {
                return;
            }
            themeSrv = syn.ng.injector.get("$mdTheming");
            theme = themeSrv.THEMES["default"];
            defaultHue = theme.colors.primary.hues.default;
            var colors = '';
            for (var _i = 0, _a = Object.keys(theme.colors); _i < _a.length; _i++) {
                var colorName = _a[_i];
                var color = theme.colors[colorName];
                var paletteName = color.name;
                colors += toColorVar(paletteName, color.hues.default, colorName).join("\n") + "\n";
                for (var _b = 0, _c = Object.keys(color.hues); _b < _c.length; _b++) {
                    var hueName = _c[_b];
                    if (hueName == 'default') {
                        continue;
                    }
                    var palette = themeSrv.PALETTES[paletteName];
                    var hue = palette[color.hues[hueName]];
                    var contrast = hue.contrast;
                    colors += "--md-color-" + colorName + "-" + hueName + ":" + hue.hex + ";\n";
                    colors += "--md-color-" + colorName + "-" + hueName + "-contrast:rgba(" + contrast.join(',') + ");\n";
                }
            }
            for (var _d = 0, _e = Object.keys(themeSrv.PALETTES); _d < _e.length; _d++) {
                var paletteName = _e[_d];
                colors += toColorVar(paletteName, defaultHue).join("\n") + "\n";
            }
            $("<style md-theme-style>:root{" + colors + "}\r\nhtml,body{background:unset;}</style>").appendTo($('head'));
        }
        theme_1.init = init;
        function toColorVar(paletteName, defaultHue, alias) {
            var rs = [];
            var palette = themeSrv.PALETTES[paletteName];
            var name = alias || paletteName;
            for (var _i = 0, _a = Object.keys(palette); _i < _a.length; _i++) {
                var hueName = _a[_i];
                var hue = palette[hueName];
                var contrast = hue.contrast;
                rs.push("--md-color-" + name + "-" + hueName + ":" + hue.hex + ";");
                rs.push("--md-color-" + name + "-" + hueName + "-contrast:rgba(" + contrast.join(',') + ");");
                if (hueName == defaultHue) {
                    rs.push("--md-color-" + name + ":" + hue.hex + ";");
                    rs.push("--md-color-" + name + "-contrast:rgba(" + contrast.join(',') + ");");
                }
            }
            return rs;
        }
    })(theme = synwork.theme || (synwork.theme = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            function autoGrowFactory() {
                function compile(tElement, tAttrs, transclude) {
                    return function postLink(scope, iElement, iAttrs) {
                        if (!iElement.is('textarea')) {
                            return;
                        }
                        var offset = 0;
                        iElement[0].style.overflowY = 'hidden';
                        var _autoGrow = function () {
                            iElement[0].style.minHeight = '6px';
                            iElement[0].style.height = '6px';
                            var newHeight = (iElement[0].scrollHeight - offset) + 'px';
                            iElement[0].style.minHeight = newHeight;
                            iElement[0].style.height = newHeight;
                        };
                        var autoGrow = _.debounce(function () {
                            _autoGrow();
                        }, 200);
                        var listener = scope.$on("autoGrowRefresh", function () {
                            framework.syn.ng.timeout(function () {
                                _autoGrow();
                            });
                        });
                        iElement.on("input", autoGrow);
                        var modelAttr = iAttrs["ngModel"];
                        if (modelAttr) {
                            var watcher = scope.$watch(modelAttr, function (newValue, oldValue) {
                                framework.syn.ng.timeout(function () {
                                    autoGrow();
                                }, 10);
                            });
                            scope.$on("$destroy", function () {
                                watcher();
                                listener();
                            });
                        }
                    };
                }
                return {
                    restrict: 'A',
                    compile: compile
                };
            }
            directive.autoGrowFactory = autoGrowFactory;
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            function dateFormaterFactory() {
                function compile(tElement, tAttrs, transclude) {
                    return function postLink(scope, iElement, iAttrs, ngModel) {
                        if (!iElement.is('input')) {
                            return;
                        }
                        iElement.attr('autocomplete', 'off');
                        if (iElement.attr('type') != 'date') {
                            return;
                        }
                        ngModel.$formatters.push(function (modelValue) {
                            return new Date(Number(modelValue));
                        });
                    };
                }
                return {
                    restrict: 'A',
                    require: 'ngModel',
                    compile: compile
                };
            }
            directive.dateFormaterFactory = dateFormaterFactory;
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            function datePickerFactory() {
                function compile(tElement, tAttrs, transclude) {
                    return function postLink(scope, iElement, iAttrs, ngModel) {
                        if (!iElement.is('input')) {
                            return;
                        }
                        if (iElement.attr('type') == 'date') {
                            return;
                        }
                        var inst;
                        iElement.on('paste', function () { return false; });
                        iElement.on('dragenter', function () { return false; });
                        iElement.on('contextmenu', function () { return false; });
                        iElement.attr("style", "ime-mode:disabled");
                        iElement.on("blur", function () {
                            var d = moment(iElement.val());
                            if (d.isValid()) {
                                ngModel.$setViewValue(d.format("YYYY-MM-DD"));
                                ngModel.$render();
                            }
                            else {
                                ngModel.$setViewValue("");
                                ngModel.$render();
                            }
                        });
                        iElement.on('focus', function (event) {
                            if (iElement.attr("readonly")) {
                                event.stopImmediatePropagation();
                                event.preventDefault();
                                event.stopPropagation();
                                return;
                            }
                        });
                        iElement.on('click', function (event) {
                            if (iElement.attr("readonly")) {
                                event.stopImmediatePropagation();
                                event.preventDefault();
                                event.stopPropagation();
                                return;
                            }
                            iElement.select();
                        });
                        iElement.on("keydown", function (event) {
                            if (event.keyCode == 13 || event.keyCode == 9) {
                                event.stopImmediatePropagation();
                                inst.remove();
                                iElement.blur();
                            }
                            var isInput = (event.keyCode >= 48 && event.keyCode <= 57) ||
                                event.keyCode == 189;
                            if (!(isInput ||
                                event.keyCode == 8 ||
                                event.keyCode == 9 ||
                                event.keyCode == 37 ||
                                event.keyCode == 39 ||
                                event.keyCode == 46)) {
                                event.stopImmediatePropagation();
                                event.stopPropagation();
                                event.preventDefault();
                            }
                        });
                        inst = laydate.render({
                            elem: iElement[0],
                            showBottom: true,
                            trigger: 'click',
                            done: function (value, date) {
                                ngModel.$setViewValue(value);
                                iElement.focus();
                            }
                        }).inst;
                        ngModel.$formatters.push(function (modelValue) {
                            if (modelValue) {
                                var date = modelValue instanceof Date ? modelValue : new Date(Number(modelValue));
                                return framework.syn.ng.filter("date")(date, "yyyy-MM-dd");
                            }
                            else {
                                return "";
                            }
                        });
                        ngModel.$parsers.push(function (viewValue) {
                            var d = moment(viewValue);
                            return d.isValid() ? d.toDate() : null;
                        });
                    };
                }
                return {
                    restrict: 'A',
                    require: 'ngModel',
                    compile: compile
                };
            }
            directive.datePickerFactory = datePickerFactory;
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            function timePickerFactory() {
                function compile(tElement, tAttrs, transclude) {
                    return function postLink(scope, iElement, iAttrs, ngModel) {
                        if (!iElement.is('input')) {
                            return;
                        }
                        if (iElement.attr('type') == 'date') {
                            return;
                        }
                        var inst;
                        iElement.on('paste', function () { return false; });
                        iElement.on('dragenter', function () { return false; });
                        iElement.on('contextmenu', function () { return false; });
                        iElement.attr("style", "ime-mode:disabled");
                        iElement.on("blur", function () {
                            var time = iElement.val();
                            ngModel.$setViewValue(time);
                            ngModel.$render();
                        });
                        iElement.on('focus', function (event) {
                            if (iElement.attr("readonly")) {
                                event.stopImmediatePropagation();
                                event.preventDefault();
                                event.stopPropagation();
                                return;
                            }
                        });
                        iElement.on('click', function (event) {
                            if (iElement.attr("readonly")) {
                                event.stopImmediatePropagation();
                                event.preventDefault();
                                event.stopPropagation();
                                return;
                            }
                            iElement.select();
                        });
                        iElement.on("keydown", function (event) {
                            if (event.keyCode == 13 || event.keyCode == 9) {
                                event.stopImmediatePropagation();
                                inst.remove();
                                iElement.blur();
                            }
                            var isInput = (event.keyCode >= 48 && event.keyCode <= 57) ||
                                event.keyCode == 189;
                            if (!(isInput ||
                                event.keyCode == 8 ||
                                event.keyCode == 9 ||
                                event.keyCode == 37 ||
                                event.keyCode == 39 ||
                                event.keyCode == 46)) {
                                event.stopImmediatePropagation();
                                event.stopPropagation();
                                event.preventDefault();
                            }
                        });
                        inst = laydate.render({
                            elem: iElement[0],
                            showBottom: true,
                            type: 'time',
                            trigger: 'click',
                            done: function (value, date) {
                                ngModel.$setViewValue(value);
                                iElement.focus();
                            }
                        }).inst;
                    };
                }
                return {
                    restrict: 'A',
                    require: 'ngModel',
                    compile: compile
                };
            }
            directive.timePickerFactory = timePickerFactory;
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            function radioListFactory() {
                function compile(tElement, tAttrs, transclude) {
                    return function postLink(scope, iElement, iAttrs, ngModel) {
                        if (!iElement.is('input')) {
                            return;
                        }
                        ngModel.$render = function () {
                            var value = iAttrs.value;
                            if (angular.isObject(value) && angular.isObject(ngModel.$viewValue)) {
                                iElement[0].checked = (value.id == ngModel.$viewValue.id);
                            }
                            else {
                                iElement[0].checked = (value == ngModel.$viewValue);
                            }
                        };
                        iAttrs.$observe('value', ngModel.$render);
                    };
                }
                return {
                    restrict: 'A',
                    require: 'ngModel',
                    compile: compile
                };
            }
            directive.radioListFactory = radioListFactory;
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            function loadingFactory() {
                function compile(tElement, tAttrs, transclude) {
                    return function postLink(scope, iElement, iAttrs) {
                        var loadingText = iElement.attr("loading-text") || "Loading";
                        var loadingTpl = "<div class='ui active inverted dimmer'><div class='ui text loader'>" + loadingText + "</div></div>";
                        scope.$watch(iElement.attr("loading"), function (promise) {
                            if (promise && promise.finally) {
                                var dimmer;
                                var isBtn = iElement.hasClass("ui button");
                                if (isBtn) {
                                    iElement.addClass("loading");
                                }
                                else {
                                    dimmer = $(loadingTpl).appendTo(iElement);
                                }
                                promise.finally(function () {
                                    if (!isBtn) {
                                        dimmer.remove();
                                    }
                                    else {
                                        iElement.removeClass("loading");
                                    }
                                });
                            }
                        });
                    };
                }
                return {
                    restrict: 'A',
                    compile: compile
                };
            }
            directive.loadingFactory = loadingFactory;
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            function inputHintFactory() {
                function compile(tElement, tAttrs, transclude) {
                    return function postLink(scope, iElement, iAttrs) {
                        scope.$watch(iElement.attr("input-hint"), function (newHint, oldHint) {
                            if (newHint) {
                                if (newHint.tip) {
                                    iElement.attr("title", newHint.tip);
                                }
                                iElement.addClass("input-hint-" + newHint.type);
                                $("i", iElement).remove();
                                iElement.prepend("<i class=\"" + newHint.type + " icon\"></i>");
                            }
                            else if (!newHint && oldHint) {
                                iElement.removeAttr("class");
                                iElement.removeAttr("title");
                                $("i", iElement).remove();
                            }
                        });
                    };
                }
                return {
                    restrict: 'A',
                    compile: compile
                };
            }
            directive.inputHintFactory = inputHintFactory;
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            function repeatFinishFactory() {
                function compile(tElement, tAttrs, transclude) {
                    return function postLink(scope, iElement, iAttrs) {
                        if (scope.$last === true) {
                            framework.syn.ng.timeout(function () {
                                scope.$eval(iAttrs.repeatFinish);
                            });
                        }
                    };
                }
                return {
                    restrict: 'A',
                    compile: compile
                };
            }
            directive.repeatFinishFactory = repeatFinishFactory;
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            function checkboxListFactory() {
                function compile(tElement, tAttrs, transclude) {
                    return function postLink(scope, iElement, iAttrs, ngModel) {
                        var value = scope.$eval(iElement.attr("value"));
                        if (!iElement.is('input')) {
                            return;
                        }
                        ngModel.$parsers.push(function (viewValue) {
                            var modelValue = ngModel.$modelValue;
                            if (modelValue == undefined) {
                                modelValue = [];
                            }
                            if (viewValue) {
                                modelValue.push(value);
                            }
                            else {
                                if (angular.isObject(value)) {
                                    modelValue = _.remove(modelValue, function (it) {
                                        return it.id != value.id;
                                    });
                                }
                                else {
                                    modelValue = _.remove(modelValue, function (it) {
                                        return it != value;
                                    });
                                }
                            }
                            return modelValue || [];
                        });
                        ngModel.$formatters.push(function (modelValue) {
                            if (!modelValue) {
                                return false;
                            }
                            if (angular.isArray(modelValue)) {
                                if (modelValue.length == 0) {
                                    return false;
                                }
                                if (angular.isObject(value)) {
                                    return _.find(modelValue, { id: value.id }) != null;
                                }
                                else {
                                    return _.find(modelValue, function (it) {
                                        return it == value;
                                    }) != null;
                                }
                            }
                            return false;
                        });
                    };
                }
                return {
                    restrict: 'A',
                    require: 'ngModel',
                    compile: compile
                };
            }
            directive.checkboxListFactory = checkboxListFactory;
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            function dateInputFactory() {
                function compile(tElement, tAttrs, transclude) {
                    return function postLink(scope, iElement, iAttrs, ngModel) {
                        if (!iElement.is('input')) {
                            return;
                        }
                        iElement.on("change", function () {
                            ngModel.$setViewValue(framework.syn.ng.filter("date")(new Date(), "yyyy-MM-dd"));
                            ngModel.$render();
                        });
                        ngModel.$formatters.push(function (modelValue) {
                            var date = modelValue instanceof Date ? modelValue : new Date(Number(modelValue));
                            return framework.syn.ng.filter("date")(date, "yyyy-MM-dd");
                        });
                        ngModel.$parsers.push(function (viewValue) {
                            return viewValue;
                        });
                    };
                }
                return {
                    restrict: 'A',
                    require: 'ngModel',
                    compile: compile
                };
            }
            directive.dateInputFactory = dateInputFactory;
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            var validator;
            (function (validator) {
                function init(module) {
                    module.directive("synMessage", messagFactory);
                    module.directive("synValidator", validatorFactory);
                    module.directive("synAsyncValidator", asyncValidatorFactory);
                }
                validator.init = init;
                function asyncValidatorFactory($parse) {
                    function compile(tElement, tAttrs, transclude) {
                        return function postLink(scope, iElement, iAttrs, ngModel) {
                            var exp = tElement.attr("syn-async-validator");
                            if (!exp)
                                return;
                            ngModel.$asyncValidators["synAsyncValidator"] = function (modelValue, viewValue) {
                                var defer = framework.syn.ng.q.defer();
                                var rs = scope.$eval(exp, { value: modelValue });
                                if (rs) {
                                    if (angular.isString(rs)) {
                                        iElement.attr("syn-async-validator-message", rs);
                                        defer.reject();
                                    }
                                    else {
                                        if (rs.then) {
                                            rs.then(function (rs) {
                                                if (rs) {
                                                    iElement.attr("syn-async-validator-message", rs);
                                                    defer.reject();
                                                }
                                                else {
                                                    iElement.removeAttr("syn-async-validator-message");
                                                    defer.resolve();
                                                }
                                            }).catch(function (error) {
                                                iElement.attr("syn-async-validator-message", error.message || error.code);
                                                defer.reject();
                                            });
                                        }
                                    }
                                }
                                else {
                                    iElement.removeAttr("syn-async-validator-message");
                                    defer.resolve();
                                }
                                return defer.promise;
                            };
                        };
                    }
                    return {
                        restrict: 'A',
                        compile: compile,
                        require: 'ngModel',
                    };
                }
                function validatorFactory($parse) {
                    function compile(tElement, tAttrs, transclude) {
                        return function postLink(scope, iElement, iAttrs, ngModel) {
                            var exp = tElement.attr("syn-validator");
                            if (!exp)
                                return;
                            ngModel.$validators["synValidator"] = function (modelValue, viewValue) {
                                var rs = scope.$eval(exp, { value: modelValue });
                                if (rs) {
                                    iElement.attr("syn-validator-message", rs);
                                    return false;
                                }
                                else {
                                    iElement.removeAttr("syn-validator-message");
                                }
                                return true;
                            };
                        };
                    }
                    return {
                        restrict: 'A',
                        compile: compile,
                        require: 'ngModel',
                    };
                }
                function messagFactory() {
                    var MessageStatus = (function () {
                        function MessageStatus(successMessage) {
                            this.successMessage = successMessage;
                            this.showRequire = false;
                            this.showSuccess = false;
                            this.showError = false;
                            this.showSuccessMessage = false;
                            this.showSuccessIcon = false;
                            this.show = false;
                        }
                        MessageStatus.prototype.check = function (ngModel, ctrl) {
                            this.showSuccess = ngModel.$valid && (ctrl.showSuccessIcon || this.successMessage != null);
                            this.showSuccessMessage = this.showSuccess && this.successMessage != null;
                            this.showSuccessIcon = this.showSuccess && ctrl.showSuccessIcon && !this.showSuccessMessage;
                            this.showRequire = ngModel.$error.required;
                            this.showError = !this.showRequire && ctrl.showError;
                            this.show = this.showSuccess || this.showError;
                            if (!this.showError)
                                return;
                            this.error = ctrl.toErrorMessage();
                        };
                        return MessageStatus;
                    }());
                    var MessageController = (function () {
                        function MessageController(ngModel, el, scope) {
                            this.ngModel = ngModel;
                            this.el = el;
                            this.scope = scope;
                            this._status = new MessageStatus(this.successMessage);
                            this.showSuccessIcon = el.attr("show-success") != null;
                            this.successMessage = el.attr("success-message");
                            this.formFiled = el.parent().parent();
                        }
                        Object.defineProperty(MessageController.prototype, "status", {
                            get: function () {
                                return this._status;
                            },
                            enumerable: true,
                            configurable: true
                        });
                        Object.defineProperty(MessageController.prototype, "showError", {
                            get: function () {
                                if (this.showErrorExp && this.showErrorExp != "auto") {
                                    var codition = this.scope.$eval(this.showErrorExp, { ngModel: this.ngModel });
                                    return this.ngModel.$invalid && codition;
                                }
                                return this.ngModel.$invalid && this.ngModel.$dirty;
                            },
                            enumerable: true,
                            configurable: true
                        });
                        MessageController.prototype.init = function () {
                            var _this = this;
                            var formCtrl = this.ngModel["$$parentForm"];
                            if (formCtrl) {
                                var formEl = this.el.parents("form[name=\"" + formCtrl.$name + "\"]");
                                if (formEl.length > 0) {
                                    this.showErrorExp = formEl.attr("show-error");
                                }
                                if (formCtrl.$name === "modelForm" &&
                                    this.scope['model'] && this.scope['model']['isEditable']) {
                                    var model = this.scope['model'];
                                    if (!model.isEditable(this.ngModel.$name)) {
                                        this.ngModel.$validators = {};
                                        this.ngModel.$asyncValidators = {};
                                    }
                                }
                            }
                            var currentScope = this.scope.$new();
                            var tplEl = $(MessageController.tpl).appendTo(this.formFiled);
                            currentScope['vm'] = this;
                            framework.syn.ng.compile(tplEl)(currentScope);
                            currentScope.$watch("vm.status.showRequire", function (show) {
                                show ? _this.formFiled.addClass("required") : _this.formFiled.removeClass("required");
                            });
                            currentScope.$watch("vm.status.showError", function (show) {
                                show ? _this.formFiled.addClass("ui-error") : _this.formFiled.removeClass("ui-error");
                            });
                            currentScope.$watch("vm.status.showSuccess", function (show) {
                                show ? _this.formFiled.addClass("ui-success") : _this.formFiled.removeClass("ui-success");
                            });
                        };
                        MessageController.prototype.toErrorMessage = function () {
                            if (this.ngModel.$error.maxlength) {
                                return this.el.attr('maxlength-message') || "\u5B57\u7B26\u957F\u5EA6\u4E0D\u80FD\u5927\u4E8E" + this.el.attr("ng-maxlength");
                            }
                            else if (this.ngModel.$error.minlength) {
                                return this.el.attr('minlength-message') || "\u5B57\u7B26\u957F\u5EA6\u4E0D\u80FD\u5C0F\u4E8E" + this.el.attr("ng-minlength");
                            }
                            else if (this.ngModel.$error.email) {
                                return this.el.attr('email-message') || "\u90AE\u7BB1\u683C\u5F0F\u9519\u8BEF";
                            }
                            else if (this.ngModel.$error.url) {
                                return this.el.attr('url-message') || "url\u683C\u5F0F\u9519\u8BEF";
                            }
                            else if (this.ngModel.$error.max) {
                                return this.el.attr('max-message') || "\u4E0D\u80FD\u5927\u4E8E" + this.el.attr("ng-max");
                            }
                            else if (this.ngModel.$error.min) {
                                return this.el.attr('min-message') || "\u4E0D\u80FD\u5C0F\u4E8E" + this.el.attr("ng-min");
                            }
                            else if (this.ngModel.$error.pattern) {
                                return this.el.attr('pattern-message') || "\u8F93\u5165\u683C\u5F0F\u6709\u8BEF";
                            }
                            else if (this.ngModel.$error.synValidator) {
                                return this.el.attr('syn-validator-message');
                            }
                            else if (this.ngModel.$error.synAsyncValidator) {
                                return this.el.attr('syn-async-validator-message');
                            }
                            return "";
                        };
                        MessageController.prototype.checkStaus = function () {
                            this._status = new MessageStatus(this.successMessage);
                            this._status.check(this.ngModel, this);
                        };
                        MessageController.tpl = "\n            <div class=\"ui-message\" ng-show=\"vm.status.show\">\n                <i class=\"orange warning circle icon\" sm-popup data-content=\"{{vm.status.error}}\" ng-show=\"vm.status.showError\"></i>\n                <i class=\"green checkmark icon\" ng-show=\"vm.status.showSuccessIcon\"></i>\n                <div class=\"ui left pointing green basic label\" ng-bind=\"vm.status.successMessage\" \n                        ng-if=\"vm.status.showSuccessMessage\">\n                </div>\n            </div>\n            ";
                        return MessageController;
                    }());
                    function compile(tElement, tAttrs, transclude) {
                        return function postLink(scope, iElement, iAttrs, ngModel) {
                            var formFiled = iElement.parent().parent();
                            if (!formFiled.hasClass("ui-form-field")) {
                                return;
                            }
                            var ctrl = new MessageController(ngModel, iElement, scope);
                            ctrl.init();
                            scope.$watch(function () {
                                ctrl.checkStaus();
                            });
                        };
                    }
                    return {
                        restrict: 'A',
                        priority: 100,
                        compile: compile,
                        require: 'ngModel',
                    };
                }
            })(validator = directive.validator || (directive.validator = {}));
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            var scrollFixTable;
            (function (scrollFixTable) {
                function init(module) {
                    module.directive("synScrollFixTable", factory);
                }
                scrollFixTable.init = init;
                function factory($parse) {
                    function compile(tElement, tAttrs, transclude) {
                        return function postLink(scope, iElement, iAttrs, ngModel) {
                            var header = $("thead", iElement);
                            iElement.on("scroll", function (event) {
                                var scrollTop = iElement.scrollTop();
                                if (header.length > 0) {
                                    header[0].style.transform = 'translateY(' + scrollTop + 'px)';
                                }
                            });
                        };
                    }
                    return {
                        restrict: 'A',
                        compile: compile
                    };
                }
            })(scrollFixTable = directive.scrollFixTable || (directive.scrollFixTable = {}));
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            function frameLinkFactory() {
                function compile(tElement, tAttrs, transclude) {
                    return function postLink(scope, iElement, iAttrs) {
                        if (framework.syn.app.isMobileClient || framework.syn.app.isIPadClient) {
                            iElement.removeAttr("href");
                            iElement.click(function (event) {
                                event.preventDefault();
                                event.stopPropagation();
                                var params = {
                                    source: "object",
                                    pageId: iElement.attr("page-id"),
                                    pageName: iElement.attr("page-name"),
                                    objId: iElement.attr("obj-id"),
                                    objName: iElement.attr("obj-name"),
                                    pageUrl: iElement.attr("url"),
                                    pageParam: scope.$eval(iElement.attr("page-param"))
                                };
                                SynEvent.topTrigger("OpenPage", params);
                            });
                        }
                    };
                }
                return {
                    restrict: 'A',
                    compile: compile
                };
            }
            directive.frameLinkFactory = frameLinkFactory;
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            function elementInitFactory() {
                function compile(tElement, tAttrs, transclude) {
                    return function postLink(scope, iElement, iAttrs) {
                        scope.el = iElement;
                        scope.$eval(iAttrs.elementInit, { scope: scope });
                    };
                }
                return {
                    restrict: 'A',
                    compile: compile
                };
            }
            directive.elementInitFactory = elementInitFactory;
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            function portletFactory() {
                function compile(tElement, tAttrs, transclude) {
                    return function postLink(scope, iElement, iAttrs) {
                        var pageId = scope['pageId'];
                        if (pageId) {
                            var tpl = $("<include-page page-id=\"'" + pageId + "'\" style=\"" + tAttrs.style + "\" params=\"params\"></include-page>").insertAfter(iElement);
                            framework.syn.ng.compile(tpl)(scope);
                        }
                    };
                }
                return {
                    priority: 400,
                    terminal: true,
                    transclude: 'element',
                    restrict: 'A',
                    compile: compile
                };
            }
            directive.portletFactory = portletFactory;
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            var PostLink = (function () {
                function PostLink(scope, iElement, iAttrs, controller, transclude, tElement, tAttrs, compatible) {
                    this.scope = scope;
                    this.iElement = iElement;
                    this.iAttrs = iAttrs;
                    this.controller = controller;
                    this.transclude = transclude;
                    this.tElement = tElement;
                    this.tAttrs = tAttrs;
                    this.compatible = compatible;
                    this.childrenHtml = "";
                    this.init();
                }
                PostLink.prototype.init = function () {
                    var _this = this;
                    var onloadExp = this.tAttrs.onload;
                    var tmpScope = this.scope.$new();
                    this.transclude(tmpScope, function (el) {
                        var children = el.children();
                        if (children.length > 0) {
                            if (children[0].tagName.toLocaleLowerCase() == "template") {
                                _this.childrenHtml = children[0].innerHTML;
                            }
                            else {
                                _this.childrenHtml = el[0].innerHTML;
                            }
                        }
                        el.remove();
                    });
                    tmpScope.$destroy();
                    this.scope.$watch(this.tAttrs.pageId, function (pageId) {
                        if (pageId) {
                            framework.syn.component.load(pageId).then(function (component) {
                                _this.cleanupLastIncludeContent();
                                var attrs = {};
                                var params;
                                if (component.isComponent) {
                                    for (var key in _this.tAttrs.$attr) {
                                        var attr = _this.tAttrs.$attr[key];
                                        if (attr != 'ng-repeat' || attr != 'page-id') {
                                            attrs[attr] = _this.tAttrs[key];
                                        }
                                    }
                                }
                                if (_this.tAttrs.params) {
                                    params = _this.scope.$eval(_this.tAttrs.params);
                                }
                                _this.currentComponent = component.newInstance(_this.scope, {
                                    attrs: attrs,
                                    children: _this.childrenHtml,
                                    params: params
                                }).link(function (el) {
                                    if (component.isComponent) {
                                        el.insertAfter(_this.iElement);
                                        el.addClass("ui-item component");
                                    }
                                    else {
                                        if (_this.compatible) {
                                            var div = $("<div class='syn-include'></div>").insertAfter(_this.iElement);
                                            if (_this.tAttrs.style) {
                                                div.attr('style', _this.iAttrs.style);
                                            }
                                            el.appendTo(div);
                                        }
                                        else {
                                            el.insertAfter(_this.iElement);
                                        }
                                    }
                                });
                                _this.scope.$eval(onloadExp);
                            });
                        }
                        else {
                            _this.cleanupLastIncludeContent();
                        }
                    });
                };
                PostLink.prototype.cleanupLastIncludeContent = function () {
                    if (this.currentComponent) {
                        if (!this.currentComponent.component.isComponent && this.compatible) {
                            this.currentComponent.element.parent().remove();
                        }
                        this.currentComponent.dispose();
                        this.currentComponent = undefined;
                    }
                };
                return PostLink;
            }());
            function synComponentFactory() {
                return {
                    restrict: 'ECA',
                    priority: 400,
                    terminal: true,
                    transclude: 'element',
                    compile: function (tElement, tAttrs) {
                        return function (scope, iElement, iAttrs, controller, transclude) {
                            new PostLink(scope, iElement, iAttrs, controller, transclude, tElement, tAttrs, false);
                        };
                    }
                };
            }
            directive.synComponentFactory = synComponentFactory;
            function synComponentFactoryOld() {
                return {
                    restrict: 'ECA',
                    priority: 400,
                    terminal: true,
                    transclude: 'element',
                    compile: function (tElement, tAttrs) {
                        return function (scope, iElement, iAttrs, controller, transclude) {
                            new PostLink(scope, iElement, iAttrs, controller, transclude, tElement, tAttrs, true);
                        };
                    }
                };
            }
            directive.synComponentFactoryOld = synComponentFactoryOld;
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            var override;
            (function (override) {
                function init(module) {
                    var Override = (function () {
                        function Override(scope, elementId) {
                            this.scope = scope;
                            this.elementId = elementId;
                            this.interpolate = {};
                        }
                        Override.prototype.getKey = function (prop) {
                            return this.elementId + "." + prop;
                        };
                        Override.prototype.v = function (prop, option) {
                            var overrides = this.scope['$overrides'];
                            var key = this.getKey(prop);
                            if (overrides && overrides[key]) {
                                return this.scope.$eval(overrides[key]);
                            }
                            else {
                                return this.scope.$eval(option);
                            }
                        };
                        Override.prototype.t = function (prop, option) {
                            var overrides = this.scope['$overrides'];
                            var key = this.getKey(prop);
                            if (overrides && overrides[key]) {
                                return this.evalInterpolate(key, overrides[key]);
                            }
                            else {
                                return this.evalInterpolate(key + "_", option);
                            }
                        };
                        Override.prototype.evalInterpolate = function (key, expression) {
                            var item = this.interpolate[key];
                            if (!item) {
                                this.interpolate[key] = item = { expresion: expression, fn: framework.syn.ng.interpolate(expression) };
                            }
                            if (item.expresion != expression) {
                                item.expresion = expression;
                                item.fn = framework.syn.ng.interpolate(expression);
                            }
                            return item.fn(this.scope);
                        };
                        return Override;
                    }());
                    var OverrideController = (function () {
                        function OverrideController($scope, $element, $attrs) {
                            this.elementId = $attrs['synOverride'];
                            $scope["_o"] = new Override($scope, this.elementId);
                            console.log(this.elementId);
                        }
                        return OverrideController;
                    }());
                    module.directive("synOverride", function () {
                        return {
                            restrict: 'A',
                            priority: 800,
                            controller: OverrideController,
                            scope: true
                        };
                    });
                    module.directive("synOverrideNgIf", function () {
                        return {
                            restrict: 'A',
                            priority: 500,
                            controller: OverrideController,
                            scope: true
                        };
                    });
                }
                override.init = init;
            })(override = directive.override || (directive.override = {}));
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            var semantic;
            (function (semantic) {
                function smCheckboxFactory() {
                    function compile(tElement, tAttrs, transclude) {
                        var a;
                        return function postLink(scope, iElement, iAttrs, ngModel) {
                            if (!iElement.is('input'))
                                return;
                            var el = iElement.parent();
                            var cfg = scope.$eval(tAttrs.smCheckbox) || {};
                            cfg.onChange = function (value) {
                                if (!ngModel)
                                    return;
                                if (iElement.attr("type") == "checkbox") {
                                    ngModel.$setViewValue(iElement[0]['checked'], "change");
                                }
                                else if (iElement.attr("type") == "radio") {
                                    if (iElement[0]['checked']) {
                                        var value_1 = iAttrs.value;
                                        ngModel.$setViewValue(value_1, "change");
                                    }
                                }
                            };
                            el.checkbox(cfg);
                            var ngClick = iElement.attr("ng-click");
                            var ngDisable = iElement.attr("ng-disabled");
                            if (ngDisable) {
                                scope.$watch(ngDisable, function (value) {
                                    if (value) {
                                        iElement.parent().addClass("disable");
                                    }
                                    else {
                                        iElement.parent().removeClass("disable");
                                    }
                                });
                            }
                            if (ngClick) {
                                iElement.parent().click(function () {
                                    scope.$apply(function () {
                                        scope.$eval(ngClick);
                                    });
                                });
                            }
                        };
                    }
                    return {
                        restrict: 'A',
                        require: '?ngModel',
                        compile: compile
                    };
                }
                semantic.smCheckboxFactory = smCheckboxFactory;
            })(semantic = directive.semantic || (directive.semantic = {}));
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            var semantic;
            (function (semantic) {
                function smDropdownFactory() {
                    function compile(tElement, tAttrs, transclude) {
                        return function postLink(scope, iElement, iAttrs) {
                            var cfg = scope.$eval(iAttrs.smDropdown);
                            cfg = angular.merge({ action: "hide" }, cfg);
                            $(iElement)['dropdown'](cfg);
                        };
                    }
                    return {
                        restrict: 'A',
                        compile: compile
                    };
                }
                semantic.smDropdownFactory = smDropdownFactory;
            })(semantic = directive.semantic || (directive.semantic = {}));
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            var semantic;
            (function (semantic) {
                function smPopupFactory() {
                    function compile(tElement, tAttrs, transclude) {
                        return function postLink(scope, iElement, iAttrs) {
                            var cfg = scope.$eval(iAttrs.smPopup) || {};
                            var hoverable = cfg.inline && cfg.hoverable;
                            var popupEl = $(iElement.next()[0]);
                            var popupContent = $(popupEl.children()[0]);
                            var isClose = false;
                            var autoHeight = cfg.autoHeight;
                            if (autoHeight) {
                                if (!cfg.position) {
                                    cfg.position = "bottom right";
                                }
                                cfg.duration = 0;
                            }
                            popupEl.on("click", "a.item", function () {
                                isClose = true;
                                $(iElement)['popup']('hide');
                            });
                            cfg.onVisible = function () {
                                if (autoHeight) {
                                    popupContent.css("height", "auto").css("visibility", "visible");
                                }
                                isClose = false;
                            };
                            cfg.onShow = function () {
                                if (autoHeight) {
                                    popupContent.css("height", "20px").css("visibility", "hidden");
                                }
                                return true;
                            };
                            cfg.onHide = function (popup, el) {
                                if (isClose) {
                                    return true;
                                }
                                if (hoverable) {
                                    if (popupEl) {
                                        var rect = popupEl[0].getBoundingClientRect();
                                        var pageX = framework.syn.mouse.pageX;
                                        var pageY = framework.syn.mouse.pageY;
                                        if (pageX >= rect.left && pageX <= rect.right
                                            && pageY >= rect.top && pageY <= rect.bottom) {
                                            return false;
                                        }
                                    }
                                }
                                return true;
                            };
                            $(iElement)['popup'](cfg);
                        };
                    }
                    return {
                        restrict: 'A',
                        compile: compile
                    };
                }
                semantic.smPopupFactory = smPopupFactory;
            })(semantic = directive.semantic || (directive.semantic = {}));
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            var semantic;
            (function (semantic) {
                function smIconFactory() {
                    function compile(tElement, tAttrs) {
                        return function postLink(scope, iElement, iAttrs) {
                            var icon = iAttrs['smIcon'];
                            iElement.prepend("<i class=\"" + icon + " icon\"></i>");
                        };
                    }
                    return {
                        restrict: 'A',
                        compile: compile
                    };
                }
                semantic.smIconFactory = smIconFactory;
            })(semantic = directive.semantic || (directive.semantic = {}));
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            var semantic;
            (function (semantic) {
                function smTabFactory() {
                    function compile(tElement, tAttrs, transclude) {
                        return function postLink(scope, iElement, iAttrs) {
                            var cfg = scope.$eval(iAttrs.smTab);
                            $('.item', iElement)['tab'](cfg);
                        };
                    }
                    return {
                        restrict: 'A',
                        compile: compile
                    };
                }
                semantic.smTabFactory = smTabFactory;
            })(semantic = directive.semantic || (directive.semantic = {}));
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            function videoUploadFactory() {
                var FileInfo = (function () {
                    function FileInfo(info, uploader) {
                        this.info = info;
                        this.uploader = uploader;
                        this.uploadedSize = 0;
                        this.percent = 0;
                        this.file = info.file;
                        this.name = this.file.name;
                        this.size = this.file.size;
                        this.ossId = info.object;
                    }
                    Object.defineProperty(FileInfo.prototype, "state", {
                        get: function () {
                            return this.info.state;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    FileInfo.prototype.cancel = function () {
                        this.uploader.uploader.cancelFile(this.info.index);
                    };
                    FileInfo.prototype.resume = function () {
                        this.uploader.uploader.resumeFile(this.info.index);
                    };
                    FileInfo.prototype.remvoe = function () {
                    };
                    return FileInfo;
                }());
                var FileUploader = (function () {
                    function FileUploader(fileList, scope, onSuccess, fileFolderId, bizFolderId, tplId, isDebug) {
                        var _this = this;
                        this.fileList = fileList;
                        this.scope = scope;
                        this.onSuccess = onSuccess;
                        this.fileFolderId = fileFolderId;
                        this.bizFolderId = bizFolderId;
                        this.tplId = tplId;
                        this.isDebug = isDebug;
                        this.endpoint = "http://oss-cn-hangzhou.aliyuncs.com";
                        this.bucket = "syn-work";
                        this.userData = '{"Vod":{"Title":"","Description":""}}';
                        this.rpc = framework.syn.rpc.service("@AliyunService");
                        this.uploader = new VODUpload({
                            'onUploadFailed': function (uploadInfo, code, message) {
                                var fileInfo = _this.files[uploadInfo.index];
                                fileInfo.message = message;
                                fileInfo.code = code;
                                _this.scope.$applyAsync();
                                if (isDebug)
                                    console.log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message);
                            },
                            'onUploadSucceed': function (uploadInfo) {
                                var fileInfo = _this.files[uploadInfo.index];
                                _this.rpc.call("transcodeMedia", _this.fileFolderId, _this.bizFolderId, fileInfo.size, fileInfo.name, fileInfo.ossId, _this.tplId).subscribe(function (rs) {
                                    if (_this.onSuccess) {
                                        _this.scope.$eval(_this.onSuccess, { file: rs });
                                    }
                                });
                                if (isDebug)
                                    console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object);
                            },
                            'onUploadProgress': function (uploadInfo, totalSize, uploadedSize) {
                                var fileInfo = _this.files[uploadInfo.index];
                                fileInfo.uploadedSize = uploadedSize;
                                fileInfo.percent = Math.ceil(uploadedSize * 100 / totalSize);
                                _this.scope.$applyAsync();
                                if (isDebug)
                                    console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(uploadedSize * 100 / totalSize) + "%");
                            },
                            'onUploadTokenExpired': function () {
                                if (isDebug)
                                    console.log("onUploadTokenExpired");
                                _this.rpc.call("getOssToken").subscribe(function (rs) {
                                    _this.uploader.resumeUploadWithToken(rs.accessKeyId, rs.accessKeySecret, rs.securityToken, rs.expiration);
                                });
                            },
                            'onUploadstarted': function (uploadInfo) {
                                if (isDebug)
                                    console.log("onUploadStarted:" + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object);
                            }
                        });
                    }
                    FileUploader.prototype.start = function () {
                        var _this = this;
                        this.rpc.call("getOssToken").subscribe(function (rs) {
                            _this.uploader.init(rs.accessKeyId, rs.accessKeySecret, rs.securityToken, rs.expiration);
                            _this.files = [];
                            var path = "video-test/" + rs.did + "/" + moment().format("YYMM");
                            for (var i = 0; i < _this.fileList.length; i++) {
                                var ossId = path + "/" + ALY.util.uuid();
                                if (_this.tplId) {
                                    ossId += "-meida-origin";
                                }
                                _this.uploader.addFile(_this.fileList[i], _this.endpoint, _this.bucket, ossId, _this.userData);
                                var info = _this.uploader.listFiles()[i];
                                info.index = i;
                                _this.files.push(new FileInfo(info, _this));
                            }
                            _this.uploader.startUpload();
                        });
                    };
                    return FileUploader;
                }());
                function compile(tElement, tAttrs, transclude) {
                    require(['lib/aliyun/aliyun-sdk.min', 'lib/aliyun/vod-sdk-upload-1.0.6.min']);
                    var selectTemplateDlgId = 1201774;
                    var uploadDlgId = 1201776;
                    return function postLink(scope, iElement, iAttrs, ngModel) {
                        var isDebug = scope.$eval(iAttrs["debug"]) ? true : false;
                        var isMultiple = scope.$eval(iAttrs["multiple"]) ? true : false;
                        var accept = iAttrs["accept"] || "*";
                        var onSuccess = iAttrs["onSuccess"];
                        var input = $("<input type=\"file\" style=\"display:none\" value=\"\" " + (isMultiple ? "multiple" : "") + " accept=\"" + accept + "\">")
                            .appendTo('body');
                        input.change(function (event) {
                            var fileFolderId = scope.$eval(iAttrs['fileFolderId']) || -1;
                            var bizFolderId = scope.$eval(iAttrs['bizFolderId']) || -1;
                            var files = input[0].files;
                            framework.syn.dlg.openPage(selectTemplateDlgId).smallSize().onOk(function (tplId) {
                                var uploader = new FileUploader(files, scope, onSuccess, fileFolderId, bizFolderId, tplId, isDebug);
                                framework.syn.dlg.openSimplePage(uploadDlgId, { uploader: uploader }).smallSize()
                                    .onHidden(function (rs) {
                                    uploader.uploader.stopUpload();
                                });
                            });
                        });
                        iElement.click(function () {
                            input.val(null);
                            input.trigger("click");
                        });
                    };
                }
                return {
                    restrict: 'A',
                    compile: compile
                };
            }
            directive.videoUploadFactory = videoUploadFactory;
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            var nav;
            (function (nav_2) {
                var navKey = framework.service.nav.PageNavigator.key;
                function init(module) {
                    module.directive("synNavView", function () {
                        return {
                            restrict: 'A',
                            priority: 600,
                            controller: NavViewDirective
                        };
                    });
                    module.directive("synNavHome", function () {
                        return {
                            restrict: 'A',
                            compile: function (tElement, tAttrs) {
                                return function postLink(scope, iElement, iAttrs) {
                                    var nav = iElement.inheritedData(navKey);
                                    iElement.click(function () {
                                        nav.goHome();
                                    });
                                };
                            }
                        };
                    });
                    module.directive("synNavBack", function () {
                        return {
                            restrict: 'A',
                            compile: function (tElement, tAttrs) {
                                return function postLink(scope, iElement, iAttrs) {
                                    var nav = iElement.inheritedData(navKey);
                                    iElement.click(function () {
                                        nav.back(evalValue(iAttrs, scope, 'synNavBack'));
                                    });
                                };
                            }
                        };
                    });
                    module.directive("synNavPage", function () {
                        return {
                            restrict: 'A',
                            compile: function (tElement, tAttrs) {
                                return function postLink(scope, iElement, iAttrs) {
                                    var nav = iElement.inheritedData(navKey);
                                    iElement.click(function () {
                                        var value = evalValue(iAttrs, scope, 'synNavPage');
                                        if (!value)
                                            return;
                                        if (angular.isArray(value)) {
                                            nav.openPage(value[0], value[1]);
                                            return;
                                        }
                                        nav.openPage(value);
                                    });
                                };
                            }
                        };
                    });
                    function evalValue(iAttrs, scope, attrName) {
                        if (!iAttrs[attrName])
                            return null;
                        var value;
                        try {
                            value = scope.$eval(iAttrs[attrName]);
                        }
                        catch (e) {
                        }
                        return value;
                    }
                }
                nav_2.init = init;
                var NavViewDirective = (function () {
                    function NavViewDirective($scope, $element) {
                        new framework.service.nav.PageNavigator($scope, $element);
                    }
                    return NavViewDirective;
                }());
            })(nav = directive.nav || (directive.nav = {}));
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            var pageview;
            (function (pageview) {
                var nav = framework.service.nav;
                function init(module) {
                    module.directive("synPageView", function () {
                        return {
                            restrict: 'A',
                            controller: PageView
                        };
                    });
                }
                pageview.init = init;
                var Page = (function () {
                    function Page(id, params) {
                        this.id = id;
                        this.params = params;
                        this.isHide = true;
                    }
                    Page.prototype.show = function () {
                        var _this = this;
                        if (!this.isHide) {
                            return;
                        }
                        this.isHide = false;
                        if (this.el) {
                            this.el.show();
                            if (!framework.syn.isAngular1_5) {
                                framework.syn.ng.timeout(function () {
                                    _this.scope.$resume();
                                    _this.notifyPageShow();
                                }, 500);
                            }
                            else {
                                this.notifyPageShow();
                            }
                        }
                        this.isHide = false;
                    };
                    Page.prototype.hide = function () {
                        if (this.isHide) {
                            return;
                        }
                        this.isHide = true;
                        this.notifyPageHide();
                        if (this.el) {
                            this.el.hide();
                            if (!framework.syn.isAngular1_5) {
                                this.scope.$suspend();
                            }
                        }
                    };
                    Page.prototype.notifyPageShow = function () {
                        this.scope.$broadcast(nav.PAGE_EVENT_SHOW, this.id);
                    };
                    Page.prototype.notifyPageHide = function () {
                        this.scope.$broadcast(nav.PAGE_EVENT_HIDE, this.id);
                    };
                    Page.prototype.load = function (parentScope, parentEl) {
                        var _this = this;
                        var defer = framework.syn.ng.q.defer();
                        framework.syn.toast.showLoading();
                        framework.syn.component.load(this.id.toString()).then(function (component) {
                            var instance = component.newInstance(parentScope, { params: _this.params }).link(function (el) {
                                _this.el = el;
                                _this.el.appendTo(parentEl);
                            });
                            _this.scope = instance.scope;
                            framework.syn.toast.hide();
                            defer.resolve();
                        });
                        return defer.promise;
                    };
                    return Page;
                }());
                var PageView = (function () {
                    function PageView($scope, $element) {
                        var _this = this;
                        this.$scope = $scope;
                        this.$element = $element;
                        this.pageMap = {};
                        this.pageStack = [];
                        var expression = $element.attr("syn-page-view");
                        if (expression) {
                            framework.syn.ng.parse(expression).assign($scope, this);
                        }
                        $scope.$on(framework.service.nav.BACK_EVENT, function (event) {
                            if (event.defaultPrevented) {
                                return;
                            }
                            if (_this.pageStack.length <= 1) {
                                return;
                            }
                            _this.pageStack.pop();
                            var pageInfo = _this.pageStack[_this.pageStack.length - 1];
                            if (!pageInfo) {
                                return;
                            }
                            var page = _this.pageMap[pageInfo.id];
                            if (page) {
                                _this.showPage(page);
                                _this.currentPage = pageInfo.id;
                                event.preventDefault();
                                framework.syn.ng.timeout();
                            }
                        });
                    }
                    PageView.prototype.pushState = function (pageIdOrName, params) {
                        framework.service.nav.nav.pushBack();
                        if (this.pageStack.length >= PageView.maxStack) {
                            this.pageStack.splice(0, 1);
                        }
                        this.pageStack.push({ id: pageIdOrName, params: params });
                    };
                    PageView.prototype.loadPage = function (pageIdOrName, params) {
                        var _this = this;
                        this.currentPage = pageIdOrName;
                        var id = pageIdOrName.toString();
                        var page = this.pageMap[id];
                        this.pushState(pageIdOrName, params);
                        if (page) {
                            this.showPage(page);
                        }
                        else {
                            page = new Page(pageIdOrName, params);
                            this.pageMap[id] = page;
                            page.load(this.$scope, this.$element).then(function () {
                                _this.showPage(page);
                            });
                        }
                    };
                    PageView.prototype.showPage = function (page) {
                        angular.forEach(this.pageMap, function (value, key) {
                            if (page === value) {
                                value.show();
                            }
                            else {
                                value.hide();
                            }
                        });
                    };
                    PageView.maxStack = 20;
                    return PageView;
                }());
                pageview.PageView = PageView;
            })(pageview = directive.pageview || (directive.pageview = {}));
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var directive;
        (function (directive) {
            var page;
            (function (page) {
                function init(module) {
                    module.directive("synPage", function () {
                        return {
                            restrict: 'A',
                            priority: 9999,
                            compile: function (tElement, tAttrs, transclude) {
                                return function postLink(scope, iElement, iAttrs) {
                                    var pageId = iElement.attr("page-id");
                                    if (!scope['$pageId'])
                                        scope['$pageId'] = pageId;
                                };
                            }
                        };
                    });
                }
                page.init = init;
            })(page = directive.page || (directive.page = {}));
        })(directive = framework.directive || (framework.directive = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var component;
        (function (component) {
            var dataGrid;
            (function (dataGrid) {
                function init(module) {
                    DataGrid.init(module);
                    dataGrid.DataGridHeadComponent.init(module);
                    dataGrid.DataGridRowComponent.init(module);
                    dataGrid.DataGridRowCellComponent.init(module);
                }
                dataGrid.init = init;
                var DataGrid = (function () {
                    function DataGrid($scope, $element, $compile) {
                        this.scrollBarWidth = 20;
                        this._position = 0;
                        this.gridBodyHeight = 0;
                        this.gridBodyWdith = 0;
                        this._checked = false;
                        this.sortColumns = [];
                        this.vScrollbarWidth = 14;
                        this._rows = new synwork.utils.ArrayList();
                        this._items = new synwork.utils.ArrayList();
                        this._renderers = new synwork.utils.ArrayList();
                        this._selection = new synwork.utils.ArrayList();
                        this.scope = $scope;
                        this.el = $element;
                        this.compile = $compile;
                    }
                    DataGrid.init = function (module) {
                        module.component("synDataGrid", {
                            controller: DataGrid,
                            controllerAs: "vm",
                            template: DataGrid.tpl,
                            replace: true,
                            bindings: {
                                rowHeight: '<',
                                headHeight: '<',
                                data: '<',
                                enableSelection: '<',
                                multiSelect: "<",
                                enableCheckbox: '<',
                                enableRowNumber: '<',
                                rowNumberWidth: '<',
                                gridCls: '<',
                                columns: '<',
                                editable: '<',
                                onReady: '&'
                            }
                        });
                    };
                    DataGrid.headsTpl = function (position) {
                        return "<div class=\"" + position + " sgrid-heads\" ng-if=\"vm.has" + position + "Columns\">\n                <syn-grid-head ng-repeat=\"col in vm." + position + "HeadColumns\" col=\"col\"></syn-grid-head>\n            </div>\n            ";
                    };
                    DataGrid.rowsTpl = function (position) {
                        return "<div class=\"" + position + " sgrid-rows\" ng-if=\"vm.has" + position + "Columns\">\n                <div>\n                    <syn-grid-row ng-click=\"vm.onRowClick(renderer.row,$event)\" ng-class=\"{selected:renderer.row.checked}\" ng-if=\"renderer.isVisible\" ng-repeat=\"renderer in vm.renderers\" columns=\"vm." + position + "RowColumns\" renderer=\"renderer\"></syn-grid-row>\n                </div>\n            </div>\n            ";
                    };
                    DataGrid.prototype.$onInit = function () {
                        var _this = this;
                        $("body").mousedown(function (event) {
                            _this.onMouseDown(event);
                        });
                        angular.merge(this, {
                            rowHeight: 30,
                            headHeight: 30
                        });
                        this.buildGrid();
                        this.scope.$watchCollection('vm.columns', function (value) {
                            if (value) {
                                _this.buildColumnModel();
                                framework.syn.ng.timeout(function () {
                                    _this.layout();
                                });
                            }
                        });
                        this.scope.$watchCollection('vm.data', function (newValue) {
                            _this._rows.clear();
                            if (newValue) {
                                _this.buildRowModel();
                                _this.gridBodyHeight = 0;
                                _this.layout();
                            }
                        });
                        if (this.onReady) {
                            this.onReady({ grid: this });
                        }
                    };
                    Object.defineProperty(DataGrid.prototype, "hasleftColumns", {
                        get: function () {
                            return this.leftHeadColumns && this.leftHeadColumns.length > 0;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGrid.prototype, "hasrightColumns", {
                        get: function () {
                            return this.rightHeadColumns && this.rightHeadColumns.length > 0;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGrid.prototype, "hascenterColumns", {
                        get: function () {
                            return this.centerHeadColumns && this.centerHeadColumns.length > 0;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    DataGrid.prototype.buildColumnModel = function () {
                        var _this = this;
                        this.leftHeadColumns = [];
                        this.centerHeadColumns = [];
                        this.rightHeadColumns = [];
                        this.leftRowColumns = [];
                        this.centerRowColumns = [];
                        this.rightRowColumns = [];
                        var centerColumnVisted = false;
                        this.columns.forEach(function (col) {
                            if (col.fixed) {
                                if (!centerColumnVisted) {
                                    _this.leftHeadColumns.push(new dataGrid.DataGridColumn(col));
                                }
                                else {
                                    _this.rightHeadColumns.push(new dataGrid.DataGridColumn(col));
                                }
                            }
                            else {
                                centerColumnVisted = true;
                                _this.centerHeadColumns.push(new dataGrid.DataGridColumn(col));
                            }
                        });
                        if (this.enableRowNumber) {
                            this.leftHeadColumns.unshift(new dataGrid.DataGridColumn({
                                title: '行号',
                                width: this.rowNumberWidth || 50,
                                fixWidth: true,
                                cellTpl: "{{row.number}}"
                            }));
                        }
                        if (this.enableCheckbox) {
                            this.leftHeadColumns.unshift(new dataGrid.DataGridColumn({
                                headTpl: "<div class=\"ui checkbox\"><input type=\"checkbox\" sm-checkbox ng-model=\"grid.checked\"><label></label></div>",
                                headCls: 'checkbox',
                                fixWidth: true,
                                width: 40,
                                cellTpl: "<div class=\"ui checkbox\"><input type=\"checkbox\" sm-checkbox ng-model=\"row.checked\"><label></label></div>",
                                cellCls: 'checkbox',
                            }));
                        }
                        this.leftRowColumns = _.flatMap(this.leftHeadColumns, "rowColumns");
                        this.centerRowColumns = _.flatMap(this.centerHeadColumns, "rowColumns");
                        this.rightRowColumns = _.flatMap(this.rightHeadColumns, "rowColumns");
                        this.gridBodyWdith = this.gridBodyHeight = 0;
                    };
                    DataGrid.prototype.buildGrid = function () {
                        var _this = this;
                        this.vScrollCt = $('div.sgrid-vscroll-bar', this.el);
                        this.vScrollContent = $('<div></div>').appendTo(this.vScrollCt);
                        this.hScrollCt = $('div.sgrid-hscroll-bar', this.el);
                        this.hScrollContent = $('<div></div>').appendTo(this.hScrollCt);
                        this.gridCt = $('div.sgrid-ct', this.el);
                        this.gridBody = $('div.sgrid-row-ct', this.gridCt);
                        this.gridHead = $('div.sgrid-head-ct', this.gridCt);
                        this.gridFoot = $('div.sgrid-foot-ct', this.gridCt);
                        this.vScrollCt.on('scroll', this.onVScroll.bind(this));
                        this.hScrollCt.on('scroll', this.onHScroll.bind(this));
                        this.gridCt[0].addEventListener("mousewheel", this.onMouseWheel.bind(this));
                        setInterval(function () {
                            _this.layout();
                        }, 2000);
                    };
                    DataGrid.prototype.onHScroll = function () {
                        var left = this.hScrollCt.scrollLeft();
                        $('div.center.sgrid-rows', this.gridCt).scrollLeft(left);
                        $('div.center.sgrid-heads', this.gridCt).scrollLeft(left);
                    };
                    DataGrid.prototype.onVScroll = function () {
                        var top = this.vScrollCt.scrollTop();
                        this._position = Math.floor(top / this.rowHeight);
                        this.updaePosition();
                    };
                    DataGrid.prototype.onMouseWheel = function (event) {
                        var _this = this;
                        var top = this.vScrollCt.scrollTop();
                        top = top + this.rowHeight * (event.deltaY / Math.abs(event.deltaY)) * 3;
                        this.vScrollCt.scrollTop(top);
                        if (window.requestAnimationFrame) {
                            window.requestAnimationFrame(function () {
                                _this.onVScroll();
                            });
                        }
                        else {
                            this.onVScroll();
                        }
                    };
                    DataGrid.prototype.updaePosition = function () {
                        this.scope.$applyAsync();
                    };
                    Object.defineProperty(DataGrid.prototype, "columns", {
                        get: function () {
                            return this._columns;
                        },
                        set: function (value) {
                            this._columns = value;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGrid.prototype, "selectedRows", {
                        get: function () {
                            return;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGrid.prototype, "position", {
                        get: function () {
                            return this._position;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGrid.prototype, "rows", {
                        get: function () {
                            return this._rows.array;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGrid.prototype, "renderers", {
                        get: function () {
                            return this._renderers.array;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGrid.prototype, "gridFootHeight", {
                        get: function () {
                            return this.gridFoot.length > 0 ? this.gridFoot.height() : 0;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGrid.prototype, "gridHeadHeight", {
                        get: function () {
                            return this.gridHead.length > 0 ? this.gridHead.height() : 0;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    DataGrid.prototype.layout = function () {
                        if (!this.columns) {
                            return;
                        }
                        var currentBodyHeight = Math.floor(this.gridBody.height());
                        var currentBodyWidth = Math.floor(this.gridBody.width());
                        if (currentBodyWidth != this.gridBodyWdith) {
                            this.gridBodyWdith = currentBodyWidth;
                            this.computeColumnWidths();
                            var centerWidth = _.sumBy(this.centerHeadColumns, "acturalWidth");
                            var leftWidth = _.sumBy(this.leftHeadColumns, "acturalWidth");
                            var rightWidth = _.sumBy(this.rightHeadColumns, "acturalWidth");
                            this.hScrollContent.width(leftWidth + centerWidth + rightWidth + "px");
                            this.scope.$applyAsync();
                        }
                        if (currentBodyHeight != this.gridBodyHeight) {
                            this.gridBodyHeight = currentBodyHeight;
                            var rendererCount = Math.ceil(this.gridBodyHeight / this.rowHeight);
                            var totalHeight = this._rows.size * this.rowHeight;
                            rendererCount = Math.min(this._rows.size, rendererCount);
                            if (rendererCount != this._renderers.size) {
                                this._renderers.clear();
                                for (var i = 0; i < rendererCount; i++) {
                                    this._renderers.add(new dataGrid.DataGridRowRenderer(i, this));
                                }
                            }
                            this.vScrollContent.height(Math.floor(totalHeight + this.rowHeight * 2) + "px");
                            if (totalHeight > this.gridBodyHeight) {
                                this.vScrollCt.show();
                            }
                            else {
                                this.vScrollCt.hide();
                            }
                            this.updaePosition();
                        }
                    };
                    DataGrid.prototype.computeColumnWidths = function () {
                        var rowColumns = _.flatten([this.leftRowColumns, this.centerRowColumns, this.rightRowColumns]);
                        var fixWidth = _.sumBy(_.filter(rowColumns, "cfg.fixWidth"), "width");
                        var totalWidth = _.sumBy(rowColumns, "width");
                        var viewWidth = this.gridBody.width() - this.vScrollbarWidth;
                        if (totalWidth < viewWidth) {
                            this.hScrollCt.hide();
                            var ratio_1 = (viewWidth - fixWidth) / (totalWidth - fixWidth);
                            rowColumns.forEach(function (col) {
                                if (col.cfg.fixWidth) {
                                    col.acturalWidth = col.width;
                                }
                                else {
                                    col.acturalWidth = col.width * ratio_1;
                                }
                            });
                        }
                        else {
                            rowColumns.forEach(function (col) {
                                col.acturalWidth = Number(col.width);
                            });
                            this.hScrollCt.show();
                        }
                        var headColumns = _.flatten([this.leftHeadColumns, this.centerHeadColumns, this.rightHeadColumns]);
                        headColumns.forEach(function (col) {
                            col.computeWidth();
                        });
                    };
                    Object.defineProperty(DataGrid.prototype, "appScope", {
                        get: function () {
                            return this.scope.$parent;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    DataGrid.prototype.buildRowModel = function () {
                        var _this = this;
                        if (this.sortColumns.length > 0) {
                            this._items.array = _.orderBy(this.data, this.sortColumns.map(function (it) { return it.sortable; }), this.sortColumns.map(function (it) { return it.sortOrder; }));
                        }
                        else {
                            this._items.array = this.data;
                        }
                        this._rows.clear();
                        this._selection.clear();
                        this._items.array.forEach(function (item, index) {
                            var row = item.$row;
                            if (!row) {
                                row = new dataGrid.DataGridRow(item, _this);
                                item.$row = row;
                            }
                            row.number = index + 1;
                            row.grid = _this;
                            _this._rows.add(row);
                        });
                    };
                    DataGrid.prototype.addRow = function (item) {
                        this._items.add(item);
                    };
                    DataGrid.prototype.removeRow = function (item) {
                        this._items.remove(item);
                    };
                    DataGrid.prototype.commit = function () {
                        this._rows.array.forEach(function (row) {
                            row.commit();
                        });
                    };
                    Object.defineProperty(DataGrid.prototype, "changedItems", {
                        get: function () {
                            return this.changedRows.map(function (row) { return row.item; });
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGrid.prototype, "changedRows", {
                        get: function () {
                            return _.filter(this._rows.array, "isChange");
                        },
                        enumerable: true,
                        configurable: true
                    });
                    DataGrid.prototype.onMouseDown = function (event) {
                        if (this.editCell) {
                            if ($(event.target).parents(".layui-laydate").length > 0) {
                                return;
                            }
                            this.editCell.onEndEdit();
                            this.editCell = null;
                        }
                    };
                    DataGrid.prototype.clearSelection = function () {
                        this._checked = false;
                        this._selection.array.forEach(function (row) {
                            row.isSelected = false;
                        });
                        this._selection.clear();
                    };
                    DataGrid.prototype.selectAll = function () {
                        var _this = this;
                        this._checked = true;
                        this._selection.clear();
                        this._rows.array.forEach(function (row) {
                            row.isSelected = true;
                            _this._selection.add(row);
                        });
                    };
                    Object.defineProperty(DataGrid.prototype, "selection", {
                        get: function () {
                            return this._selection.array;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGrid.prototype, "selectedCount", {
                        get: function () {
                            return this._selection.size;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGrid.prototype, "hasSelection", {
                        get: function () {
                            return this.selectedCount > 0;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGrid.prototype, "firstSelected", {
                        get: function () {
                            return this._selection.first;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGrid.prototype, "lastSelected", {
                        get: function () {
                            return this._selection.last;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    DataGrid.prototype.selectRow = function (row) {
                        row.isSelected = true;
                        if (!this._selection.contains(row))
                            this._selection.add(row);
                    };
                    DataGrid.prototype.unSelectRow = function (row) {
                        row.isSelected = false;
                        this._selection.remove(row);
                    };
                    DataGrid.prototype.selectRowByItem = function (item) {
                        var row = item.$item;
                        if (row) {
                            this.selectRow(row);
                        }
                    };
                    DataGrid.prototype.unSelectRowByItem = function (item) {
                        var row = item.$item;
                        if (row) {
                            this.unSelectRow(row);
                        }
                    };
                    DataGrid.prototype.onColumnClick = function (col) {
                        if (!col.sortable)
                            return;
                        _.remove(this.sortColumns, col);
                        this.sortColumns.forEach(function (it) {
                            it.sortIndex = 0;
                            it.sortOrder = "";
                        });
                        if (col.sortOrder === "") {
                            col.sortOrder = "asc";
                        }
                        else if (col.sortOrder === "asc") {
                            col.sortOrder = "desc";
                        }
                        else if (col.sortOrder === "desc") {
                            col.sortOrder = "";
                        }
                        if (col.sortOrder) {
                            col.sortIndex = 1;
                            this.sortColumns = [col];
                        }
                        this.buildRowModel();
                    };
                    DataGrid.prototype.onRowClick = function (row, event) {
                        if (this.enableCheckbox)
                            return;
                        if (!this.enableSelection)
                            return;
                        if (this.multiSelect && (event.ctrlKey || event.shiftKey)) {
                            if (event.ctrlKey) {
                                if (row.isSelected) {
                                    this.unSelectRow(row);
                                }
                                else {
                                    this.selectRow(row);
                                }
                            }
                            else if (event.shiftKey) {
                                var last = this.lastSelected;
                                if (last) {
                                    var lastIndex = this._rows.indexOf(last);
                                    var index = this._rows.indexOf(row);
                                    var start = lastIndex;
                                    var end = index;
                                    if (lastIndex > index) {
                                        start = index;
                                        end = lastIndex;
                                    }
                                    this.clearSelection();
                                    for (var i = start; i <= end; i++) {
                                        this.selectRow(this._rows.getAt(i));
                                    }
                                }
                                else {
                                    this.selectRow(row);
                                }
                            }
                        }
                        else {
                            var isSelected = row.isSelected;
                            this.clearSelection();
                            if (!isSelected) {
                                this.selectRow(row);
                            }
                        }
                    };
                    Object.defineProperty(DataGrid.prototype, "checked", {
                        get: function () {
                            return this._checked;
                        },
                        set: function (value) {
                            if (value) {
                                this.selectAll();
                            }
                            else {
                                this.clearSelection();
                            }
                        },
                        enumerable: true,
                        configurable: true
                    });
                    DataGrid.prototype.onCheckClick = function (event) {
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                    };
                    DataGrid.prototype.scrollToItem = function (item) {
                        var row = item.$row;
                        if (row) {
                            this.scrollToRow(row);
                        }
                    };
                    DataGrid.prototype.scrollToRow = function (row) {
                        var index = this._rows.indexOf(row);
                        var top = this.rowHeight * index;
                        this.vScrollCt.scrollTop(top);
                        this.onVScroll();
                    };
                    DataGrid.tpl = "\n        <div class=\"sgrid-ct\">\n            <div class=\"sgrid-head-ct\">\n                " + DataGrid.headsTpl('left') + "\n                " + DataGrid.headsTpl('center') + "\n                " + DataGrid.headsTpl('right') + "\n                <div class=\"sgrid-head-pad\"></div>\n            </div>\n            <div class=\"sgrid-row-ct\">\n                " + DataGrid.rowsTpl('left') + "\n                " + DataGrid.rowsTpl('center') + "\n                " + DataGrid.rowsTpl('right') + "\n                <div class=\"sgrid-row-pad\">\n                    <div ng-repeat=\"renderer in vm.renderers\" style=\"height:{{vm.rowHeight}}px\"></div>            \n                </div>  \n                <div class=\"sgrid-vscroll-bar\"></div>              \n            </div>\n            <div class=\"sgrid-hscroll-bar\"></div>    \n        </div> \n        ";
                    return DataGrid;
                }());
                dataGrid.DataGrid = DataGrid;
            })(dataGrid = component.dataGrid || (component.dataGrid = {}));
        })(component = framework.component || (framework.component = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var component;
        (function (component) {
            var dataGrid;
            (function (dataGrid) {
                var DataGridHeadComponent = (function () {
                    function DataGridHeadComponent($scope, $element, $compile) {
                        this.scope = $scope;
                        this.el = $element;
                        this.compile = $compile;
                    }
                    DataGridHeadComponent.init = function (module) {
                        module.component("synGridHead", {
                            controller: DataGridHeadComponent,
                            controllerAs: "vm",
                            template: DataGridHeadComponent.tpl,
                            replace: true,
                            require: {
                                'grid': '^synDataGrid'
                            },
                            bindings: {
                                col: '<',
                            }
                        });
                    };
                    DataGridHeadComponent.prototype.$onInit = function () {
                        var _this = this;
                        this.headCell = $(">.sgrid-head-cell", this.el);
                        var colCfg = this.col.cfg;
                        this.scope['appScope'] = this.grid.appScope;
                        this.scope['grid'] = this.grid;
                        this.scope['col'] = this.col;
                        if (this.isFieldColumn) {
                            this.el.addClass("field");
                        }
                        else {
                            this.el.removeClass("field");
                        }
                        this.scope.$watch("vm.col.acturalWidth", (function (newWidth, oldWidth) {
                            if (newWidth) {
                                _this.headCell.css("width", newWidth + "px");
                            }
                        }));
                        var tpl = '';
                        if (colCfg.headTpl) {
                            tpl = "<div class=\"title\" ng-class=\"vm.sortCls()\">" + colCfg.headTpl + "</div>";
                        }
                        else if (colCfg.title) {
                            tpl = "<div class=\"title\" ng-class=\"vm.sortCls()\">" + colCfg.title + "</div>";
                        }
                        var cellEl = this.compile(tpl)(this.scope);
                        cellEl.appendTo(this.headCell);
                    };
                    Object.defineProperty(DataGridHeadComponent.prototype, "isFieldColumn", {
                        get: function () {
                            return this.col && this.col.columns.length == 0;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGridHeadComponent.prototype, "columns", {
                        get: function () {
                            return this.col.columns;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    DataGridHeadComponent.prototype.headStyle = function () {
                        var cfg = this.col.cfg;
                        if (cfg.headStyle) {
                            if (angular.isFunction(cfg.headStyle)) {
                                return cfg.headStyle(this.col);
                            }
                            else {
                                return cfg.headStyle;
                            }
                        }
                        return null;
                    };
                    DataGridHeadComponent.prototype.sortCls = function () {
                        if (this.col.sortable)
                            return "sortable " + this.col.sortOrder;
                        else
                            return "";
                    };
                    DataGridHeadComponent.prototype.headCls = function () {
                        var cfg = this.col.cfg;
                        var cls = "";
                        if (cfg.headCls) {
                            if (angular.isFunction(cfg.headCls)) {
                                cls = cfg.headCls(this.col);
                            }
                            else {
                                cls = cfg.headCls;
                            }
                        }
                        if (cfg.headAlign) {
                            cls += " align-" + cfg.headAlign;
                        }
                        return cls;
                    };
                    DataGridHeadComponent.tpl = "\n        <div class=\"sgrid-head-cell\" ng-class=\"vm.headCls()\" ng-style=\"vm.headStyle()\" ng-click=\"vm.grid.onColumnClick(vm.col)\"></div>\n        <div class=\"sgrid-columns\" ng-if=\"!vm.isFieldColumn\">\n            <syn-grid-head ng-repeat=\"col in vm.columns\" col=\"col\"></syn-grid-head>\n        </div>\n        ";
                    return DataGridHeadComponent;
                }());
                dataGrid.DataGridHeadComponent = DataGridHeadComponent;
            })(dataGrid = component.dataGrid || (component.dataGrid = {}));
        })(component = framework.component || (framework.component = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var component;
        (function (component) {
            var dataGrid;
            (function (dataGrid) {
                var DataGridRowComponent = (function () {
                    function DataGridRowComponent($scope, $element, $compile) {
                        this.scope = $scope;
                        this.el = $element;
                        this.compile = $compile;
                    }
                    DataGridRowComponent.init = function (module) {
                        module.component("synGridRow", {
                            controller: DataGridRowComponent,
                            controllerAs: "vm",
                            template: DataGridRowComponent.tpl,
                            replace: true,
                            require: {
                                'grid': '^synDataGrid'
                            },
                            bindings: {
                                renderer: '<',
                                columns: '<'
                            }
                        });
                    };
                    DataGridRowComponent.prototype.$onInit = function () {
                        this.el.css("height", this.grid.rowHeight + "px");
                    };
                    DataGridRowComponent.prototype.cellStyle = function (col) {
                        var cfg = col.cfg;
                        if (cfg.cellStyle) {
                            if (angular.isFunction(cfg.cellStyle)) {
                                return cfg.cellStyle(this.renderer.row, col);
                            }
                            else {
                                return cfg.cellStyle;
                            }
                        }
                        return null;
                    };
                    DataGridRowComponent.prototype.selectRow = function () {
                        this.grid.selectRow;
                    };
                    DataGridRowComponent.prototype.cellCls = function (col) {
                        var cfg = col.cfg;
                        var cls = "";
                        if (cfg.cellCls) {
                            if (angular.isFunction(cfg.cellCls)) {
                                cls = cfg.cellCls(this.renderer.row, col);
                            }
                            else {
                                cls = cfg.cellCls;
                            }
                        }
                        if (cfg.cellAlign) {
                            cls += " align-" + cfg.cellAlign;
                        }
                        return cls;
                    };
                    DataGridRowComponent.tpl = "       \n            <syn-grid-row-cell ng-class=\"vm.cellCls(col)\" ng-style=\"vm.cellStyle(col)\" ng-repeat=\"col in vm.columns\" \n            col=\"col\" renderer=\"vm.renderer\"></syn-grid-row-cell>\n        ";
                    return DataGridRowComponent;
                }());
                dataGrid.DataGridRowComponent = DataGridRowComponent;
            })(dataGrid = component.dataGrid || (component.dataGrid = {}));
        })(component = framework.component || (framework.component = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var component;
        (function (component) {
            var dataGrid;
            (function (dataGrid) {
                var ColumnDef = (function () {
                    function ColumnDef() {
                    }
                    return ColumnDef;
                }());
                dataGrid.ColumnDef = ColumnDef;
                var DataGridColumn = (function () {
                    function DataGridColumn(cfg) {
                        var _this = this;
                        this.cfg = cfg;
                        this.acturalWidth = 0;
                        this.sortIndex = 0;
                        this.sortOrder = "";
                        this.isFieldColumn = false;
                        this.columns = [];
                        if (cfg.columns) {
                            cfg.columns.forEach(function (child) {
                                var gridColumn = new DataGridColumn(child);
                                gridColumn.parent = _this;
                                _this.columns.push(gridColumn);
                            });
                        }
                        this.isFieldColumn = this.columns.length == 0;
                    }
                    DataGridColumn.prototype.visit = function (fn) {
                        fn(this);
                        this.columns.forEach(function (child) { return child.visit(fn); });
                    };
                    Object.defineProperty(DataGridColumn.prototype, "rowColumns", {
                        get: function () {
                            var rs = [];
                            this.visit(function (col) {
                                if (col.columns.length == 0) {
                                    rs.push(col);
                                }
                            });
                            return rs;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGridColumn.prototype, "isBodyColumn", {
                        get: function () {
                            return false;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGridColumn.prototype, "width", {
                        get: function () {
                            return this.cfg.width || 80;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    DataGridColumn.prototype.computeWidth = function () {
                        var _this = this;
                        if (this.isFieldColumn) {
                            return;
                        }
                        this.acturalWidth = 0;
                        this.columns.forEach(function (col) {
                            col.computeWidth();
                            _this.acturalWidth += col.acturalWidth;
                        });
                    };
                    Object.defineProperty(DataGridColumn.prototype, "sortable", {
                        get: function () {
                            return this.cfg.field || this.cfg.sortField || this.cfg.sortFn;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    return DataGridColumn;
                }());
                dataGrid.DataGridColumn = DataGridColumn;
                var DataGridRow = (function () {
                    function DataGridRow(item, grid) {
                        this.item = item;
                        this.grid = grid;
                        this.number = 0;
                        this.isSelected = false;
                        this.isChange = false;
                        item.$row = this;
                    }
                    Object.defineProperty(DataGridRow.prototype, "checked", {
                        get: function () {
                            return this.isSelected;
                        },
                        set: function (value) {
                            if (value) {
                                this.grid.selectRow(this);
                            }
                            else {
                                this.grid.unSelectRow(this);
                            }
                        },
                        enumerable: true,
                        configurable: true
                    });
                    DataGridRow.prototype.setChange = function (prop) {
                        this.isChange = true;
                    };
                    DataGridRow.prototype.commit = function () {
                        this.isChange = false;
                    };
                    return DataGridRow;
                }());
                dataGrid.DataGridRow = DataGridRow;
            })(dataGrid = component.dataGrid || (component.dataGrid = {}));
        })(component = framework.component || (framework.component = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var component;
        (function (component) {
            var dataGrid;
            (function (dataGrid) {
                var DataGridRowRenderer = (function () {
                    function DataGridRowRenderer(index, grid) {
                        this.index = index;
                        this.grid = grid;
                    }
                    Object.defineProperty(DataGridRowRenderer.prototype, "row", {
                        get: function () {
                            var index = this.index + this.grid.position;
                            if (index < this.grid.rows.length) {
                                return this.grid.rows[this.index + this.grid.position];
                            }
                            else {
                                return null;
                            }
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGridRowRenderer.prototype, "item", {
                        get: function () {
                            var row = this.row;
                            return row ? row.item : null;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGridRowRenderer.prototype, "isVisible", {
                        get: function () {
                            return this.row != null;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGridRowRenderer.prototype, "appScope", {
                        get: function () {
                            return this.grid.appScope;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    return DataGridRowRenderer;
                }());
                dataGrid.DataGridRowRenderer = DataGridRowRenderer;
            })(dataGrid = component.dataGrid || (component.dataGrid = {}));
        })(component = framework.component || (framework.component = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var component;
        (function (component) {
            var dataGrid;
            (function (dataGrid) {
                var DataGridRowCellComponent = (function () {
                    function DataGridRowCellComponent($scope, $element, $compile) {
                        this.scope = $scope;
                        this.el = $element;
                        this.compile = $compile;
                    }
                    DataGridRowCellComponent.init = function (module) {
                        module.component("synGridRowCell", {
                            controller: DataGridRowCellComponent,
                            controllerAs: "vm",
                            template: DataGridRowCellComponent.tpl,
                            replace: true,
                            bindings: {
                                col: '<',
                                renderer: '<'
                            }
                        });
                    };
                    Object.defineProperty(DataGridRowCellComponent.prototype, "item", {
                        get: function () {
                            return this.renderer.item;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataGridRowCellComponent.prototype, "editable", {
                        get: function () {
                            if (!this.col.cfg.field) {
                                return false;
                            }
                            if (this.col.cfg.editable !== undefined) {
                                return this.col.cfg.editable;
                            }
                            return this.renderer.grid.editable;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    DataGridRowCellComponent.prototype.$onInit = function () {
                        var _this = this;
                        this.scope.$watch("vm.col.acturalWidth", function (newWidth) {
                            if (newWidth) {
                                _this.el.css("width", newWidth + "px");
                            }
                        });
                        this.el.click(this.onCellClick.bind(this));
                        this.colCfg = this.col.cfg;
                        this.scope['appScope'] = this.renderer.appScope;
                        this.scope['col'] = this.col;
                        this.scope['grid'] = this.renderer.grid;
                        this.el.mousedown(this.onCellMouseDown.bind(this));
                        Object.defineProperty(this.scope, 'row', {
                            get: function () {
                                return _this.renderer.row;
                            },
                            enumerable: true,
                            configurable: true
                        });
                        Object.defineProperty(this.scope, 'item', {
                            get: function () {
                                return _this.renderer.row.item;
                            },
                            enumerable: true,
                            configurable: true
                        });
                        this.createCell();
                    };
                    DataGridRowCellComponent.prototype.format = function (value) {
                        return this.col.cfg.cellFormatter(value, this.renderer.row, this.col);
                    };
                    DataGridRowCellComponent.prototype.formatDate = function (value) {
                        return framework.syn.ng.filter('date')(value, this.colCfg.cellFormatter || "yyyy-MM-dd");
                    };
                    DataGridRowCellComponent.prototype.formatBool = function (value) {
                        return value ? "是" : "否";
                    };
                    DataGridRowCellComponent.prototype.formatNumber = function (value) {
                        if (this.colCfg.cellFormatter) {
                            return framework.syn.ng.filter('number')(value, this.colCfg.cellFormatter);
                        }
                        else {
                            return value;
                        }
                    };
                    DataGridRowCellComponent.prototype.formatCurrency = function (value) {
                        if (this.colCfg.cellFormatter) {
                            return framework.syn.ng.filter('currency')(value, this.colCfg.cellFormatter);
                        }
                        else {
                            return value;
                        }
                    };
                    DataGridRowCellComponent.prototype.onCellMouseDown = function (event) {
                        if (this.editable) {
                            if (this.isEditing) {
                                event.stopPropagation();
                            }
                        }
                    };
                    DataGridRowCellComponent.prototype.onCellClick = function () {
                        if (!this.editable)
                            return;
                        if (this.isEditing)
                            return;
                        this.onStartEdit();
                    };
                    DataGridRowCellComponent.prototype.createCell = function () {
                        var colCfg = this.col.cfg;
                        var tpl = '';
                        if (colCfg.cellTpl) {
                            tpl = "<div>" + colCfg.cellTpl + "</div>";
                        }
                        else if (colCfg.cellFormatter && angular.isFunction(colCfg.cellFormatter)) {
                            tpl = "<div>{{vm.format(vm.item." + colCfg.field + ")}}</div>";
                        }
                        else if (colCfg.field) {
                            var field = colCfg.field;
                            var value = field.indexOf('[') == 0 ? "vm.item" + colCfg.field : "vm.item." + colCfg.field;
                            if (colCfg.type == "date") {
                                tpl = "<div>{{vm.formatDate(" + value + ")}}</div>";
                            }
                            else if (colCfg.type == "number") {
                                tpl = "<div>{{vm.formatNumber(" + value + ")}}</div>";
                            }
                            else if (colCfg.type == "currency") {
                                tpl = "<div>{{vm.formatCurrency(" + value + ")}}</div>";
                            }
                            else if (colCfg.type == "bool") {
                                tpl = "<div>{{vm.formatBool(" + value + ")}}</div>";
                            }
                            else {
                                tpl = "<div>{{" + value + "}}</div>";
                            }
                        }
                        this.cellScope = this.scope.$new();
                        this.cellEl = this.compile(tpl)(this.cellScope);
                        this.cellEl.appendTo(this.el);
                    };
                    DataGridRowCellComponent.prototype.destoryCell = function () {
                        this.cellScope.$destroy();
                        this.cellEl.remove();
                        this.cellScope = null;
                        this.cellEl = null;
                    };
                    DataGridRowCellComponent.prototype.createEditor = function () {
                        var fieldType = this.colCfg.type || "string";
                        if (this.colCfg.options) {
                            this.cellEditor = new OptionEditor(this);
                        }
                        else if (fieldType === "number") {
                            this.cellEditor = new NumberEditor(this);
                        }
                        else if (fieldType === "date") {
                            this.cellEditor = new DateEditor(this);
                        }
                        else if (fieldType === "bool") {
                            this.cellEditor = new BoolEditor(this);
                        }
                        else {
                            this.cellEditor = new TextEditor(this);
                        }
                        this.cellEditor.build();
                        this.cellEditor.select();
                    };
                    DataGridRowCellComponent.prototype.destoryEditor = function () {
                        this.cellEditor.destory();
                        this.cellEditor = null;
                    };
                    DataGridRowCellComponent.prototype.onStartEdit = function () {
                        this.isEditing = true;
                        this.el.addClass("edit");
                        this.destoryCell();
                        this.createEditor();
                        this.renderer.grid.editCell = this;
                    };
                    DataGridRowCellComponent.prototype.onEndEdit = function () {
                        this.isEditing = false;
                        this.el.removeClass("edit");
                        this.destoryEditor();
                        this.createCell();
                        this.cellScope.$apply();
                    };
                    DataGridRowCellComponent.tpl = "";
                    return DataGridRowCellComponent;
                }());
                dataGrid.DataGridRowCellComponent = DataGridRowCellComponent;
                var CellEditor = (function () {
                    function CellEditor(rowCell) {
                        this.rowCell = rowCell;
                    }
                    CellEditor.prototype.build = function () {
                        this.expr = framework.syn.ng.parse("obj." + this.rowCell.colCfg.field);
                        this.scope = this.rowCell.scope.$new(true);
                        this.scope['vm'] = this;
                        this.el = this.rowCell.compile("<div class=\"sgrid-cell-editor\">" + this.tpl() + "</div>")(this.scope);
                        this.el.appendTo(this.rowCell.el);
                        this.input = $("input,select", this.el);
                        this.scope["options"] = this.rowCell.colCfg.options;
                        this.scope.$apply();
                    };
                    CellEditor.prototype.destory = function () {
                        this.scope.$destroy();
                        this.el.remove();
                    };
                    Object.defineProperty(CellEditor.prototype, "value", {
                        get: function () {
                            return this.expr({ obj: this.rowCell.renderer.row.item });
                        },
                        set: function (value) {
                            this.expr.assign({ obj: this.rowCell.renderer.row.item }, value);
                            this.rowCell.renderer.row.setChange(this.rowCell.colCfg.field);
                        },
                        enumerable: true,
                        configurable: true
                    });
                    CellEditor.prototype.select = function () {
                        this.input.focus();
                    };
                    return CellEditor;
                }());
                dataGrid.CellEditor = CellEditor;
                var TextEditor = (function (_super) {
                    __extends(TextEditor, _super);
                    function TextEditor() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    TextEditor.prototype.tpl = function () {
                        return "<input type=\"text\" ng-model=\"vm.value\"></input>";
                    };
                    return TextEditor;
                }(CellEditor));
                dataGrid.TextEditor = TextEditor;
                var NumberEditor = (function (_super) {
                    __extends(NumberEditor, _super);
                    function NumberEditor() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    NumberEditor.prototype.tpl = function () {
                        return "<input type=\"number\" ng-model=\"vm.value\"></input>";
                    };
                    return NumberEditor;
                }(CellEditor));
                dataGrid.NumberEditor = NumberEditor;
                var BoolEditor = (function (_super) {
                    __extends(BoolEditor, _super);
                    function BoolEditor() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    BoolEditor.prototype.tpl = function () {
                        return "<div class=\"ui checkbox\">\n                <input type=\"checkbox\" sm-checkbox ng-model=\"vm.value\">\n                <label></label>\n            </div>";
                    };
                    BoolEditor.prototype.build = function () {
                        _super.prototype.build.call(this);
                        this.el.addClass("checkbox");
                    };
                    return BoolEditor;
                }(CellEditor));
                dataGrid.BoolEditor = BoolEditor;
                var DateEditor = (function (_super) {
                    __extends(DateEditor, _super);
                    function DateEditor() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    DateEditor.prototype.tpl = function () {
                        return "<input type=\"text\" date-formatter syn-date-picker ng-model=\"vm.value\"></input>";
                    };
                    return DateEditor;
                }(CellEditor));
                dataGrid.DateEditor = DateEditor;
                var OptionEditor = (function (_super) {
                    __extends(OptionEditor, _super);
                    function OptionEditor() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    OptionEditor.prototype.tpl = function () {
                        var isObjValue = this.rowCell.colCfg.type === "object";
                        var options = this.rowCell.colCfg.options;
                        var hasLabel = false;
                        if (options.length > 0) {
                            var value = options[0];
                            if (angular.isObject(value)) {
                                hasLabel = value.hasOwnProperty("label");
                            }
                        }
                        var ngOptions = "item for item in options";
                        if (hasLabel) {
                            ngOptions = "item.value as item.label for item in options";
                        }
                        if (isObjValue) {
                            ngOptions += " track by item.id";
                        }
                        return "<select ng-model=\"vm.value\" ng-options=\"" + ngOptions + "\"></select>";
                    };
                    return OptionEditor;
                }(CellEditor));
                dataGrid.OptionEditor = OptionEditor;
            })(dataGrid = component.dataGrid || (component.dataGrid = {}));
        })(component = framework.component || (framework.component = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var component;
        (function (component) {
            var tree;
            (function (tree) {
                var TreeNode = (function () {
                    function TreeNode(_data, _provider, _parent, _ctrl) {
                        this._data = _data;
                        this._provider = _provider;
                        this._parent = _parent;
                        this._ctrl = _ctrl;
                        this._isOpened = false;
                        this._originChildrenVer = 0;
                        this._level = 0;
                        this._selected = false;
                        this.hidden = false;
                        this.filtered = false;
                        this.init();
                        _ctrl.onNodeCreate(this);
                    }
                    TreeNode.prototype.init = function () {
                        if (this._parent) {
                            this._level = this._parent._level + 1;
                        }
                        this._cls = "tree node level-" + this._level;
                        this._selectedCls = this._cls + " selected";
                    };
                    Object.defineProperty(TreeNode.prototype, "level", {
                        get: function () {
                            return this._level;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "opened", {
                        get: function () {
                            return this._isOpened;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "data", {
                        get: function () {
                            return this._data;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "id", {
                        get: function () {
                            return this._provider.id(this._data);
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "label", {
                        get: function () {
                            var label = this._provider.label(this._data);
                            if (this.filtered) {
                                label = "<span style=\"color:green\">" + label + "</span>";
                            }
                            return label;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "style", {
                        get: function () {
                            return this._provider.style(this._data);
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "first", {
                        get: function () {
                            return this._children.first;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "last", {
                        get: function () {
                            return this._children.last;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "parent", {
                        get: function () {
                            return this._parent;
                        },
                        set: function (parent) {
                            this._parent = parent;
                            this.vist(function (node) {
                                node.init();
                            });
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "draggable", {
                        get: function () {
                            return this._ctrl.allowDrag;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "children", {
                        get: function () {
                            var currentChildren = this._provider.children(this.data);
                            if (!this._children) {
                                this._children = new synwork.utils.ArrayList();
                            }
                            if (this._originChildren !== currentChildren) {
                                this._originChildren = currentChildren;
                                this._originChildrenVer = 0;
                                this.buildChildren();
                            }
                            else {
                                if (!currentChildren) {
                                    this._originChildren = currentChildren;
                                    this._originChildrenVer = 0;
                                    this.buildChildren();
                                    return this._children.array;
                                }
                                var ver = Number(currentChildren['ver']);
                                if (ver) {
                                    if (ver != this._originChildrenVer) {
                                        this._originChildren = currentChildren;
                                        this._originChildrenVer = ver;
                                        this.buildChildren();
                                    }
                                }
                                else {
                                }
                            }
                            return this._children.array;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    TreeNode.prototype.buildChildren = function () {
                        var _this = this;
                        if (!this._originChildren || this._originChildren.length == 0) {
                            this._children.clear();
                            return;
                        }
                        this._children.clear();
                        this._originChildren.forEach(function (it) {
                            var node = _this._ctrl.getTreeNode(it);
                            if (!node) {
                                node = new TreeNode(it, _this._provider, _this, _this._ctrl);
                            }
                            else {
                                node.parent = _this;
                            }
                            _this._children.add(node);
                        });
                    };
                    TreeNode.prototype.hasChildren = function () {
                        return this.children.length > 0;
                    };
                    Object.defineProperty(TreeNode.prototype, "rawChildren", {
                        get: function () {
                            return this._children;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "leaf", {
                        get: function () {
                            return this._provider.isLeaf(this._data);
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "showChildren", {
                        get: function () {
                            return this._isOpened && !this.leaf;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "collapseIcon", {
                        get: function () {
                            return (!this.leaf && this.children.length > 0) ?
                                (this.opened ? "caret down" : "caret right") : "";
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "selected", {
                        get: function () {
                            return this._selected;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    TreeNode.prototype.setSelected = function () {
                        this._selected = true;
                    };
                    TreeNode.prototype.unselect = function () {
                        this._selected = false;
                    };
                    TreeNode.prototype.setOpen = function () {
                        this._isOpened = true;
                    };
                    TreeNode.prototype.setClose = function () {
                        this._isOpened = false;
                    };
                    TreeNode.prototype.onCollapse = function (event) {
                        if (this.leaf) {
                            return;
                        }
                        event.stopPropagation();
                        this._isOpened = !this._isOpened;
                    };
                    TreeNode.prototype.onClick = function (event) {
                        if (event.ctrlKey) {
                            this._ctrl.onCtrlClick(this);
                        }
                        else {
                            this._ctrl.selectNode(this);
                            this._ctrl.notifySelection();
                        }
                    };
                    TreeNode.prototype.onDblClick = function () {
                        this._ctrl.onDblClick(this);
                    };
                    TreeNode.prototype.onMouseLeave = function (event) {
                    };
                    Object.defineProperty(TreeNode.prototype, "nodeCls", {
                        get: function () {
                            return (this._selected ? this._selectedCls : this._cls) + " " + this._provider.cls(this._data);
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "icon", {
                        get: function () {
                            return this._provider.icon(this.data) || "empty";
                        },
                        enumerable: true,
                        configurable: true
                    });
                    TreeNode.prototype.nextNode = function () {
                        return this.parent._children.nextItem(this);
                    };
                    TreeNode.prototype.preNode = function () {
                        return this.parent._children.preItem(this);
                    };
                    Object.defineProperty(TreeNode.prototype, "index", {
                        get: function () {
                            return this.parent._children.indexOf(this);
                        },
                        enumerable: true,
                        configurable: true
                    });
                    TreeNode.prototype.toPath = function () {
                        var paths = [];
                        paths.push(this);
                        var parent = this.parent;
                        while (parent) {
                            paths.push(parent);
                            parent = parent.parent;
                        }
                        paths.pop();
                        return paths.reverse();
                    };
                    TreeNode.prototype.vist = function (fn) {
                        if (fn === void 0) { fn = null; }
                        if (fn)
                            fn(this);
                        this.children.forEach(function (it) {
                            it.vist(fn);
                        });
                    };
                    Object.defineProperty(TreeNode.prototype, "el", {
                        get: function () {
                            return this._el;
                        },
                        set: function (el) {
                            this._el = el;
                            this._nodeEl = null;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "nodeEl", {
                        get: function () {
                            if (!this._nodeEl) {
                                this._nodeEl = $($("div.tree.node", this.el)[0]);
                            }
                            return this._nodeEl;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeNode.prototype, "nodeContentEl", {
                        get: function () {
                            return $(".node.content", this.nodeEl);
                        },
                        enumerable: true,
                        configurable: true
                    });
                    TreeNode.prototype.removeNode = function (node) {
                        if (this._provider.onRemoveNode(this, node))
                            this._children.remove(node);
                        if (this._children.size == 0) {
                            this.setClose();
                        }
                    };
                    TreeNode.prototype.removeNodeData = function (data) {
                        this.removeNode(this._ctrl.getTreeNode(data));
                    };
                    TreeNode.prototype.isAncestor = function (node) {
                        var parent = node.parent;
                        while (parent !== null) {
                            if (parent.id == this.id) {
                                return true;
                            }
                            parent = parent.parent;
                        }
                        return false;
                    };
                    TreeNode.prototype.addChild = function (index, data) {
                        if (this._provider.onAddChild(index, data, this)) {
                            var node = new TreeNode(data, this._provider, this, this._ctrl);
                            this._children.addAt(index, node);
                        }
                    };
                    TreeNode.prototype.addLastChild = function (data) {
                        this.addChild(this.children.length, data);
                    };
                    TreeNode.prototype.refreshChildren = function () {
                        var _this = this;
                        if (!this._children)
                            return;
                        var oldChildren = this._children.toArray();
                        this._children.clear();
                        var newChildren = this._provider.children(this._data);
                        newChildren.forEach(function (data) {
                            var id = _this._provider.id(data);
                            var node = _this._ctrl.getTreeNode(data);
                            if (node) {
                                if (node.data !== data) {
                                    node._data = data;
                                }
                                node.parent = _this;
                                _this._children.add(node);
                            }
                            else {
                                node = new TreeNode(data, _this._provider, _this, _this._ctrl);
                                _this._children.add(node);
                            }
                        });
                        oldChildren.forEach(function (node) {
                            if (!_this._children.findById(node.id)) {
                                delete _this._ctrl.nodeMap[node.id];
                            }
                        });
                    };
                    return TreeNode;
                }());
                tree.TreeNode = TreeNode;
                var TreeDataProvider = (function () {
                    function TreeDataProvider() {
                    }
                    TreeDataProvider.prototype.label = function (data) {
                        return "";
                    };
                    TreeDataProvider.prototype.children = function (data) {
                        return [];
                    };
                    TreeDataProvider.prototype.style = function (data) {
                        return null;
                    };
                    TreeDataProvider.prototype.cls = function (data) {
                        return "";
                    };
                    TreeDataProvider.prototype.id = function (data) {
                        return "";
                    };
                    TreeDataProvider.prototype.icon = function (data) {
                        return "";
                    };
                    TreeDataProvider.prototype.allowAddChild = function (parentNode, childNode) {
                        return true;
                    };
                    TreeDataProvider.prototype.isLeaf = function (data) {
                        return this.children(data).length == 0;
                    };
                    TreeDataProvider.prototype.onRemoveNode = function (parentNode, node) {
                        var children = this.children(parentNode.data);
                        new synwork.utils.ArrayList(children).remove(node.data);
                        return true;
                    };
                    TreeDataProvider.prototype.newChildren = function (data) {
                        return [];
                    };
                    TreeDataProvider.prototype.onAddChild = function (index, data, parent) {
                        var children = new synwork.utils.ArrayList(this.children(parent.data)
                            || this.newChildren(parent.data));
                        children.addAt(index, data);
                        return true;
                    };
                    TreeDataProvider.prototype.onMoveNode = function (node, index, fromParent, toParent) {
                        var fromChildren = new synwork.utils.ArrayList(this.children(fromParent.data)
                            || this.newChildren(fromParent.data));
                        var toChildren = new synwork.utils.ArrayList(this.children(toParent.data)
                            || this.newChildren(toParent.data));
                        if (toParent.id == fromParent.id) {
                            var fromIndex = node.index;
                            if (fromIndex < index) {
                                index--;
                            }
                        }
                        fromChildren.remove(node.data);
                        toChildren.addAt(index, node.data);
                        return true;
                    };
                    return TreeDataProvider;
                }());
                tree.TreeDataProvider = TreeDataProvider;
                function init(module) {
                    module.component("sTree", {
                        controller: TreeController,
                        controllerAs: 'vm',
                        template: "\n        <div style=\"flex:1;overflow-x:hidden;overflow-y:auto\">\n            <s-tree-item ng-if=\"vm.rootNode\" ng-repeat=\"node in vm.rootNode.children track by node.id\"\n                node=\"node\" ng-show=\"!node.hidden\" ctrl=\"vm\">\n            </s-tree-item>\n        </div>\n        <div class='popup' ng-transclude=\"spopup\"></div>",
                        bindings: {
                            provider: "<",
                            data: "<",
                            onSelect: "&",
                            onOver: "&",
                            onDblclick: "&",
                            onCtrlclick: "&",
                            selected: "<",
                            allowDrag: "<",
                            tree: "="
                        }, transclude: {
                            'spopup': '?spopup'
                        }
                    });
                }
                tree.init = init;
                var DragInfo = (function () {
                    function DragInfo(dragEl, dragNode, ctrl) {
                        this.dragEl = dragEl;
                        this.dragNode = dragNode;
                        this.ctrl = ctrl;
                        this.dropPosition = "none";
                    }
                    DragInfo.prototype.showIndicate = function (event, dropNode) {
                        this.dropTarget = dropNode;
                        var dropRect = dropNode.nodeContentEl[0].getBoundingClientRect();
                        this.dropPosition = event.pageY < dropRect.top + dropRect.height / 2 ? "top" : "bottom";
                        if (!dropNode.leaf) {
                            if (dropNode.opened && dropNode.hasChildren()) {
                                if (this.dropPosition == "bottom") {
                                    this.dropPosition = "firstChild";
                                }
                            }
                            else {
                                if (this.dropPosition == "bottom") {
                                    if (event.pageX > dropRect.left + dropRect.width / 2) {
                                        this.dropPosition = "lastChild";
                                    }
                                }
                            }
                        }
                        if (this.dropPosition == "bottom") {
                            var nextNode = dropNode.nextNode();
                            if (nextNode && nextNode.id == this.dragNode.id) {
                                this.dropPosition = "none";
                            }
                        }
                        if (this.dropPosition == "top") {
                            var preNode = dropNode.preNode();
                            if (preNode && preNode.id == this.dragNode.id) {
                                this.dropPosition = "none";
                            }
                        }
                        if (this.dropPosition == "firstChild") {
                            var child = dropNode.first;
                            if (child && child.id == this.dragNode.id) {
                                this.dropPosition = "none";
                            }
                        }
                        if (this.dragNode.isAncestor(dropNode)) {
                            this.dropPosition = "none";
                        }
                        if (this.dropPosition == "top" || this.dropPosition == "bottom") {
                            if (!this.ctrl.allowAddChild(dropNode.parent, this.dragNode)) {
                                this.dropPosition = "none";
                            }
                        }
                        if (this.dropPosition == "firstChild" || this.dropPosition == "lastChild") {
                            if (!this.ctrl.allowAddChild(dropNode, this.dragNode)) {
                                this.dropPosition = "none";
                            }
                        }
                        var dropKey = dropNode.id + this.dropPosition;
                        if (dropKey == this.dropKey) {
                            return;
                        }
                        this.dropKey = dropKey;
                        if (this.indicate) {
                            this.indicate.remove();
                        }
                        if (this.dropPosition == "none") {
                            return;
                        }
                        var insert = this.dropPosition == "top" ? "insertBefore" : "insertAfter";
                        var level = this.dropPosition == "firstChild" || this.dropPosition == "lastChild" ?
                            dropNode.level + 1 : dropNode.level;
                        this.indicate = this.dragEl.clone()[insert](dropNode.nodeEl).addClass("drop-indicate")
                            .removeClass("drag-source").removeClass("level-" + this.dragNode.level)
                            .addClass("level-" + level);
                    };
                    DragInfo.prototype.destoryIndicate = function () {
                        this.dropKey = "none";
                        if (this.indicate) {
                            this.indicate.remove();
                        }
                    };
                    Object.defineProperty(DragInfo.prototype, "isDestory", {
                        get: function () {
                            return this.indicate == null;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    return DragInfo;
                }());
                tree.DragInfo = DragInfo;
                var TreeController = (function () {
                    function TreeController($scope, $element) {
                        this.$scope = $scope;
                        this.$element = $element;
                        this.isDraging = false;
                        this.isLeftPopup = false;
                    }
                    TreeController.prototype.onNodeCreate = function (node) {
                        this.nodeMap[node.id] = node;
                        if (this._currentData) {
                            var id = this.provider.id(this._currentData);
                            if (node.id == id) {
                                this.selectNode(node);
                            }
                        }
                    };
                    TreeController.prototype.openAll = function () {
                        this.rootNode.vist(function (node) {
                            node.setOpen();
                        });
                    };
                    TreeController.prototype.openToLevel = function (level) {
                        this.rootNode.vist(function (node) {
                            if (node.level < level) {
                                node.setOpen();
                            }
                        });
                    };
                    TreeController.prototype.closeAll = function () {
                        this.rootNode.vist(function (node) {
                            node.setClose();
                        });
                    };
                    Object.defineProperty(TreeController.prototype, "data", {
                        set: function (_data) {
                            this._data = _data;
                            if (_data) {
                                this.nodeMap = {};
                                this.rootNode = new TreeNode(this._data, this.provider, null, this);
                                this.rootNode.vist();
                            }
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeController.prototype, "selected", {
                        set: function (nodeData) {
                            if (!nodeData) {
                                this.unSelect();
                                return;
                            }
                            if (nodeData && this.provider) {
                                var id = this.provider.id(nodeData);
                                var node = this.nodeMap[id];
                                if (node) {
                                    this.selectNode(node);
                                }
                                else {
                                    this.unSelect();
                                    this._currentData = nodeData;
                                }
                            }
                        },
                        enumerable: true,
                        configurable: true
                    });
                    TreeController.prototype.refreshNodeChildren = function (node) {
                        var treeNode = this.nodeMap[this.provider.id(node)];
                        if (treeNode) {
                            treeNode.refreshChildren();
                        }
                    };
                    TreeController.prototype.scrollIntoView = function (node) {
                        $("div.tree.node[name='tree-node-" + node.id + "']", this.$element)[0].scrollIntoView();
                    };
                    Object.defineProperty(TreeController.prototype, "selectedNode", {
                        get: function () {
                            return this._current;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(TreeController.prototype, "overNode", {
                        get: function () {
                            return this._overNode;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    TreeController.prototype.unSelect = function () {
                        if (this._current) {
                            this._current.unselect();
                        }
                        this._current = null;
                        this._currentData = null;
                    };
                    TreeController.prototype.onCtrlClick = function (node) {
                        if (this['onCtrlclick']) {
                            this['onCtrlclick']({ node: node });
                        }
                    };
                    TreeController.prototype.selectNode = function (node) {
                        if (this._current) {
                            if (this._current.id == node.id) {
                                return;
                            }
                            this._current.unselect();
                            this._current = node;
                            this._currentData = node.data;
                        }
                        else {
                            this._current = node;
                            this._currentData = node.data;
                        }
                        this._current.setSelected();
                    };
                    TreeController.prototype.onDblClick = function (treeNode) {
                        if (this['onDblclick']) {
                            this['onDblclick']({ node: treeNode });
                        }
                    };
                    TreeController.prototype.onNodeMouseEnter = function (event) {
                        if (this.isDraging)
                            return;
                        var target = $(event.currentTarget);
                        var top = this.$element.offset().top;
                        var node = target.parent().data()._node;
                        this._overNode = node;
                        if (this["onOver"]) {
                            this['onOver']({ node: node });
                        }
                        var pt = target.offset();
                        this.$scope.$digest();
                        if (this.isLeftPopup) {
                            this.popUp.css("left", -this.popUp.width()).css("top", pt.top - top).show();
                        }
                        else {
                            this.popUp.css("left", this.$element.width() - 8).css("top", pt.top - top).show();
                        }
                        var bodyHeight = $(document.body).height();
                        if (this.popUp.outerHeight() + this.popUp.offset().top > bodyHeight) {
                            this.popUp.css("top", pt.top + target.outerHeight() - this.popUp.outerHeight() - top);
                        }
                    };
                    TreeController.prototype.notifySelection = function () {
                        this['onSelect']({ node: this._current });
                    };
                    TreeController.prototype.$onInit = function () {
                    };
                    TreeController.prototype.$postLink = function () {
                        var _this = this;
                        this.tree = this;
                        this.popUp = $("div.popup", this.$element);
                        this.isLeftPopup = $("popup", this.popUp).attr("left") == "true";
                        if (this.popUp.children().length > 0) {
                            this.$element.mouseleave(function () {
                                _this.popUp.hide();
                            });
                            this.popUp.click(function () {
                                _this.popUp.hide();
                            });
                        }
                        if (this.allowDrag) {
                            this.$element[0].ondragover = (function (event) {
                                event.preventDefault();
                            });
                        }
                    };
                    TreeController.prototype.onDragStart = function (event) {
                        var _this = this;
                        var el = this.treeNodeEl(event);
                        this.dragInfo = new DragInfo(el, el.parent().data()._node, this);
                        el.addClass("drag-source");
                        this.popUp.hide();
                        this.isDraging = true;
                        setTimeout(function () {
                            _this.$element.addClass("drag");
                        }, 0);
                    };
                    TreeController.prototype.onDragEnd = function (event) {
                        if (!this.dragInfo)
                            return;
                        var node = this.dragInfo.dragNode;
                        var dropNode = this.dragInfo.dropTarget;
                        if (this.dragInfo.dropPosition == "top") {
                            this.moveNode(node, dropNode.index, node.parent, dropNode.parent);
                        }
                        else if (this.dragInfo.dropPosition == "bottom") {
                            this.moveNode(node, dropNode.index + 1, node.parent, dropNode.parent);
                        }
                        else if (this.dragInfo.dropPosition == "firstChild") {
                            this.moveNode(node, 0, node.parent, dropNode);
                        }
                        else if (this.dragInfo.dropPosition == "lastChild") {
                            this.moveNode(node, dropNode.children.length, node.parent, dropNode);
                        }
                        this.dragInfo.destoryIndicate();
                        this.$element.removeClass("drag");
                        this.dragInfo.dragEl.removeClass("drag-source");
                        this.isDraging = false;
                        this.dragInfo = null;
                    };
                    TreeController.prototype.allowAddChild = function (parentNode, childNode) {
                        return this.provider.allowAddChild(parentNode, childNode);
                    };
                    TreeController.prototype.onDragEnter = function (event) {
                    };
                    TreeController.prototype.onDragLeave = function (event) {
                        this.dragInfo.destoryIndicate();
                    };
                    TreeController.prototype.onDrop = function (event) {
                    };
                    TreeController.prototype.onDragOver = function (event) {
                        var dropEl = this.treeNodeEl(event);
                        if (dropEl.hasClass("drop-indicate")) {
                            return;
                        }
                        var dropNode = dropEl.parent().data()._node;
                        if (dropNode.id != this.dragInfo.dragNode.id) {
                            this.dragInfo.showIndicate(event, dropNode);
                        }
                        if (this.dragInfo.dropPosition != "none") {
                            event.preventDefault();
                        }
                    };
                    TreeController.prototype.treeNodeEl = function (event) {
                        var el = $(event.target);
                        if (el.hasClass("tree node"))
                            return el;
                        var parents = $(event.target).parents("div.tree.node");
                        if (parents.length > 0)
                            return $(parents[0]);
                        return null;
                    };
                    TreeController.prototype.getTreeNode = function (data) {
                        return this.nodeMap[this.provider.id(data)];
                    };
                    TreeController.prototype.getTreeNodeById = function (id) {
                        return this.nodeMap[id];
                    };
                    TreeController.prototype.openNodeById = function (id) {
                        var node = this.getTreeNodeById(id);
                        if (node) {
                            var parent_1 = node.parent;
                            while (parent_1) {
                                parent_1.setOpen();
                                parent_1 = parent_1.parent;
                            }
                        }
                        return node;
                    };
                    TreeController.prototype.filter = function (fn) {
                        this.rootNode.children.forEach(function (treeNode) {
                            treeNode.vist(function (node) {
                                node.hidden = true;
                                node.filtered = false;
                                node.setOpen();
                                if (fn(node)) {
                                    var path = node.toPath();
                                    node.filtered = true;
                                    path.forEach(function (n) {
                                        n.hidden = false;
                                    });
                                }
                            });
                        });
                    };
                    TreeController.prototype.clearFilter = function () {
                        this.rootNode.vist(function (node) {
                            node.hidden = false;
                            node.filter = false;
                            node.setClose();
                        });
                    };
                    TreeController.prototype.moveNode = function (node, index, fromParent, toParent) {
                        var _this = this;
                        framework.syn.ng.timeout(function () {
                            if (!_this.provider.onMoveNode(node, index, fromParent, toParent))
                                return;
                            if (toParent.id == fromParent.id) {
                                var fromIndex = node.index;
                                if (fromIndex < index) {
                                    index--;
                                }
                            }
                            fromParent.rawChildren.remove(node);
                            if (fromParent.rawChildren.size == 0) {
                                fromParent.setClose();
                            }
                            toParent.rawChildren.addAt(index, node);
                            if (toParent.rawChildren.size == 1) {
                                toParent.setOpen();
                            }
                            node.parent = toParent;
                        });
                    };
                    return TreeController;
                }());
                tree.TreeController = TreeController;
            })(tree = component.tree || (component.tree = {}));
        })(component = framework.component || (framework.component = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var component;
        (function (component) {
            var treeItem;
            (function (treeItem) {
                function init(module) {
                    module.component("sTreeItem", {
                        controller: Controller,
                        controllerAs: 'vm',
                        template: "\n<div class=\"{{vm.node.nodeCls}}\" ng-click=\"vm.node.onClick($event)\" name=\"tree-node-{{vm.node.id}}\"\n    draggable=\"{{::vm.node.draggable}}\" ng-dblclick=\"vm.node.onDblClick($event)\">\n    <div class=\"node content\">\n        <i class=\"{{vm.node.collapseIcon}} collapse icon\" ng-click=\"vm.node.onCollapse($event)\"></i>\n        <i class=\"{{vm.node.icon}} icon\"></i>\n        <span class=\"label\" ng-style=\"vm.node.style\" ng-bind-html=\"vm.node.label\"></span>\n    </div>\n</div>\n\n<div class=\"tree children\" ng-if=\"vm.node.showChildren\">\n    <s-tree-item ng-repeat=\"node in vm.node.children track by node.id\" node=\"node\"\n        ctrl=\"vm.ctrl\" ng-show=\"!node.hidden\">\n    </s-tree-item>\n</div>",
                        bindings: {
                            node: "<",
                            ctrl: "<"
                        }
                    });
                }
                treeItem.init = init;
                var Controller = (function () {
                    function Controller($element) {
                        this.$element = $element;
                    }
                    Object.defineProperty(Controller.prototype, "node", {
                        get: function () {
                            return this._node;
                        },
                        set: function (node) {
                            this._node = node;
                            this.initNode();
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Controller.prototype.initNode = function () {
                        if (this._node && this.$element) {
                            this.$element.data()._node = this._node;
                            this._node.el = this.$element;
                        }
                    };
                    Controller.prototype.$onInit = function () {
                        var _this = this;
                        if (this.ctrl.allowDrag) {
                            var nodeEl = this.$element.children()[0];
                            nodeEl.ondragstart = function (event) {
                                _this.ctrl.onDragStart(event);
                            };
                            nodeEl.ondragend = function (event) {
                                _this.ctrl.onDragEnd(event);
                            };
                            nodeEl.ondragover = function (event) {
                                _this.ctrl.onDragOver(event);
                            };
                            nodeEl.onmouseenter = function (event) {
                                _this.ctrl.onNodeMouseEnter(event);
                            };
                        }
                        this.initNode();
                    };
                    return Controller;
                }());
                treeItem.Controller = Controller;
            })(treeItem = component.treeItem || (component.treeItem = {}));
        })(component = framework.component || (framework.component = {}));
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var utils;
    (function (utils) {
        var ArrayList = (function () {
            function ArrayList(_array) {
                if (_array === void 0) { _array = []; }
                this._array = _array;
                this.init();
            }
            ArrayList.prototype.init = function () {
                this._array['ver'] = 0;
            };
            ArrayList.prototype.updateVer = function () {
                var ver = Number(this._array['ver']);
                this._array['ver'] = ver + 1;
            };
            Object.defineProperty(ArrayList.prototype, "array", {
                get: function () {
                    return this._array;
                },
                set: function (array) {
                    this._array = array;
                    this.init();
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(ArrayList.prototype, "size", {
                get: function () {
                    return this._array.length;
                },
                enumerable: true,
                configurable: true
            });
            ArrayList.prototype.add = function (item) {
                this._array.push(item);
                this.updateVer();
                return this;
            };
            ArrayList.prototype.addAt = function (index, item) {
                this._array.splice(index, 0, item);
                this.updateVer();
                return this;
            };
            ArrayList.prototype.addAll = function (array) {
                var _this = this;
                this.clear();
                array.forEach(function (it) {
                    _this._array.push(it);
                });
                this.updateVer();
                return this;
            };
            ArrayList.prototype.clear = function () {
                if (this._array.length > 0) {
                    this._array.splice(0, this._array.length);
                }
                this.updateVer();
                return this;
            };
            ArrayList.prototype.contains = function (item) {
                var index = this._array.indexOf(item);
                return (index >= 0);
            };
            ArrayList.prototype.findById = function (id) {
                return this._array['find'](function (it) {
                    return it.id == id;
                });
            };
            ArrayList.prototype.containsById = function (id) {
                return this.findById(id) != null;
            };
            Object.defineProperty(ArrayList.prototype, "isEmpty", {
                get: function () {
                    return this._array.length == 0;
                },
                enumerable: true,
                configurable: true
            });
            ArrayList.prototype.getAt = function (index) {
                return this._array[index];
            };
            ArrayList.prototype.indexOf = function (item) {
                return this._array.indexOf(item);
            };
            ArrayList.prototype.lastIndexOf = function (item) {
                return this._array.lastIndexOf(item);
            };
            ArrayList.prototype.setAt = function (index, item) {
                this._array[index] = item;
                return this;
            };
            ArrayList.prototype.remove = function (item) {
                var index = this.indexOf(item);
                if (index >= 0) {
                    this._array.splice(index, 1);
                    this.updateVer();
                }
                return this;
            };
            ArrayList.prototype.removeAt = function (index) {
                this._array.splice(index, 1);
                this.updateVer();
                return this;
            };
            ArrayList.prototype.removeAll = function (items) {
                var _this = this;
                items.forEach(function (it) {
                    _this.remove(it);
                });
                this.updateVer();
                return this;
            };
            Object.defineProperty(ArrayList.prototype, "first", {
                get: function () {
                    return this.size == 0 ? null : this._array[0];
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(ArrayList.prototype, "last", {
                get: function () {
                    return this.size == 0 ? null : this._array[this._array.length - 1];
                },
                enumerable: true,
                configurable: true
            });
            ArrayList.prototype.preItem = function (item) {
                var index = this.indexOf(item);
                return this._array[index - 1];
            };
            ArrayList.prototype.nextItem = function (item) {
                var index = this.indexOf(item);
                return this._array[index + 1];
            };
            ArrayList.prototype.toArray = function () {
                return [].concat(this._array);
            };
            ArrayList.prototype.pop = function () {
                this.updateVer();
                return this._array.pop();
            };
            ArrayList.prototype.sortBy = function (prop) {
                var sorted = _.sortBy(this._array, [prop]);
                this.addAll(sorted);
            };
            ArrayList.prototype.moveUp = function (item) {
                if (this.first === item)
                    return;
                this.updateVer();
                var pre = this.preItem(item);
                this.remove(item);
                this.insertBefore(pre, item);
            };
            ArrayList.prototype.moveDown = function (item) {
                if (this.last === item)
                    return;
                this.updateVer();
                var next = this.nextItem(item);
                this.remove(item);
                this.insertAfter(next, item);
            };
            ArrayList.prototype.insertBefore = function (toItem, item) {
                this.addAt(this.indexOf(toItem), item);
            };
            ArrayList.prototype.insertAfter = function (toItem, item) {
                this.addAt(this.indexOf(toItem) + 1, item);
            };
            Object.defineProperty(ArrayList.prototype, "selected", {
                get: function () {
                    return this._selected;
                },
                set: function (item) {
                    this._selected = item;
                    this._array.forEach(function (it) {
                        it['$isSelected'] = false;
                    });
                    if (this._selected) {
                        this._selected['$isSelected'] = true;
                    }
                    if (this.onSelect) {
                        this.onSelect(this._selected);
                    }
                },
                enumerable: true,
                configurable: true
            });
            ArrayList.prototype.selectFirst = function () {
                this.selected = this.first;
            };
            ArrayList.prototype.removeAndSelectLast = function (item) {
                if (this.selected === item) {
                    this.selected = this.preItem(item) || this.nextItem(item);
                }
                this.remove(item);
                return this;
            };
            return ArrayList;
        }());
        utils.ArrayList = ArrayList;
    })(utils = synwork.utils || (synwork.utils = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var utils;
    (function (utils) {
        var Job = (function () {
            function Job() {
                this.msg = "";
                this.name = "";
            }
            return Job;
        }());
        utils.Job = Job;
        var JobGroup = (function (_super) {
            __extends(JobGroup, _super);
            function JobGroup() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.jobs = [];
                _this.percent = "";
                _this.isRun = false;
                _this.isFinish = false;
                _this.executed = false;
                return _this;
            }
            Object.defineProperty(JobGroup.prototype, "currentMessage", {
                get: function () {
                    if (this.job) {
                        if (this.job instanceof JobGroup) {
                            return this.job.currentMessage;
                        }
                        return this.job.msg;
                    }
                    return "";
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(JobGroup.prototype, "currentJob", {
                get: function () {
                    return this.job;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(JobGroup.prototype, "currentPercent", {
                get: function () {
                    if (this.job && this.job instanceof JobGroup) {
                        return this.job.percent;
                    }
                    return "";
                },
                enumerable: true,
                configurable: true
            });
            JobGroup.prototype.addJob = function (job) {
                this.jobs.push(job);
            };
            JobGroup.prototype.run = function () {
                this._jobs = [].concat(this.jobs);
                this.executed = true;
                this.isRun = true;
                this.isFinish = false;
                this.defer = syn.ng.q.defer();
                this.runJob();
                return this.defer.promise;
            };
            JobGroup.prototype.runJob = function () {
                var _this = this;
                if (this._jobs.length == 0) {
                    this.isRun = false;
                    this.msg = "";
                    this.isFinish = true;
                    this.job = null;
                    this.defer.resolve();
                    return;
                }
                var total = this.jobs.length;
                this.job = this._jobs.shift();
                var index = this.jobs.length - this._jobs.length;
                this.percent = index + "/" + total;
                var promise = this.job.run();
                this.msg = this.job.msg;
                if (promise)
                    promise.then(function () {
                        _this.runJob();
                    }).catch(function (error) {
                        error.resolve();
                        syn.dlg.openError("\u6267\u884C\uFF1A" + _this.job.msg + "\u65F6\u51FA\u9519\uFF1A" + (error.code || error.message) + "!");
                    });
                else {
                    this.runJob();
                }
            };
            return JobGroup;
        }(Job));
        utils.JobGroup = JobGroup;
    })(utils = synwork.utils || (synwork.utils = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var ctrl;
    (function (ctrl) {
        var DialogController = (function () {
            function DialogController($scope, $element) {
                var _this = this;
                this.$scope = $scope;
                this.$element = $element;
                this.isEntityMode = false;
                this.scope = $scope;
                this.params = $scope.$parent['params'];
                this.dlg = $scope.$parent['dialog'];
                if (this.dlg) {
                    this.dlg.okAction(function () {
                        return _this.onOkAction();
                    });
                    this.dlg.cancelAction(function () {
                        return _this.onCancelAction();
                    });
                    this.dlg.isOkButtonEnable = function () {
                        return _this.isOkEnable();
                    };
                    this.dlg.dialogScope.okLabel = function () {
                        return _this.okLabel();
                    };
                    this.dlg.dialogScope.cancelLabel = function () {
                        return _this.cancelLabel();
                    };
                }
                var formEl = $('form', this.$element);
                if (formEl.length > 0) {
                    var formName = formEl.attr('name');
                    this.formModelName = formEl.attr('model');
                    if (formName) {
                        $scope.$watch(formName, function (value, old) {
                            _this.form = value;
                        });
                    }
                }
            }
            DialogController.prototype.okLabel = function () {
                if (this.form) {
                    if (this.isEntityMode) {
                        var model = this.scope.$eval(this.formModelName);
                        if (model && !model.id) {
                            this.dlg.dialogScope.title = "创建" + this.entityName;
                            return "创建";
                        }
                        this.dlg.dialogScope.title = "编辑" + this.entityName;
                    }
                    return "保存";
                }
                return "确定";
            };
            DialogController.prototype.cancelLabel = function () {
                return "取消";
            };
            DialogController.prototype.isOkEnable = function () {
                if (this.dlg.isBusy)
                    return false;
                if (this.form) {
                    return this.form.$valid;
                }
                return true;
            };
            DialogController.prototype.setEntityMode = function (name) {
                this.entityName = name;
                this.isEntityMode = true;
            };
            DialogController.prototype.onOkAction = function () {
                return true;
            };
            DialogController.prototype.onCancelAction = function () {
                return true;
            };
            return DialogController;
        }());
        ctrl.DialogController = DialogController;
    })(ctrl = synwork.ctrl || (synwork.ctrl = {}));
})(synwork || (synwork = {}));
var synwork;
(function (synwork) {
    var nav = synwork.framework.service.nav;
    var ValueChangeListener = (function () {
        function ValueChangeListener(scope, items) {
            var _this = this;
            this.scope = scope;
            this.items = items;
            if (items.length == 0) {
                return;
            }
            if (items.length == 1) {
                this.destoryFn = this.scope.$watch(items[0], (function (value) {
                    if (_.isNil(value))
                        return;
                    if (_this.callback) {
                        _this.callback();
                    }
                }));
            }
            else {
                this.scope.$watchGroup(items, function (values) {
                    if (values.some(_.isNil)) {
                        return;
                    }
                    if (_this.callback) {
                        _this.callback();
                    }
                });
            }
        }
        ValueChangeListener.prototype.then = function (fn) {
            this.callback = fn;
            return this;
        };
        ValueChangeListener.prototype.destory = function () {
            this.destoryFn();
            return this;
        };
        return ValueChangeListener;
    }());
    synwork.ValueChangeListener = ValueChangeListener;
    var Controller = (function () {
        function Controller(scope, el) {
            var _this = this;
            this.scope = scope;
            this.el = el;
            this._type = 'page';
            if (!scope.hasOwnProperty('vm')) {
                scope['vm'] = this;
            }
            this.nav = el.inheritedData(nav.PageNavigator.key);
            this._pageId = el.attr("page-id");
            if (el.hasClass('ui-item component')) {
                this._type = 'component';
            }
            this.scope['cls'] = this.cls.bind(this);
            this.scope.$on(nav.PAGE_EVENT_SHOW, function (event, pageId) {
                if (event.defaultPrevented) {
                    return;
                }
                if (pageId.toString() == _this._pageId) {
                    event.preventDefault();
                    _this.$onShow();
                }
            });
            this.scope.$on(nav.PAGE_EVENT_HIDE, function (event, pageId) {
                if (event.defaultPrevented) {
                    return;
                }
                if (pageId.toString() == _this._pageId) {
                    event.preventDefault();
                    _this.$onHide();
                }
            });
        }
        Controller.prototype.cls = function () {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (args.length > 1) {
                return args.map(function (it) { return "ui-page-" + _this._pageId + "-" + it.trim(); }).join(" ");
            }
            var obj = args[0];
            if (angular.isString(obj)) {
                return obj.toString().trim().split(" ").map(function (it) { return "ui-page-" + _this._pageId + "-" + it.trim(); }).join(" ");
            }
            if (angular.isObject(obj)) {
                var keys = Object.keys(obj);
                for (var _a = 0, keys_4 = keys; _a < keys_4.length; _a++) {
                    var key = keys_4[_a];
                    obj["ui-page-" + this._pageId + "-" + key] = obj[key];
                    delete obj[key];
                }
                return obj;
            }
            return "";
        };
        Object.defineProperty(Controller.prototype, "pageId", {
            get: function () {
                return this._pageId;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "type", {
            get: function () {
                return this._type;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "rootScope", {
            get: function () {
                return this.scope.$root;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Controller.prototype, "log", {
            get: function () {
                if (!this._log) {
                    this._log = synwork.log.LogFactory.get(this._type + "-" + this._pageId);
                }
                return this._log;
            },
            enumerable: true,
            configurable: true
        });
        Controller.prototype.$onInit = function () {
        };
        Controller.prototype.$doCheck = function () {
        };
        Controller.prototype.$onChanges = function (onChangesObj) {
        };
        Controller.prototype.$onDestroy = function () {
        };
        Controller.prototype.$postLink = function () {
        };
        Controller.prototype.$onShow = function () {
        };
        Controller.prototype.$onHide = function () {
        };
        Controller.prototype.watchChange = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ValueChangeListener(this.scope, args);
        };
        return Controller;
    }());
    synwork.Controller = Controller;
    Controller.$inject = ["$scope", "$element"];
    var DialogController = (function (_super) {
        __extends(DialogController, _super);
        function DialogController(scope, el) {
            var _this = _super.call(this, scope, el) || this;
            _this.modelName = "";
            _this.dlg = el.inheritedData("dlg.instance");
            _this.modalPage = el.inheritedData("modalPage.instance");
            _this.params = el.inheritedData("dlg.params") || el.inheritedData("modalPage.params");
            _this.scope['params'] = _this.params;
            if (!_this.dlg)
                return _this;
            _this.dlg.okAction(function () {
                return _this.onOkAction();
            });
            return _this;
        }
        DialogController.prototype.setModel = function (model) {
            var _this = this;
            this.model = model;
            this.initTitle();
            this.initButtonLabel();
            this.dlg.isOkButtonEnable = function () {
                return _this.model && _this.modelForm && _this.modelForm.$dirty && _this.modelForm.$valid;
            };
        };
        DialogController.prototype.onOkAction = function () {
        };
        Object.defineProperty(DialogController.prototype, "actionName", {
            get: function () {
                if (!this.model) {
                    return "";
                }
                return this.model['id'] > 0 ? '保存' : '新建';
            },
            enumerable: true,
            configurable: true
        });
        DialogController.prototype.initTitle = function () {
            if (this.model['id'] > 0) {
                this.dlg.title('编辑' + this.modelName);
            }
            else {
                this.dlg.title('新建' + this.modelName);
            }
        };
        DialogController.prototype.initButtonLabel = function () {
            this.dlg.okLabel(this.actionName);
        };
        DialogController.prototype.close = function (args) {
            if (this.dlg) {
                this.dlg.close(args);
                return;
            }
            if (this.modalPage) {
                this.modalPage.close(args);
            }
        };
        return DialogController;
    }(Controller));
    synwork.DialogController = DialogController;
})(synwork || (synwork = {}));
this.globalThis || (this.globalThis = this);
var synwork;
(function (synwork) {
    var framework;
    (function (framework) {
        var Global = (function () {
            function Global() {
                this.data = {};
            }
            Global.prototype.set = function (key, value) {
                this.data[key] = value;
            };
            Global.prototype.get = function (key) {
                return this.data[key];
            };
            Global.prototype.newObject = function () {
                return {};
            };
            Global.prototype.delete = function (key) {
                delete this.data[key];
            };
            return Global;
        }());
        framework.Global = Global;
        var Synwork = (function () {
            function Synwork() {
                this.component = framework.service.component2.getManager();
                this.mouse = {
                    clientX: 0,
                    clientY: 0,
                    pageX: 0,
                    pageY: 0
                };
                window['Promise'].prototype.apply = function () {
                    this.finally(function () {
                        framework.syn.ng.rootScope.$evalAsync();
                    });
                };
                synwork.log.LogFactory.setLevel('warn');
                this.log = synwork.log.LogFactory.get("syn");
                window['syn'] = this;
                if (window.top === window.self) {
                    this.top = this;
                    this.global = new Global();
                }
                else {
                    try {
                        this.top = window.top['syn'];
                        this.global = this.top.global;
                    }
                    catch (_a) {
                        this.top = this;
                        this.global = new Global();
                    }
                }
                this.core = new framework.SynworkCore(this);
                this.cache = new framework.service.cache.CacheManager();
                this.ng = new AngularHelper(this.core);
                this.app = new framework.service.App(this);
                this.rpc = new framework.service.Rpc();
                this.rest = new framework.service.Rest(this);
                this.message = new framework.service.MessageService(this);
                this.htmlExporter = new framework.service.HtmlExporter();
                this.dataAggregate = new framework.service.DataAggregateService();
                this.busy = framework.service.BusyConfig;
                this.dlg = new framework.service.DialogService(this);
                this.im = framework.service.im2.factory;
                this.converter = new framework.service.converter.HtmlConveter();
                this.toast = new framework.service.toast.ToastService();
                this.msgbox = new framework.service.msgbox.MsgBoxService();
                this.actionsheet = new framework.service.actionsheet.ActionSheetService();
            }
            Object.defineProperty(Synwork.prototype, "isAngular1_5", {
                get: function () {
                    return angular.version.minor === 5;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Synwork.prototype, "isAngular1_7", {
                get: function () {
                    return angular.version.minor === 7;
                },
                enumerable: true,
                configurable: true
            });
            Synwork.prototype.urlParam = function (name) {
                var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
                var r = window.location.search.substr(1).match(reg);
                if (r != null) {
                    return unescape(r[2]);
                }
                return null;
            };
            Synwork.prototype.async = function (fn) {
                var promise = fn();
                promise.finally(function () {
                    framework.syn.ng.timeout();
                });
                return promise;
            };
            Synwork.prototype.bindContext = function (scope) {
                return new framework.service.BindingContext(scope);
            };
            Synwork.prototype.boot = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        document.addEventListener('mousemove', function (event) {
                            _this.mouse.clientX = event.clientX;
                            _this.mouse.clientY = event.clientY;
                            _this.mouse.pageX = event.pageX;
                            _this.mouse.pageY = event.pageY;
                        }, false);
                        this.core.boot();
                        return [2];
                    });
                });
            };
            Synwork.prototype.getLog = function (name) {
                return synwork.log.LogFactory.get(name);
            };
            Synwork.prototype.setLogLevel = function (level) {
                synwork.log.LogFactory.setLevel(level);
            };
            Synwork.prototype.directive = function (name, factory) {
                framework.syn.ng.compileProvider.directive(name, factory);
            };
            return Synwork;
        }());
        framework.Synwork = Synwork;
        var AngularHelper = (function () {
            function AngularHelper(core) {
                this.core = core;
            }
            AngularHelper.prototype.init = function (injector) {
                this.injector = injector;
                this.rootScope = injector.get('$rootScope');
                this.q = injector.get('$q');
                this.http = injector.get('$http');
                this.templateRequest = injector.get("$templateRequest");
                this.compile = injector.get("$compile");
                this.templateCache = injector.get("$templateCache");
                this.timeout = injector.get("$timeout");
                this.filter = injector.get("$filter");
                this.parse = injector.get("$parse");
                this.interpolate = injector.get("$interpolate");
                this.interval = injector.get("$interval");
                this.location = injector.get("$location");
                this.injector.get('$animate').enabled(false);
                this.hookUpload();
                framework.syn.msgbox.init();
                framework.syn.actionsheet.init();
                framework.syn.dlg.init();
            };
            AngularHelper.prototype.hookUpload = function () {
                var upload = this.injector.get('Upload');
                var uploadFn = upload.upload;
                upload.upload = function (config, internal) {
                    if (config.url == "/web/_file/upload") {
                        config.url = framework.syn.app.uploadUrl();
                    }
                    else if (config.url == "/web/_file/imageUpload") {
                        config.url = framework.syn.app.imageUploadUrl();
                    }
                    return uploadFn(config, internal);
                };
            };
            return AngularHelper;
        }());
        framework.AngularHelper = AngularHelper;
        framework.syn = new synwork.framework.Synwork();
        framework.syn.boot();
    })(framework = synwork.framework || (synwork.framework = {}));
})(synwork || (synwork = {}));
